// Auto-generated from fr.json - DO NOT EDIT DIRECTLY
// Edit src/assets/i18n/fr.json instead, then run: npm run i18n:sync
// Or let the build watch mode auto-sync on changes.

import type { Translation } from '../i18n-types';

const fr = {
	meals: {
		breakfast: 'Petit-déjeuner',
		lunch: 'Déjeuner',
		dinner: 'Dîner',
		supper: 'Souper',
		snack: 'Collation',
		snackNumbered: 'Collation {number}',
	},
	editWeighIn: {
		title: 'Enregistrer le poids',
		skinfolds: {
			suprailiac: 'Supra-iliaque',
			umbilical: 'Ombilical',
			thigh: 'Cuisse',
			chest: 'Pectoral',
			tricep: 'Triceps',
		},
		validation: {
			weight: 'Veuillez indiquer votre poids actuel.',
			skinfolds: 'Mesurez vos plis cutanés 3 à 5 fois à chaque site et nous calculerons la moyenne.',
		},
		labels: {
			bodyWeight: 'Poids corporel',
			bodyFat: 'Masse grasse',
			skinfolds: 'Plis cutanés',
			waist: 'Tour de taille',
		},
		notes: {
			bodyFatTracking: 'Activez la ou les méthodes que vous souhaitez utiliser pour suivre votre masse grasse.',
			logWeightInstructions: 'Enregistrez votre poids chaque matin avant le petit-déjeuner et après être passé aux toilettes.',
			measureSkinfolds: 'Mesurez vos plis cutanés 3 à 5 fois à chaque site, et nous calculerons votre moyenne.',
			measureWaist: 'Mesurez votre tour de taille avant le petit-déjeuner et après être passé aux toilettes. Expirez à fond, contractez vos abdominaux et enroulez le mètre à plat autour de votre nombril avec une tension constante. Pour de meilleurs résultats, utilisez un mètre à tension automatique comme le AccuFitness MyoTape.',
		},
		buttons: {
			save: 'Enregistrer',
		},
		warnings: {
			weightNotMeasured: 'Cela fait {days} jours depuis votre dernière pesée. Essayez de prendre l\'habitude de vous peser chaque jour pour améliorer votre régularité et votre suivi.',
			weightNotMeasuredWeeks: 'Cela fait {weeks} semaines depuis votre dernière pesée. Essayez de prendre l\'habitude de vous peser chaque jour pour améliorer votre régularité et votre suivi.',
			weightNotMeasuredLongTime: 'Essayez de prendre l\'habitude de vous peser chaque jour pour améliorer votre régularité et votre suivi.',
			bodyFatNotMeasured: 'Cela fait {days} jours depuis que vous avez mesuré vos plis cutanés ou votre tour de taille. Pour de meilleurs résultats, mesurez-les tous les {frequency} jours.',
			bodyFatNotMeasuredWeeks: 'Cela fait {weeks} semaines depuis que vous avez mesuré vos plis cutanés ou votre tour de taille. Pour de meilleurs résultats, mesurez-les tous les {frequency} jours.',
			bodyFatNotMeasuredLongTime: 'Cela fait un moment que vous n\'avez pas mesuré vos plis cutanés ou votre tour de taille. Pour de meilleurs résultats, mesurez-les tous les {frequency} jours.',
		},
		info: {
			futureWeighIn: 'Vous ne pouvez pas saisir de poids pour des dates futures.',
			neverMeasuredBodyFat: 'Vous devriez mesurer votre composition corporelle tous les {frequency} jours. Choisissez les méthodes que vous souhaitez utiliser. Les pinces sont plus précises, mais les mètres rubans sont plus faciles à utiliser.',
			bodyFatNeededForProgressCheck: 'Votre suivi de progression a besoin de quelques mesures supplémentaires des plis cutanés ou du tour de taille pour évaluer votre tendance. Mesurer aujourd\'hui aide.',
			bodyFatCooldownTomorrow: 'Vous pourrez refaire votre mesure des plis cutanés ou du tour de taille demain.',
			bodyFatCooldownDays: 'Vous pourrez refaire votre mesure des plis cutanés ou du tour de taille dans {days} jours, le {date}.',
		},
		links: {
			howToMeasureSkinfolds: 'Comment mesurer les plis cutanés ?',
		},
	},
	weeklyCheckup: {
		dailyAvgWithDelta: '{avg} kcal ({sign}{diff})',
		loading: {
			processingData: 'Traitement des données. Veuillez patienter...',
			finishingCheckup: 'Finalisation du bilan hebdomadaire, veuillez patienter...',
		},
		errors: {
			couldNotProcess: 'Nous n\'avons pas pu mettre à jour votre programme pour le moment. Veuillez réessayer, ou contactez le support si le problème persiste.',
			progressCheckFailed: 'Nous n\'avons pas pu évaluer vos progrès pour le moment, donc nous ne pouvons pas lancer votre bilan. Veuillez réessayer plus tard, ou contactez le support si le problème persiste.',
		},
		bodyfatEstimation: {
			timeForEstimate: 'Cela fait un moment que nous n\'avons pas estimé votre pourcentage de masse grasse, alors faisons-le maintenant.',
			bestEstimate: 'Quelle est la meilleure estimation de votre pourcentage de masse grasse que vous pouvez obtenir (une seule suffit) ?',
			skipOk: 'Vous pouvez passer cette étape : nous continuerons alors à utiliser la dernière estimation.',
		},
		nutritionLogging: {
			nextSection: 'Ensuite, nous examinerons votre apport calorique de la semaine passée pour mettre à jour votre programme pour la semaine à venir.',
			deselectIncomplete: 'Désélectionnez les jours qui semblent incomplets ou partiellement enregistrés et nous les exclurons de nos calculs.',
		},
		calorieBaseline: {
			beforeAdjust: 'Avant d\'ajuster votre apport calorique pour la semaine prochaine, nous devons obtenir une idée précise de votre apport énergétique actuel.',
			whichOption: 'Laquelle de ces options reflète le mieux votre apport calorique moyen de la semaine passée ?',
			logged: 'Enregistré',
			loggedNote: 'Il s\'agit de la moyenne des calories enregistrées par jour au cours de la semaine passée, en excluant les jours que vous avez marqués comme incomplets.',
			target: 'Cible',
			targetNote: 'Il s\'agit de votre apport calorique cible moyen recommandé par jour au cours de la semaine passée.',
			custom: 'Personnalisé',
			customNote: 'Si vous avez consommé un nombre de calories différent des options ci-dessus, veuillez le saisir ici.',
		},
		programUpdate: {
			basedOnProgress: 'D\'après vos données de progression, nous recommandons les mises à jour suivantes de votre programme :',
			progressOnTrack: 'Votre progression est sur la bonne voie ! Aucun ajustement n\'est nécessaire pour le moment.',
			notEnoughData: 'Il n\'y a pas encore assez de données de progression. Aucun changement n\'est recommandé pour le moment. Continuez à enregistrer vos pesées et vos mesures corporelles pour que nous puissions suivre votre progression.',
			notEnoughDataCompleted: 'Il n\'y avait pas assez de données de progression au moment de ce bilan. Aucun changement n\'a été recommandé.',
			undeterminedMeasureMoreOften: 'Nous avons besoin de plus de mesures pour évaluer votre progression, donc aucun changement n\'est recommandé cette semaine. Continuez à enregistrer votre poids chaque jour et ajoutez des mesures des plis cutanés ou du tour de taille quand l\'écran de pesée vous les demande.',
			undeterminedBodyFatTrendUnclear: 'La tendance de votre masse grasse n\'est pas encore claire, donc aucun changement n\'est recommandé cette semaine. Ajoutez quelques mesures supplémentaires des plis cutanés ou du tour de taille dans les prochains jours. L\'écran de pesée vous les demandera.',
			undeterminedDataErratic: 'Vos mesures fluctuent beaucoup, donc aucune tendance claire ne se dégage et aucun changement n\'est recommandé cette semaine. Essayez de mesurer à chaque fois dans les mêmes conditions.',
			undeterminedWeightTooFlat: 'Vos derniers relevés de poids étaient exactement identiques, donc aucun changement n\'est recommandé cette semaine. Veuillez vérifier que votre balance fonctionne correctement.',
			atMinimum: 'Vos progrès indiquent qu\'il faudrait manger un peu moins, mais votre objectif de calories quotidien est déjà au plus bas que l\'app fixe pour votre poids corporel. Il ne peut pas descendre davantage, donc rien n\'est modifié.',
			atMinimumCompleted: 'Vos progrès indiquaient qu\'il fallait manger moins, mais votre objectif de calories quotidien était déjà au plus bas que l\'app fixe pour votre poids corporel, donc rien n\'a été modifié.',
			lowestTarget: 'C\'est l\'objectif de calories quotidien le plus bas que l\'app fixe pour votre poids corporel.',
			changeTooSmall: 'D\'après vos données de progression, votre objectif de calories quotidien changerait à peine. La différence est trop faible pour compter, donc rien n\'est modifié.',
			changeTooSmallCompleted: 'Le changement de calories recommandé était trop faible pour compter, donc rien n\'a été modifié.',
		},
		bfMethods: {
			calipers: 'Pinces',
			tape: 'Mètre ruban',
			visual: 'Visuel',
			unknown: 'Méthode inconnue',
		},
		headers: {
			bodyfatEstimation: 'Estimation de la masse grasse',
			programUpdate: 'Mise à jour du programme',
			checkupStatus: 'État du bilan',
		},
		descriptions: {
			intro: 'Pour que votre programme reste optimal et à jour, nous allons maintenant examiner votre progression de la semaine passée et faire des mises à jour si nécessaire.',
			futureCheckup: 'Ce bilan hebdomadaire est prévu pour une date future. Veuillez attendre la date prévue pour commencer le bilan.',
			outdatedCheckup: 'Ce bilan est périmé et ne peut plus être complété. Veuillez plutôt compléter le bilan de la semaine en cours.',
			weightTrendingWell: 'Votre poids et vos mesures corporelles évoluent dans la bonne direction, à un bon rythme. Continuez ainsi, bon travail !',
			weightNotEnoughData: 'Nous n\'avons pas assez de données pour déterminer si votre poids et vos mesures corporelles évoluent dans la bonne direction. Merci d\'enregistrer davantage de pesées et de mesures corporelles.',
			noWorkoutsLoggedLastWeek: 'La semaine dernière, vous n\'avez enregistré aucune séance.',
			workoutProgressionSummary: 'La semaine dernière, vous avez progressé dans des exercices {progressions} {{fois|fois}} et régressé {regressions} {{fois|fois}}.',
		},
		charts: {
			weightTrend: 'Tendance du poids',
			skinfoldTrend: 'Tendance des plis cutanés',
			waistTrend: 'Tendance du tour de taille',
			exerciseProgressions: 'Progression des exercices',
		},
		tooltips: {
			weightTrend: 'Mesures quotidiennes du poids avec leur ligne de tendance estimée sur les 7 derniers jours.',
			skinfoldTrend: 'Mesures quotidiennes des plis cutanés avec leur ligne de tendance estimée sur les 7 derniers jours.',
			waistTrend: 'Mesures quotidiennes du tour de taille avec leur ligne de tendance estimée sur les 7 derniers jours.',
			exerciseProgressions: 'Nombre d\'exercices ayant progressé par séance sur les 7 derniers jours.',
		},
		labels: {
			estimationMethod: 'Méthode d\'estimation :',
			estimatedBodyfat: 'Masse grasse estimée :',
			completionStatus: 'État d\'achèvement :',
		},
		buttons: {
			start: 'Commencer',
			decline: 'Refuser',
			accept: 'Accepter',
		},
		ownTarget: {
			nothingToChange: 'C\'est l\'objectif que l\'application recommande, il n\'y a donc rien à changer.',
			completedOwn: 'Vous avez fixé votre propre objectif. L\'application recommandait {kcal} kcal.',
			completedCoach: 'Votre coach a fixé cet objectif. L\'application recommandait {kcal} kcal.',
		},
		step: 'Étape {current} sur {total}',
		steps: {
			intro: 'Bilan hebdomadaire',
			progressReview: 'Bilan de progression',
			bodyfatEstimation: 'Estimation de la masse grasse',
			nutritionLogging: 'Suivi nutritionnel',
			calorieBaseline: 'Référence calorique',
			programUpdate: 'Mise à jour du programme',
		},
		completionActions: {
			accepted: 'Ajustements acceptés',
			declined: 'Ajustements refusés',
			finished: 'Terminé',
		},
		validation: {
			selectOption: 'Veuillez choisir une des options.',
			customCalorieIntake: 'Veuillez saisir un apport calorique personnalisé.',
			unknownField: 'Champ inconnu',
		},
		finalChoice: {
			acceptApp: 'Accepter le nouvel objectif',
			acceptAppHelp: 'La recommandation de l\'application, calculée à partir de vos progrès.',
			keepAppTarget: 'Garder l\'objectif de l\'application',
			keepAppTargetHelp: 'Vous êtes sur la bonne voie, votre objectif reste donc tel quel.',
			setOwn: 'Définir mon propre objectif',
			setOwnHelp: 'Choisissez vous-même un nombre, en kcal ou en variation en pourcentage.',
			keepCurrent: 'Garder mon objectif actuel',
			keepCurrentHelp: 'Rien ne change dans votre plan cette semaine.',
		},
	},
	nutrientList: {
		logged: 'Enregistré',
		targets: 'Cibles',
		nutrients: 'Nutriments',
		food: 'Item',
		meal: 'Repas',
		day: 'Jour',
		total: 'Total',
		left: 'Restant',
		protein: 'Protéines',
		carbs: 'Glucides',
		fat: 'Lipides',
		fiber: 'Fibres',
		cholesterol: 'Cholestérol',
		short: {
			protein: 'Pro',
			carbs: 'Glu',
			fat: 'Lip',
			fiber: 'Fib',
		},
		oneLetter: {
			protein: 'P',
			carbs: 'G',
			fat: 'L',
			fiber: 'F',
		},
	},
	common: {
		reconnecting: 'Reconnexion...',
		offlineBadge: 'Hors ligne',
		options: {
			yes: 'Oui',
			no: 'Non',
		},
		ui: {
			recommended: 'Recommandé',
			default: 'Par défaut',
		},
		states: {
			skipped: 'Ignoré',
		},
		messages: {
			backOnline: 'Vous êtes de nouveau en ligne.',
			imageQueuedOffline: 'Photo enregistrée sur cet appareil. Elle sera téléversée automatiquement dès que vous serez de nouveau en ligne.',
			scanAppCapacityReached: 'L\'application a atteint sa limite de scans pour aujourd\'hui. Veuillez réessayer demain.',
		},
		toast: {
			dontShowAgain: 'Ne plus afficher',
		},
		words: {
			or: 'ou',
			and: 'et',
		},
		measureNames: {
			portion: 'portion',
			piece: 'pièce',
			slice: 'tranche',
			whole: 'entier',
			prepared: 'portion',
			large: 'grand',
			medium: 'moyen',
			small: 'petit',
			can: 'boîte',
			bottle: 'bouteille',
			quart: 'quart',
			pint: 'pinte',
			cup: 'tasse',
			tbsp: 'c. à s.',
			tablespoon: 'cuillère à soupe',
			tsp: 'c. à c.',
			teaspoon: 'cuillère à café',
		},
		measureUnits: {
			descriptions: {
				none: 'aucune',
				genericNumber: 'Nombre générique',
				repetitions: 'Répétitions',
				sets: 'Séries',
				pairs: 'Paires',
				plates: 'Disques',
				percent: 'Pourcentage',
				millimeters: 'millimètres',
				centimeters: 'centimètres',
				feetAndInches: 'pieds et pouces',
				inches: 'pouces',
				kilograms: 'kilogrammes',
				pounds: 'livres',
				micrograms: 'microgrammes',
				milligrams: 'milligrammes',
				grams: 'grammes',
				ounces: 'onces',
				stonesAndPounds: 'stones et livres',
				kilocalories: 'kilocalories',
				kilojoules: 'kilojoules',
				internationalUnits: 'unités internationales',
				milliliters: 'millilitres',
				fluidOunces: 'onces liquides',
				quarts: 'quarts',
				pints: 'pintes',
				cups: 'tasses',
				tablespoons: 'cuillères à soupe',
				teaspoons: 'cuillères à café',
			},
		},
		pickerTitles: {
			servingSize: 'Taille de la portion',
			selectUnit: 'Sélectionner une unité',
			timeFormat: 'Format de l\'heure',
		},
		scanModels: {
			allModels: 'Tous les modèles',
			costEstimate: '{displayName} (~${cost}/1k)',
		},
		errors: {
			unknownField: 'Champ inconnu',
			generic: 'Une erreur s\'est produite. Veuillez réessayer.',
			tooManyAttempts: 'Trop de tentatives. Veuillez patienter un moment, puis réessayer.',
		},
		offTrack: {
			tooMuchWeightLoss: {
				cutting: {
					summary: 'Votre poids baisse plus vite que prévu.',
					action: 'Nous devons ajuster votre plan nutritionnel pour préserver le muscle tout en perdant de la graisse.',
				},
				bulking: {
					summary: 'Vous perdez du poids alors que vous devriez en prendre.',
					action: 'Nous devons ajuster votre plan nutritionnel pour soutenir la croissance musculaire.',
				},
			},
			tooMuchFatGain: {
				cutting: {
					summary: 'Vous gagnez de la masse grasse alors que vous devriez en perdre.',
					action: 'Nous devons ajuster votre plan nutritionnel pour remettre votre perte de graisse sur la bonne voie.',
				},
				bulking: {
					summary: 'Vos mesures de masse grasse augmentent plus vite que prévu.',
					action: 'Nous devons ajuster votre plan nutritionnel pour éviter une prise de graisse excessive.',
				},
			},
			notEnoughFatLoss: {
				cutting: {
					summary: 'Vos mesures de masse grasse ne diminuent pas comme prévu.',
					action: 'Nous devons ajuster votre plan nutritionnel pour vous aider à perdre de la graisse.',
				},
			},
			notEnoughWeightGain: {
				bulking: {
					summary: 'Votre poids n\'augmente pas comme prévu.',
					action: 'Nous devons ajuster votre plan nutritionnel pour vous aider à gagner de la masse maigre.',
				},
			},
			generic: {
				summary: 'Vous avez manqué certaines séances ou objectifs de volume. Restez régulier pour continuer à progresser.',
			},
		},
		buttons: {
			save: 'Enregistrer',
			select: 'Sélectionner',
			cancel: 'Annuler',
			delete: 'Supprimer',
			ok: 'OK',
			today: 'Aujourd\'hui',
			yes: 'Oui',
			accept: 'Accepter',
			no: 'Non',
			back: 'Retour',
			next: 'Suivant',
			edit: 'Modifier',
			remove: 'Retirer',
			report: 'Signaler',
			dismiss: 'Ignorer',
			ignore: 'Ignorer',
			learnMore: 'En savoir plus',
			discard: 'Abandonner',
			optimize: 'Optimiser',
			saveAsNew: 'Enregistrer comme nouveau',
			split: 'Diviser',
			addPlates: 'Ajouter des disques',
			cleanUp: 'Nettoyer',
			finish: 'Terminer',
			skip: 'Passer',
			restoreTask: 'Restaurer la tâche',
			autoTune: 'Réglage auto',
			uncacheFoods: 'Vider le cache des aliments',
			testSurvey: 'Tester le sondage',
			apply: 'Appliquer',
			log: 'Enregistrer',
			undo: 'Annuler',
			keep: 'Conserver',
			saving: 'Enregistrement...',
			tryAgain: 'Réessayer',
			continue: 'Continuer',
			confirm: 'Confirmer',
		},
		weekdays: {
			monday: 'Lundi',
			tuesday: 'Mardi',
			wednesday: 'Mercredi',
			thursday: 'Jeudi',
			friday: 'Vendredi',
			saturday: 'Samedi',
			sunday: 'Dimanche',
		},
		weekdayInitials: {
			monday: 'L',
			tuesday: 'M',
			wednesday: 'M',
			thursday: 'J',
			friday: 'V',
			saturday: 'S',
			sunday: 'D',
		},
		placeholders: {
			enterFoodName: 'Saisissez le nom de l\'aliment',
			selectMeasure: 'Sélectionnez une mesure...',
			day: 'JJ',
			month: 'MM',
			year: 'AAAA',
			reps: 'Répétitions',
			enterText: 'Saisissez du texte',
			select: 'Sélectionner...',
			selectAnOption: 'Sélectionnez une option',
		},
		measurements: {
			weight: 'Poids',
			waist: 'Tour de taille',
			skinfold: 'Pli cutané',
			skinfolds: 'Plis cutanés',
		},
		labelStyles: {
			us: 'US',
			eu: 'EU',
		},
		programTypes: {
			intensified: 'Intensifié',
			dup: 'DUP',
			tup: 'TUP',
		},
		loading: {
			pleaseWait: 'Veuillez patienter...',
			sendingReport: 'Envoi du rapport...',
			registeringPayment: 'Enregistrement du paiement...',
			signingIn: 'Connexion...',
			loggingInWithGoogle: 'Connexion avec Google...',
			loggingInWithFacebook: 'Connexion avec Facebook...',
			loggingInWithApple: 'Connexion avec Apple...',
		},
		relativeDay: {
			today: 'aujourd\'hui',
			yesterday: 'hier',
			tomorrow: 'demain',
		},
	},
	navigation: {
		home: 'Accueil',
		nutrition: 'Nutrition',
		settings: 'Réglages',
		training: 'Entraînement',
	},
	workouts: {
		restTimer: {
			title: 'Minuteur de repos',
			defaultLabel: 'Repos par défaut',
			exerciseOverrideTitle: 'Remplacement du minuteur de repos',
			adjustMinus: '-15 s',
			adjustPlus: '+15 s',
			skip: 'Passer',
			done: 'Terminé !',
			rollerLabel: 'REPOS',
			notificationBody: 'Repos terminé',
			autoStartLabel: 'Démarrer automatiquement',
			infoNative: 'Le minuteur de repos décompte le temps entre les séries d\'un même exercice et ne fonctionne que dans l\'application mobile installée (iOS ou Android). Si « Démarrer automatiquement » est activé, il démarre dès que vous enregistrez une série. Sinon, lancez-le avec le bouton « Démarrer le minuteur de repos » sous la première série. Les réglages sont disponibles sur tous les appareils.',
			infoOverride: 'S\'applique uniquement dans l\'application mobile installée (iOS ou Android).',
		},
		detail: {
			weightExplanations: {
				addedWeightExplanation: 'Il s\'agit du poids <i>ajouté</i> total, <i>sans</i> votre propre poids de corps.',
				totalWeightExplanation: 'Il s\'agit du poids <i>total</i> (barre comprise).',
			},
			buttons: {
				yesAgree: 'Oui, je suis d\'accord.',
				noKeepIntensity: 'Non, je garde cette intensité pour l\'instant.',
				noKeepExercise: 'Non, je garde cet exercice pour l\'instant.',
				noKeepProgram: 'Non, je garde ce programme pour l\'instant.',
				decideLater: 'Je déciderai plus tard.',
			},
			resolve: 'Résoudre',
			workoutComplete: 'Beau travail ! Vous avez terminé votre séance.',
			workoutCompleteFirstTest: 'Séance de test terminée ! La prochaine séance va autoréguler vos répétitions cibles.',
			workoutCompleteSecondTest: 'Poids de départ et répétitions cibles définis ! Prochaine séance : surcharge progressive.',
			plan: 'Programme',
			skipped: 'Passé',
			setOrdinal: 'Série {number}',
			setInstructionsToggle: 'Instructions de la série',
			collapseSet: 'Réduire la série',
			repsLabel: 'Répétitions',
			bwHelpText: 'Saisissez uniquement le poids ajouté. Saisissez 0 si vous avez utilisé le poids de corps (sans poids ajouté).',
			myoReps: 'Myo-reps',
			lastWorkout: 'Dernière séance',
			lastWorkoutSameIntensity: 'Affichage de la dernière séance au même niveau d\'intensité.',
			selectEquipmentHere: 'Sélectionnez l\'équipement ici.',
			equipmentWarning: {
				title: 'Améliorez votre équipement',
				messagePart1: 'L\'équipement sélectionné ne permet pas le poids que vous avez choisi ({error}). ',
				messageLink: 'Mettez à jour votre équipement',
				messagePart2: ' pour garantir des suggestions de progression précises.',
				mobileMessage: 'L\'équipement sélectionné ne permet pas le poids que vous avez choisi ({error}). Mettez à jour votre équipement pour garantir des suggestions de progression précises.',
				button: 'Mettre à jour l\'équipement',
			},
			equipmentFloor: {
				hintEmptyBar: 'Barre à vide · votre objectif est {target}',
				hintLightestFixed: 'Votre poids le plus léger · votre objectif est {target}',
				hintLightestStackPlate: 'Plaque la plus légère de cette machine · votre objectif est {target}',
				hintLightestSetting: 'Réglage le plus léger · votre objectif est {target}',
				title: 'Pourquoi {floor} ?',
				bodyEmptyBar: 'Le poids cible de votre programme pour cet exercice est {target}. Sur une barre, le poids que vous saisissez est le total, barre comprise. Une barre à vide pèse déjà {floor} : c\'est le plus léger que permet cet équipement. Vous visiez {target} ? Choisissez un équipement plus léger. Vous vous entraînez à {floor} volontairement ? Aucun problème. Votre prochain objectif sera calculé à partir de ce que vous enregistrez ici.',
				bodyOther: 'Le poids cible de votre programme pour cet exercice est {target}. Cet équipement ne descend pas en dessous de {floor}. Vous visiez {target} ? Choisissez un équipement plus léger. Vous vous entraînez à {floor} volontairement ? Aucun problème. Votre prochain objectif sera calculé à partir de ce que vous enregistrez ici.',
				lighterEmptyBar: 'Barre à vide · impossible d\'alléger',
				lighterLightestFixed: 'Votre poids le plus léger · impossible d\'alléger',
				lighterLightestStackPlate: 'Plaque la plus légère de cette machine · impossible d\'alléger',
				lighterLightestSetting: 'Réglage le plus léger · impossible d\'alléger',
				lighterBodyEmptyBar: 'Cette série devrait être plus légère : environ {wanted}. Sur une barre, le poids que vous saisissez est le total, barre comprise. Une barre à vide pèse déjà {floor} : c\'est le plus léger que permet cet équipement. Vous voulez plus léger ? Choisissez un équipement plus léger, puis saisissez environ {wanted}. Vous restez sur la barre ? Faites les répétitions à {floor}.',
				lighterBodyOther: 'Cette série devrait être plus légère : environ {wanted}. Cet équipement ne descend pas en dessous de {floor}. Vous voulez plus léger ? Choisissez un équipement plus léger, puis saisissez environ {wanted}. Vous gardez cet équipement ? Faites les répétitions à {floor}.',
				button: 'Changer l\'équipement',
			},
			badges: {
				myoReps: 'Myo-reps',
				strengthTest: 'Test de force',
				repTest: 'Test de répétitions',
				myoRepsInfo: 'Méthode qui fait gagner du temps, avec une série d\'activation et des mini-séries entrecoupées de courts repos.',
				strengthTestInfo: 'Trouvez le poids maximal que vous ne pouvez soulever que pour 1 à 5 répétitions. Continuez d\'ajouter du poids intuitivement jusqu\'à ne pouvoir faire que 1 à 5 répétitions.',
				repTestInfo: 'Faites autant de répétitions que possible avec le poids prescrit. Ce nombre deviendra votre objectif de répétitions. Cette méthode autorégule votre volume d\'entraînement pour chaque groupe musculaire individuellement, en fonction de la composition de ses fibres musculaires, de sa densité capillaire et d\'autres facteurs qui le rendent plus fort dans certaines plages de répétitions.',
				tempSwap: 'Temporaire',
				tempSwapInfo: 'Cet exercice est un remplacement temporaire pour cette séance uniquement. Votre programme d\'entraînement n\'est pas affecté.',
				bodyweight: 'Poids de corps',
				bodyweightInfo: 'Cet exercice utilise votre poids de corps comme partie de la charge.',
			},
			superset: 'Série combinée',
			units: {
				lb: 'Lb',
				kg: 'Kg',
			},
			firstWorkoutTestExplainer: 'Séance de test pour personnaliser votre programme',
			pendingWorkoutWarning: 'Vous avez une séance non terminée du',
			pendingWorkoutExplanation: 'Vous pouvez revenir la terminer ou démarrer cette séance, ce qui la terminera automatiquement.',
			workoutChangedInfo: 'Toute modification de cette séance sera enregistrée une fois que vous aurez complété au moins une série.',
			coachChanged: {
				title: 'Votre coach a modifié cet exercice.',
				detail: '{date}, {name} : {summary}',
			},
			skipRemaining: 'Passer le reste',
			skipRemainingConfirm: 'Voulez-vous vraiment passer toutes les séries et exercices restants ?',
			lastAttempt: 'Dernière tentative, il y a {days} jours :',
			equipment: {
				stack: 'Colonne : ',
				fixed: 'Fixe : ',
				bar: 'Barre : ',
				platesEachSide: 'Disques (de chaque côté)',
				micro: 'Micro',
				plates: 'Disques',
				notConfigured: '(non configuré)',
				automatic: 'Automatique',
				inferredStep: 'incrément estimé : ~{step}',
				copiedFromOtherUnit: 'Nous utilisons {name} pour cet exercice. C\'est la même machine, affichée dans l\'unité que vous avez choisie.',
				chooseDifferentEquipment: 'Choisir l\'Équipement',
				chooseEquipmentLabel: 'Choisir l\'équipement',
			},
			setInstructions: {
				nonRMTestRetry: 'Reposez-vous quelques minutes. Consultez les [instructions](@help:workout.strength-test-failed) et réessayez.',
				nonRMTest: 'Trouvez le poids maximal que vous pouvez soulever pour le nombre de répétitions suggéré. [En savoir plus](@help:workout.strength-test)',
				rmTestRetry: 'Reposez-vous quelques minutes. Consultez les [instructions](@help:workout.RM-strength-test-failed) et réessayez.',
				rmTest: 'Trouvez votre 1-5RM. [En savoir plus](@help:workout.RM-strength-test)',
				rmTestFollow: 'Faites autant de répétitions que possible avec une bonne technique. [En savoir plus](@help:workout.RM-test_follow)',
				repTest: 'Trouvez votre objectif de répétitions pour cet exercice. [En savoir plus](@help:workout.rep-test)',
				regular: 'Faites autant de répétitions que possible avec le poids prescrit.',
				followup: 'Faites autant de répétitions que possible avec une bonne technique.',
				dropset: 'Faites autant de répétitions que possible avec une bonne technique. [En savoir plus](@help:workout.dropset)',
				dropsetEccentric: 'Si c\'est possible, essayez de ne faire que la phase excentrique (le mouvement de descente) de l\'exercice, sans charge ajoutée, pour autant de répétitions que vous pouvez contrôler. [En savoir plus](@help:workout.dropset)',
				dropsetReduce: 'Réduisez le poids comme indiqué. Faites autant de répétitions que possible avec une bonne technique. [En savoir plus](@help:workout.dropset)',
				deload: 'Faites seulement 3 à 5 répétitions **explosives** avec la charge réduite. [En savoir plus](@help:workout.deload)',
				deloadAtFloor: 'Faites seulement 3 à 5 répétitions **explosives** avec ce poids. [En savoir plus](@help:workout.deload)',
			},
			setProgress: {
				lastSession: 'Dernière séance',
				lastMarker: 'dernière · {reps}',
				repsRangePlaceholder: '{min}–{max}',
				progressedTitle: 'Vous avez progressé !',
				targetHitTitle: 'Répétitions cibles atteintes !',
				setLoggedTitle: 'Série enregistrée',
				repsAtWeight: '{reps} {{répétition|répétitions}} à {weight}',
				overLastTime: '+{count} de plus que la dernière fois',
				nextSessionAimFor: 'Prochaine séance : visez {reps}+.',
				lastTimeYouDid: 'La dernière fois, vous avez fait {reps}.',
				lastTimeLabel: 'Dernière fois',
				todayLabel: 'Aujourd\'hui',
				startRestTimer: 'Démarrer le minuteur de repos · {duration}',
				outcomeTargetHit: 'Objectif atteint',
				lastShort: 'Précédent : {value}',
				targetLabel: 'Objectif',
				overLastTimeShort: '+{count} {{répétition|répétitions}} (vs dernière fois)',
				editSet: 'Modifier la série',
				restTimer: 'Minuteur de repos · {duration}',
				outcomeSame: 'Comme la dernière fois',
				outcomeFewer: 'Moins de répétitions',
				loggedAtLabel: 'Enregistré à',
				nextSessionLabel: 'Prochaine séance',
				repsOrMore: '{reps}+',
				targetRangeReps: '{floor}–{target} répétitions',
				targetReps: '{target} {{répétition|répétitions}}',
			},
			summary: {
				title: 'Séance terminée',
				setsCount: '{count} {{série|séries}}',
				minutes: '{minutes} min',
				hoursMinutes: '{hours} h {minutes} min',
				recordsPart: '{count} {{record personnel|records personnels}}',
				progressedPart: '{count} {{exercice en progrès|exercices en progrès}}',
				and: 'et',
				personalRecord: 'Record personnel',
			},
			finishedExercise: {
				moreRepsVsLastTime: '+{count} {{répétition|répétitions}} vs dernière fois',
				fewerRepsVsLastTime: '−{count} {{répétition|répétitions}} vs dernière fois',
				sameAsLastTime: 'Comme la dernière fois',
				lastWorkoutLine: 'Dernière séance : {sets}',
				nextTargetLine: 'Prochain objectif : visez {reps}+ rép. à la série 1',
			},
			exerciseHeader: {
				set: 'série',
				sets: 'séries',
				skipped: 'passé',
				highRep: 'répétitions élevées ; ',
				heavy: 'lourd ; ',
				medium: 'moyen ; ',
			},
		},
		buttons: {
			description: 'Description',
			instructions: 'Instructions',
			history: 'Historique',
			stats: 'Statistiques',
			settings: 'Réglages',
			skipToday: 'Passer aujourd\'hui',
			changeExercise: 'Changer d\'exercice',
			resetProgress: 'Réinitialiser la progression',
			logSet: 'Enregistrer la série',
			completeSet: 'Terminer la série',
			saveSet: 'Enregistrer la série',
			logShort: 'Valider',
			saveShort: 'Enregistrer',
			nextDay: 'Jour suivant',
			close: 'Fermer',
			yesAgree: 'Oui, je suis d\'accord',
			noDisagree: 'Non, je ne suis pas d\'accord',
			yesCorrect: 'Oui, c\'est correct',
			oopsLetMeChange: 'Oups, je corrige ça.',
			addNote: 'Ajouter une note',
			setNote: 'Note de série',
		},
		alerts: {
			youChangedWeight: 'Vous avez changé le poids ?',
			weightEstimateWrong: 'Notre application estime la charge idéale pour chacune de vos séries de travail. Pourquoi pensez-vous que nous nous sommes trompés ?',
			agreeWithDeload: 'Êtes-vous d\'accord avec un délestage réactif ?',
			agreeWithUpgrade: 'Êtes-vous d\'accord avec une amélioration du programme d\'entraînement ?',
			skipExercise: 'Passer l\'exercice...',
			skipRemainingSets: 'Voulez-vous passer le reste des séries de cet exercice dans cette séance ?',
			skipThisExercise: 'Voulez-vous passer cet exercice dans cette séance ?',
			isThisCorrect: 'Est-ce correct ?',
			notesForSet: 'Notes pour cette série',
			notesForPreviousWorkouts: 'Les notes des séances précédentes se trouvent sous Plus > Statistiques et notes.',
			switchType: 'Changer d\'exercice',
			switchTypeMessage: 'Souhaitez-vous remplacer cet exercice de façon permanente dans votre programme, ou seulement pour cette séance ?',
			thisSessionOnly: 'Cette séance uniquement',
			permanently: 'De façon permanente',
			resetProgress: 'Réinitialiser la progression',
			resetProgressConfirm: 'Voulez-vous vraiment réinitialiser le cycle actuel pour cet exercice ? Nous devrons tester votre force sur cet exercice. Vos précédents records seront conservés dans la section « Progression ».',
			switchExerciseResetWarning: 'Les séries que vous avez complétées restent avec cet exercice, et le nouvel exercice commence à la série 1. Voulez-vous continuer ?',
			exercisesSkipped: 'Certains exercices ont été passés à cause d\'un dysfonctionnement de l\'application.\n({exercises})',
			weightTooHeavy: 'Le poids que vous me recommandez est bien trop lourd.',
			weightTooLight: 'Le poids que vous me recommandez est bien trop léger.',
			closestWeight: 'Le poids que j\'ai choisi est le plus proche possible de celui que vous m\'indiquez d\'utiliser.',
			recommendDeload: 'Délestage réactif recommandé pour cet exercice. Vous ne semblez pas encore récupéré.',
			plateau: {
				exerciseChanged: 'Nous avons remplacé {name} par cet exercice.',
				exerciseWillChange: 'Cet exercice sera changé lors de la prochaine séance.',
				intensityChangeTitle: 'Êtes-vous d\'accord avec un changement d\'intensité pour {name} ?',
				intensityChangeMessage: 'Nous pensons que vous avez atteint un plateau avec l\'intensité actuelle de l\'exercice. C\'est pourquoi nous recommandons de vous retester à une intensité différente pour garantir une progression optimale.',
				exerciseChangeTitle: 'Acceptez-vous de remplacer {name} par un autre exercice ?',
				exerciseChangeMessage: 'Nous recommandons de remplacer cet exercice à ce stade.',
				planUpgradeMessage: 'Félicitations ! Vos progrès récents indiquent que vous êtes prêt à passer à un programme d\'entraînement plus avancé.',
				retestThis: 'Nous redéterminerons votre objectif de répétitions lors de cette séance.',
				retestNext: 'Nous redéterminerons votre objectif de répétitions lors de la prochaine séance.',
				switchToTUPThis: 'L\'exercice passera à la périodisation ondulatoire triple lors de cette séance.',
				switchToTUPNext: 'L\'exercice passera à la périodisation ondulatoire triple lors de la prochaine séance.',
				switchToDUPThis: 'L\'exercice passera à la périodisation ondulatoire double lors de cette séance.',
				switchToDUPNext: 'L\'exercice passera à la périodisation ondulatoire double lors de la prochaine séance.',
				planUpgradeConfirm: 'Nous ferons évoluer votre programme d\'entraînement vers un niveau plus avancé après cette séance.',
			},
			repCeiling: {
				title: 'Vous avez atteint 30 répétitions',
				switchMessage: 'Au-delà de 30 répétitions, on ne construit plus bien de muscle, et le poids suivant de votre équipement est un saut trop important. Passer à un autre exercice dès la prochaine séance ?',
				yes: 'Oui',
				noKeep: 'Non, garder 30 répétitions',
			},
			unusualSet: '{setStatText} pour {exerciseName} semble inhabituel par rapport à vos entrées précédentes.',
			unusualSetRepTest: '{setStatText} pour le test de répétitions de {exerciseName} semble inhabituel par rapport à vos entrées précédentes.',
			viewOnly: {
				futureWorkoutMessage: 'Cette séance est prévue pour une date future. Veuillez effectuer et enregistrer vos séances le jour prévu, idéalement à la salle.',
				previousWorkoutMessage: 'Ceci est une séance précédente. N\'hésitez pas à apporter des corrections.',
				templateMessage: 'Ceci est un modèle de séance issu de votre programme. Vous verrez la séance précise, avec plus de détails, le jour où elle est prévue. N\'hésitez pas à changer des exercices à l\'avance ici si besoin.',
				loggingMessage: 'Vous devriez enregistrer la séance pendant que vous êtes à la salle. Ainsi, nous pourrons vous donner les meilleurs conseils possibles pour chaque série suivante.',
			},
		},
		status: {
			exerciseNotOptimal: 'Cet exercice n\'est pas optimal pour vous en ce moment et sera remplacé lors de la prochaine séance.',
			goodJobProgression: 'Beau travail ! Nous pouvons maintenant guider votre progression à partir d\'ici.',
			strengthLevelCalculated: 'Beau travail ! Niveau de force calculé.',
			strengthCalculatedLighterSets: 'Beau travail ! Niveau de force calculé. Les séries restantes sont plus légères pour évaluer votre force-endurance.',
			tooManyRepsRetry: 'Reposez-vous quelques minutes et utilisez un poids plus lourd pour vous rapprocher des répétitions cibles.',
			tooManyRepsNextWorkout: 'Nous réessaierons lors d\'une prochaine séance avec un poids plus lourd pour vous rapprocher des répétitions cibles.',
			tooFewRepsRetry: 'Reposez-vous quelques minutes et utilisez un poids plus léger pour vous rapprocher des répétitions cibles.',
			tooFewRepsNextWorkout: 'Nous réessaierons lors d\'une prochaine séance avec un poids plus léger pour vous rapprocher des répétitions cibles.',
			repRangeEstablished: 'Excellent ! Nous avons établi votre plage de répétitions cibles.',
			repRangeEstablishedContinue: 'Excellent ! Nous avons établi votre plage de répétitions cibles. Pour les séries suivantes, vous n\'avez pas à l\'atteindre exactement. Faites simplement autant de répétitions que possible.',
			strengthRetestNextTooHeavy: 'Comme vous avez signalé que la charge suggérée est trop lourde pour vous, nous vous laisserons retester votre force la prochaine fois avec une méthode différente. Veuillez consulter les instructions de test. Pour aujourd\'hui, vous pouvez continuer avec le poids que vous avez choisi.',
			strengthRetestNextTooLight: 'Comme vous avez signalé que la charge suggérée est trop légère pour vous, nous vous laisserons retester votre force la prochaine fois avec une méthode différente. Veuillez consulter les instructions de test. Pour aujourd\'hui, vous pouvez continuer avec le poids que vous avez choisi.',
			differentWeightEquipment: 'Comme vous avez choisi un poids différent de celui suggéré, pensez à mettre à jour l\'équipement de cet exercice afin que nous puissions le calculer correctement la prochaine fois.',
			progressionDeload: 'Progression prévue non atteinte. Délestage en cours...',
			progressionDeloadLastSet: 'Progression prévue non atteinte. Votre poids cible baissera d\'un cran à la prochaine séance.',
			repTargetUpdatedRegular: 'Nous avons mis à jour l\'objectif de répétitions de cet exercice en fonction de votre progression actuelle.',
			repTargetUpdatedHighRep: 'Nous avons mis à jour l\'objectif de répétitions de la séance à répétitions élevées de cet exercice en fonction de votre progression actuelle.',
			repTargetUpdatedHeavy: 'Nous avons mis à jour l\'objectif de répétitions de la séance lourde de cet exercice en fonction de votre progression actuelle.',
			lastSetNotNeeded: 'La dernière série n\'est pas nécessaire. Nous la passons.',
			lowerThanRecommended: 'Ce poids est inférieur au poids recommandé de {plannedWeight}. Si vous avez changé de salle ou d\'équipement, vous pouvez mettre à jour l\'équipement pour que nous sachions ce qui est disponible.',
			immediateProgression: 'Vous vous débrouillez très bien ! Augmentons le poids tout de suite et voyons si vous pouvez atteindre les répétitions cibles avec.',
			immediateProgressionReps: 'Vous vous débrouillez très bien ! Augmentons l\'objectif de répétitions et voyons si vous pouvez l\'atteindre avec ce poids.',
			maxedOutEquipment: 'Il semble que nous ne puissions plus augmenter votre poids cible avec cet équipement ; la prochaine fois, nous passerons donc à un autre exercice. Si vous pouvez en réalité ajouter plus de poids, veuillez mettre à jour votre équipement disponible.',
			plateauResolved: 'Vous avez atteint un plateau. {message}',
			plateauDetected: 'Vos progrès stagnent à ce poids depuis plus d\'une séance.',
			plateauDismissed: 'Plateau ignoré par l\'utilisateur.',
			volumeAutoregulationIncrease: 'Autorégulation du volume appliquée. Votre volume d\'entraînement sera augmenté d\'une série lors de la prochaine séance en fonction de votre indice de fatigue.',
			volumeAutoregulationDecrease: 'Autorégulation du volume appliquée. Votre volume d\'entraînement sera réduit d\'une série lors de la prochaine séance en fonction de votre indice de fatigue.',
			volumeAutoregulationPending: 'D\'après votre performance, nous recommandons d\'ajuster votre volume de séries.',
			strengthTestFollowupDone: 'Bonne série ! Votre test de force a déjà mis à jour votre progression pour cet exercice, alors gardez ce poids pour le reste de la journée.',
			repCeilingSwitch: 'Vous avez atteint 30 répétitions et le poids suivant est un saut trop important ; la prochaine fois, nous passerons donc à un autre exercice.',
			repCeilingSwitchSameEquipment: 'Vous avez atteint 30 répétitions et le poids suivant est un saut trop important ; la prochaine fois, nous passerons donc à un autre exercice. Toutes les alternatives à cet exercice utilisent le même équipement : pensez à ajouter des incréments de poids plus petits dans les réglages de votre équipement.',
			repCeilingHeld: 'Vous avez atteint 30 répétitions. Votre objectif de répétitions reste à 30, et nous vous reposerons la question la prochaine fois.',
			dropSet: 'Dropset ! Réduisez le poids pour les séries suivantes.',
			dropSetAtFloor: 'Dropset ! Cet équipement ne descend pas plus bas : gardez ce poids pour les séries suivantes.',
			completeProgressionReset: 'Pour terminer la réinitialisation, effectuez le test de force maintenant. Si vous quittez la séance sans rien enregistrer pour le test de force, la réinitialisation sera annulée et vous reviendrez aux anciennes valeurs.',
			adjustedTargetWeight: 'Il semble que vous n\'ayez pas effectué cet exercice depuis plus d\'une semaine. Nous allons donc ajuster votre poids cible en conséquence.',
			adjustedTargetReps: 'Il semble que vous n\'ayez pas effectué cet exercice depuis plus d\'une semaine. Nous allons donc ajuster vos répétitions cibles en conséquence.',
			cappedToRecentPerformance: 'D\'après vos dernières séries, le poids prévu semblait trop lourd pour autant de répétitions. Nous l\'avons réduit pour correspondre à ce que vous pouvez faire en ce moment.',
			deloadedTargetWeight: 'Votre poids cible est un cran plus bas à cause de votre dernier délestage. C\'est une série de travail normale : visez votre objectif de répétitions.',
			retestRequired: 'Il semble que vous n\'ayez pas effectué cet exercice depuis quelques semaines. Nous avons donc besoin que vous retestiez cet exercice.',
		},
		instructions: {
			fillInReps: 'Saisissez votre nombre de répétitions pour la série.',
			fillInWeight: 'Saisissez le poids que vous avez soulevé.',
			fillInWeightAndReps: 'Saisissez le poids que vous avez soulevé et le nombre de répétitions pour la série.',
		},
		errors: {
			unableToLoad: 'Impossible de charger la séance',
			unableToLoadMessage: 'La séance ne peut pas être chargée pour le moment, désolé. Veuillez réessayer. Si le problème persiste, veuillez contacter le support.',
		},
	},
	foods: {
		title: 'Aliments',
		addFoods: 'Ajouter des aliments',
		searchPlaceholder: 'Rechercher...',
		filtersAndSettings: 'Filtres et réglages',
		showFoodValuesBy: 'AFFICHER LES VALEURS DES ALIMENTS PAR',
		servingSize: 'Taille de portion',
		per100g: '100 g',
		filters: {
			all: 'Tous',
			foods: 'Aliments',
			recipes: 'Recettes',
			meals: 'Repas',
			favorites: 'Favoris',
			myFoods: 'Mes aliments',
			loggedBefore: 'Déjà enregistré',
			hideUnverified: 'Masquer les non vérifiés',
			hideUnverifiedHint: 'Masque les aliments ajoutés par d\'autres membres et par Open Food Facts',
			type: 'Type',
			showOnly: 'Afficher uniquement',
			source: 'Source',
			removeFilter: 'Supprimer {filter}',
			reset: 'Effacer',
		},
		buttons: {
			createRecipe: 'Créer une recette',
			createFood: 'Créer un aliment',
			addMacros: 'Ajouter des macros',
			new: 'Nouveau',
			filters: 'Filtres',
			retrySearch: 'Réessayer',
			clearFilters: 'Effacer les Filtres',
			searchCorrection: 'Rechercher {phrase}',
			searchTypedInstead: 'Rechercher plutôt {phrase}',
			removeFromHistory: 'Retirer de l\'historique',
		},
		badges: {
			recipe: 'Recette',
			meal: 'Repas',
			locked: 'Verrouillé',
			usedBefore: 'Déjà enregistré',
			liked: 'Aimé',
			disliked: 'Pas aimé',
			community: 'Communauté',
			openFoodFacts: 'Open Food Facts',
			staple: 'Aliment de Base',
			noNutritionData: 'Aucune donnée nutritionnelle',
			checkValues: 'Valeurs douteuses',
			checkValuesInfo: 'Les calories indiquées pour cet aliment ne correspondent pas à ses protéines, lipides et glucides, qui donnent environ {expectedCalories} kcal pour 100 g. Cette fiche est peut-être erronée.',
		},
		messages: {
			useSearchBar: 'Utilisez la barre de recherche ci-dessus pour trouver des aliments.',
			removedFromHistory: 'Retiré de vos aliments récents.',
			nothingMatchesFilters: 'Aucun aliment ne correspond à vos filtres.',
			clearFiltersOrSearch: 'Effacez les filtres, ou utilisez la barre de recherche ci-dessus pour trouver des aliments.',
			clearFiltersOrCreate: 'Effacez les filtres, ou utilisez le bouton + Nouveau pour créer un nouvel aliment ou une nouvelle recette.',
			noFoodByBarcode: 'Aucun aliment trouvé pour ce code-barres. Utilisez le bouton ci-dessous pour le créer.',
			noFoodByBarcodeScanLabel: 'Aucun aliment trouvé pour ce code-barres.',
			noFoodByBarcodeScanLabelHint: 'Prenez quelques photos de l\'emballage et nous créerons un nouvel aliment pour vous !',
			notFoundWhat: 'Vous ne trouvez pas ce que vous cherchez ?',
			searchConnectionTitle: 'Impossible de charger les résultats de recherche',
			searchConnectionHint: 'Il semble y avoir un problème de connexion. Vérifiez votre connexion internet et réessayez.',
			offlineShowingLocalFoods: 'Vous êtes hors ligne, impossible de chercher dans la base de données alimentaire. Les aliments de base et les aliments consommés récemment, tous enregistrés sur cet appareil, sont affichés.',
			searchUnreachableShowingLocalFoods: 'Impossible de joindre la base de données alimentaire. Les aliments de base et les aliments consommés récemment, tous enregistrés sur cet appareil, sont affichés.',
			offlineShowingLocalFoodsBarcode: 'Vous êtes hors ligne, impossible de chercher dans la base de données alimentaire. Seuls les aliments consommés récemment, enregistrés sur cet appareil, sont affichés.',
			searchUnreachableShowingLocalFoodsBarcode: 'Impossible de joindre la base de données alimentaire. Seuls les aliments consommés récemment, enregistrés sur cet appareil, sont affichés.',
			searchFailedTitle: 'Impossible de charger les aliments',
			searchFailedHint: 'Une erreur s\'est produite lors du chargement de vos aliments. Veuillez réessayer.',
			wrongFoodScanLabel: 'Ce n\'est pas le bon aliment ?',
			wrongFoodScanLabelHint: 'Prenez quelques photos de l\'emballage et nous créerons un nouvel aliment pour vous !',
			useButtonsBelow: 'Utilisez le bouton + Nouveau pour créer un nouvel aliment ou une nouvelle recette.',
			copiedToClipboard: 'Copié dans le presse-papiers',
			didYouMeanLabel: 'Essayez avec cette orthographe :',
			showingResultsForLabel: 'Voici les résultats pour',
			searchInsteadForLabel: 'Rechercher plutôt',
		},
		suggestions: {
			listLabel: 'Recherches suggérées',
			loading: 'Recherche de suggestions',
			rowLabel: '{phrase}, {count} {{aliment|aliments}}',
			stapleRowLabel: '{name}, aliment de base',
		},
	},
	nutrition: {
		labels: {
			nutrient: 'Nutriment',
			target: 'Cible',
			actual: 'Réel',
		},
		targets: {
			remaining: 'Restant',
			logged: 'Enregistré',
		},
		macrosLogged: 'Macros enregistrées',
		macrosRemaining: 'Macros restantes',
		nutritionInfo: 'Infos nutritionnelles',
		flexibleNutritionLink: 'Nutrition flexible',
		calorieCyclingLink: 'Cyclage des calories',
		settings: {
			meals: 'Repas',
		},
		planMyWeek: 'Planifier ma semaine',
		charts: {
			loggedCalories: 'Calories enregistrées',
			targetCalories: 'Calories cibles',
		},
		enabledForMealsBoth: 'sont activés pour vos repas.',
		enabledForMeals: 'est activé pour vos repas.',
	},
	errors: {
		userFacing: {
			authFailed: 'Échec de la connexion après le retour en ligne. Vous restez hors ligne.',
			foodNotExist: 'Cet aliment n\'existe pas',
			foodLoadFailedTitle: 'Impossible de charger l\'aliment',
			foodLoadFailed: 'Impossible de charger cet aliment pour le moment. Vérifiez votre connexion et réessayez.',
			foodDeleteFailed: 'Impossible de supprimer cet aliment. Veuillez réessayer.',
			ingredientListLoadFailed: 'Impossible de charger tous les aliments de ce repas. Vérifiez votre connexion et réessayez.',
			noMealOnDayTitle: 'Aucun repas où ajouter',
			noMealOnDay: 'Il n\'y a aucun repas ce jour-là auquel tu peux ajouter cet aliment. Choisis un autre jour.',
			splitIntoFoodsFailed: 'Impossible de diviser cet élément en aliments. L\'un de ses ingrédients n\'est peut-être plus disponible. Veuillez réessayer.',
			splitTuningFailed: 'Tes aliments ont été divisés, mais l’ajustement automatique a rencontré un problème et n’a pas pu ajuster leurs quantités. Ajuste-les toi-même ou réessaie.',
			confirmRecentMealFailed: 'Impossible d’ajouter les aliments de ce repas. Réessaie.',
			recentMealCouldNotBeOpened: 'Impossible d’ouvrir ce repas, rien n’a donc été ajouté. Il a peut-être été supprimé ou n’a pas encore fini de se synchroniser. Réessaie.',
			couldNotOpenPage: 'Impossible d’ouvrir cet élément. Il a peut-être été supprimé ou n’est pas disponible pour le moment.',
			couldNotLeavePage: 'Impossible de fermer cet écran. Veuillez réessayer.',
			exportFailed: 'Impossible d\'exporter le fichier. Veuillez réessayer.',
			unsupportedBrowser: 'Votre navigateur n\'est peut-être pas entièrement pris en charge',
			noticeUnusual: 'Vous remarquez quelque chose d\'inhabituel ?',
			communityAuthFailed: 'Impossible de s\'authentifier pour accéder à la communauté',
			equipmentCannotBeUsed: 'Cet équipement ne peut pas être utilisé',
			unsubscribeFailed: 'Échec de la désinscription',
			paymentPending: 'Votre paiement est en attente de vérification, mais vous pouvez continuer à utiliser l\'application',
			resubscribeFailed: 'Échec du réabonnement',
			planSwitchFailed: 'Impossible de changer de programme',
			sendLoginEmailFailed: 'Échec de l\'envoi de l\'e-mail de connexion. Veuillez contacter le support.',
			updateWorkoutFailed: 'Impossible de mettre à jour votre séance. Veuillez réessayer.',
			paddlePortalFailed: 'Impossible d\'ouvrir le portail d\'abonnement. Veuillez réessayer.',
			imageReadFailed: 'Impossible de lire l\'image sélectionnée.',
			imageDecodeFailed: 'Impossible de charger l\'image sélectionnée.',
			imageTooSmall: 'L\'image sélectionnée est trop petite. La taille minimale est de {minSize} px.',
			imageUploadFailed: 'Impossible d\'envoyer l\'image. Vérifie ta connexion et réessaie.',
		},
		syncRetry: {
			retrying: 'Connexion à vos données — un instant...',
			stillRetrying: 'Toujours en cours — patientez un instant !',
		},
	},
	auth: {
		login: 'Se connecter',
		signup: 'S\'inscrire',
		forgotPassword: 'Mot de passe oublié',
		email: 'E-mail',
		enterYourEmail: 'Saisissez votre e-mail',
		password: 'Mot de passe',
		enterYourPassword: 'Saisissez votre mot de passe',
		signInReadyTapAgain: 'La connexion est prête. Veuillez appuyer à nouveau sur le bouton.',
		enterYourName: 'Saisissez votre nom',
		chooseYourPassword: 'Choisissez votre mot de passe',
		loginToAccount: 'Connectez-vous à votre compte',
		welcomeToMhPhysique: 'Bienvenue sur MH Physique',
		dontHaveAccountYet: 'Vous n\'avez pas encore de compte ?',
		dontHaveAccount: 'Vous n\'avez pas de compte ?',
		dontHaveAccountButton: 'Vous n\'avez pas de compte ?',
		learnMore: 'En savoir plus',
		processing: 'Traitement en cours',
		loginWithLink: 'Obtenir le lien',
		signInByEmail: 'Envoyez-moi un lien de connexion par e-mail',
		signInWithPassword: 'Se connecter avec un mot de passe',
		createAccount: 'Créer un compte',
		alreadyHaveAccount: 'Vous avez déjà un compte ?',
		signUpWithEmail: 'S\'inscrire avec un e-mail',
		orSignUpWith: 'Ou inscrivez-vous avec',
		or: 'OU',
		signIn: 'Se connecter',
		signInWithGoogle: 'Se connecter avec Google',
		signInWithApple: 'Se connecter avec Apple',
		google: 'Google',
		apple: 'Apple',
		firstLastName: 'Prénom et nom',
		choosePassword: 'Choisir un mot de passe',
		subscriptionSuccess: 'Abonnement réussi !',
		subscriptionSuccessCheckEmail: 'Nous avons envoyé un lien de connexion à l\'e-mail que vous avez utilisé lors du paiement. Consultez votre boîte de réception pour commencer.',
		emailLinkSent: 'Lien envoyé par e-mail',
		emailLinkSentMessage: 'Nous vous avons envoyé un e-mail contenant un lien de connexion. Si vous ne le voyez pas rapidement, vérifiez votre dossier spam.',
		emailLinkContact: 'S\'il n\'y est pas, contactez',
		bySigningIn: 'En vous connectant, vous acceptez les',
		bySubscribing: 'En vous abonnant, vous acceptez les',
		termsAndConditions: 'Conditions générales',
		and: 'et',
		privacyPolicy: 'la Politique de confidentialité',
		pricing: 'Tarifs',
		refunds: 'Remboursements',
		eula: 'CLUF',
		claim: {
			alreadyHaveAccount: 'J\'ai déjà un compte',
			newToMhPhysique: 'Je suis nouveau ici',
			createAccount: 'Créer un compte',
		},
		switchAccount: {
			title: 'Changer de compte',
			message: 'Vous êtes connecté en tant que {currentEmail}. Passer à {newEmail} pour accéder à votre abonnement ?',
			switchButton: 'Changer',
			expiredTitle: 'Lien expiré',
			expiredMessage: 'Votre lien de connexion a expiré. Nous en avons envoyé un nouveau à {email}.',
			expiredResendFailedMessage: 'Votre lien de connexion a expiré et nous n\'avons pas pu en envoyer un nouveau à {email} pour le moment. Vérifiez votre connexion et réessayez.',
			unfinishedTitle: 'Changement non terminé',
			unfinishedMessage: 'Le passage à {newEmail} prend trop de temps, vous êtes donc toujours connecté à votre compte actuel. Si le changement aboutit, l\'application redémarrera. Sinon, rouvrez le lien.',
		},
		errors: {
			otlExpired: 'Le lien à usage unique a expiré. Veuillez saisir votre adresse e-mail pour en recevoir un nouveau.',
			otlRecent: 'Veuillez vérifier votre boîte de réception. Nous vous avons récemment envoyé un lien de connexion. Vous ne le trouvez pas ? Nous pouvons en envoyer un autre.',
			otlAmbiguousAccount: 'Nous n\'avons pas pu envoyer votre lien de connexion, car plusieurs comptes utilisent cette adresse e-mail et nous ne pouvons pas savoir lequel est le vôtre. Contactez-nous à l\'adresse {email} et nous réglerons cela.',
			signInTokenCheck: 'Erreur lors de la vérification du jeton de connexion. Veuillez réessayer ou utiliser une autre méthode.',
			useAlternativeTitle: 'Utiliser {provider} ?',
			useAlternativeMessage: 'Ce compte est déjà enregistré avec la connexion {provider}. Voulez-vous utiliser {provider} pour vous connecter ?',
			badEmailFormat: 'Format d\'adresse e-mail incorrect.',
			passwordResetSent: 'Consultez votre boîte de réception pour les instructions de réinitialisation du mot de passe. Revenez ensuite ici pour vous connecter.',
			popupClosed: 'La fenêtre contextuelle a été fermée. Veuillez réessayer.',
			firebase: {
				invalidEmail: 'Veuillez saisir une adresse e-mail valide.',
				missingEmail: 'Veuillez saisir votre adresse e-mail.',
				userNotFound: 'Aucun compte trouvé avec cet e-mail. Veuillez vérifier votre e-mail ou créer un nouveau compte.',
				emailAlreadyInUse: 'Un compte avec cet e-mail existe déjà. Veuillez vous connecter, ou utilisez « Mot de passe oublié » si vous l\'avez oublié.',
				accountExistsWithDifferentCredential: 'Un compte avec cet e-mail existe déjà, mais il utilise une autre méthode de connexion. Veuillez vous connecter comme la dernière fois, par exemple avec votre e-mail et votre mot de passe.',
				wrongPassword: 'Mot de passe incorrect. Veuillez réessayer.',
				invalidCredential: 'E-mail ou mot de passe incorrect. Veuillez réessayer.',
				weakPassword: 'Votre mot de passe est trop faible. Veuillez en choisir un plus robuste.',
				tooManyRequests: 'Trop de tentatives. Veuillez patienter quelques minutes et réessayer.',
				networkRequestFailed: 'Connexion impossible. Veuillez vérifier votre connexion internet et réessayer.',
				userDisabled: 'Ce compte a été désactivé. Veuillez contacter le support à l\'adresse {email} pour obtenir de l\'aide.',
				operationNotAllowed: 'Cette méthode de connexion n\'est pas disponible pour le moment. Veuillez essayer une autre méthode.',
				popupBlocked: 'La fenêtre de connexion a été bloquée par votre navigateur. Veuillez autoriser les fenêtres contextuelles pour ce site et réessayer.',
				requiresRecentLogin: 'Pour des raisons de sécurité, veuillez vous reconnecter.',
				invalidActionCode: 'Ce lien est invalide ou a déjà été utilisé.',
				expiredActionCode: 'Ce lien a expiré. Veuillez en demander un nouveau.',
				genericError: 'Une erreur s\'est produite. Veuillez réessayer ou contacter le support à l\'adresse {email}.',
			},
		},
		newAccountMade: {
			title: 'Nouveau compte créé',
			message: 'En vous connectant de cette façon, un tout nouveau compte a été créé ; il est donc vide. Si vous vous êtes déjà abonné avec une autre adresse e-mail, saisissez cette adresse et nous vous enverrons un lien de connexion.',
			placeholder: 'vous@exemple.com',
			continueAsNew: 'Je suis nouveau ici',
			findMyAccount: 'Trouver mon compte',
			checking: 'Vérification de cette adresse...',
			linkSent: 'Nous avons envoyé un lien de connexion à {email}. Ouvrez-le sur cet appareil pour revenir à votre compte.',
			sameAccount: 'C\'est l\'adresse du nouveau compte auquel vous êtes déjà connecté. Si vous vous êtes abonné avec une autre adresse, essayez celle-ci.',
			noAccount: 'Nous n\'avons trouvé aucun compte avec cette adresse e-mail. Vérifiez l\'orthographe ou continuez avec le nouveau compte que vous venez de créer.',
			severalAccounts: 'Plusieurs comptes utilisent cette adresse e-mail, nous ne pouvons donc pas déterminer lequel est le vôtre. Contactez le support et nous réglerons cela pour vous.',
			couldNotCheck: 'Nous n\'avons pas pu vérifier cette adresse e-mail pour le moment. Vérifiez votre connexion et réessayez.',
			couldNotSend: 'Nous n\'avons pas pu envoyer le lien de connexion pour le moment. Vérifiez votre connexion et réessayez.',
		},
		accountHint: {
			title: 'Autre compte',
			message: 'Le lien que vous avez ouvert a été envoyé à {hintEmail}, mais vous êtes connecté en tant que {currentEmail}. Voulez-vous que nous envoyions un lien de connexion à {hintEmail} ?',
			stayButton: 'Rester connecté',
			sendButton: 'Envoyer le lien',
			sending: 'Envoi du lien de connexion...',
		},
	},
	settings: {
		sections: {
			training: 'Entraînement',
			nutrition: 'Nutrition',
			general: 'Général',
			support: 'Support',
			regional: 'Préférences régionales et d\'affichage',
			accessibility: 'Accessibilité',
			experimental: 'Expérimental',
		},
		intakePendingCard: {
			title: 'Terminez la configuration de votre profil',
			body: 'La plupart des options ici ajustent votre programme de forme, elles seront donc prêtes une fois qu\'il sera généré.',
			linkText: 'Continuer le questionnaire',
		},
		items: {
			trainingSettings: 'Réglages d\'entraînement',
			workouts: 'Séances',
			editEquipment: 'Modifier l\'équipement',
			nutritionSettings: 'Réglages de nutrition',
			mealPlanner: 'Planificateur de repas',
			foods: 'Aliments',
			appSettings: 'Réglages de l\'application',
			manageSubscription: 'Gérer l\'abonnement',
			coaching: 'Coaching',
			privacyChoices: 'Choix de confidentialité',
			admin: 'Admin',
			help: 'Aide',
			feedback: 'Commentaires',
			messageCoach: 'Contacter le coach',
			community: 'Communauté',
			whatsNew: 'Nouveautés',
			rateTheApp: 'Noter l\'application',
		},
		installApp: 'Installer l\'application',
		language: 'Langue',
		applyingLanguage: 'Application de la langue…',
		downloadingLanguage: 'Téléchargement de la langue…',
		languageDownloadFailed: {
			title: 'Impossible de changer de langue',
			message: 'Nous n\'avons pas pu télécharger {language} pour une utilisation hors ligne. Vérifiez votre connexion Internet et réessayez.',
		},
		clockMode: 'Format d\'heure',
		hour24: '24 h',
		ampm: 'AM/PM',
		automatic: 'Automatique',
		decimalSeparator: 'Séparateur décimal',
		point: 'Point (.)',
		comma: 'Virgule (,)',
		dateFormat: 'Format de date',
		firstDayOfWeek: 'Premier jour de la semaine',
		monday: 'Lundi',
		saturday: 'Samedi',
		sunday: 'Dimanche',
		nutritionLabelStyle: 'Style d\'étiquette nutritionnelle',
		foods: {
			uncaching: 'Suppression du cache des aliments...',
		},
		allowCardAnimations: 'Autoriser les animations des cartes',
		headerHideBehavior: 'Masquer l\'en-tête au défilement',
		footerHideBehavior: 'Masquer le pied de page au défilement',
		scrollHide: {
			always: 'Toujours',
			never: 'Jamais',
		},
		descriptions: {
			language: 'Choisissez la langue de l\'interface de l\'application. Tout texte qui n\'est pas encore traduit s\'affiche en anglais.',
			clockMode: 'Nous avons détecté {mode} comme le format d\'heure le plus probable selon votre pays actuel. Si cela ne correspond pas à vos préférences, définissez une valeur manuelle ici.',
			dateFormat: 'Choisissez comment les dates sont affichées dans toute l\'application. Le mode automatique utilise la langue régionale détectée à partir de votre pays actuel.',
			firstDayOfWeek: 'Choisissez quel jour s\'affiche en premier dans les vues hebdomadaires. Le mode automatique utilise la langue régionale détectée à partir de votre pays actuel.',
			decimalSeparator: 'Choisissez quel symbole est utilisé pour les décimales (p. ex. « . » ou « , »). Basé sur votre paramètre régional.',
			nutritionLabelStyle: 'Les étiquettes de style américain affichent les glucides totaux, fibres incluses. Les étiquettes de style européen affichent les glucides nets, sans les fibres.\n\nCela s\'applique uniquement lors de la modification d\'un aliment individuel. Nous affichons toujours les glucides nets (sans les fibres) ailleurs dans l\'application, car c\'est plus pertinent d\'un point de vue métabolique.',
			cardAnimations: 'Désactivez les animations si le mouvement vous dérange, ou si votre appareil ne les gère pas bien.',
			headerHideBehavior: 'Contrôlez si l\'en-tête se masque lors du défilement vers le bas. « Auto » ne masque que les en-têtes avec calendriers.',
			footerHideBehavior: 'Contrôlez si la navigation du bas se masque lors du défilement vers le bas. « Auto » ne masque que la barre de navigation principale.',
			showSlotName: 'Affichez le nom du groupe musculaire (nom du slot) sous les noms des exercices dans les vues de séance et la configuration des exercices.',
		},
		notifications: {
			sectionTitle: 'Notifications',
			description: 'Recevez des rappels pour les activités programmées. Les notifications sont envoyées 10 minutes avant l\'heure prévue.',
			workout: 'Séances',
			workoutDescription: 'Avant chaque séance programmée',
			meals: 'Repas',
			mealsDescription: 'Avant chaque repas programmé',
			weighIn: 'Pesées',
			weighInDescription: 'Les jours de pesée programmés',
			weeklyCheckup: 'Bilan hebdomadaire',
			weeklyCheckupDescription: 'Quand votre bilan hebdomadaire est attendu',
			sleep: 'Sommeil',
			sleepDescription: 'Avant l\'heure prévue pour vous détendre',
			deviceSettings: 'Réglages de notification de l\'appareil',
			deviceSettingsDescription: 'Gérez les autorisations de notification dans les réglages de votre appareil',
			content: {
				workout: 'C\'est l\'heure de s\'entraîner',
				meal: 'C\'est l\'heure de manger',
				weighIn: 'C\'est l\'heure de la pesée',
				weeklyCheckup: 'C\'est l\'heure de votre bilan hebdomadaire',
				sleep: 'C\'est l\'heure de se détendre',
			},
		},
		testSettings: {
			header: 'Réglages de test',
			testMode: 'Mode test',
			locale: 'Paramètres régionaux',
			localeDecimalSeparator: 'Séparateur décimal régional',
			unitSettings: 'Réglages des unités',
			hintsSeen: 'Astuces vues',
			helpSeen: 'Aide vue',
			dismissedToasts: 'Notifications ignorées',
			showAllHints: 'Toujours afficher toutes les astuces',
			showAllTutorials: 'Toujours afficher tous les tutoriels',
			debugFoodSearch: 'Déboguer la recherche d\'aliments',
			debugRestTimerOnWeb: 'Afficher le minuteur de repos sur le web (débogage)',
			debugLog: 'Journal de débogage',
			debugLogPlaceholder: 'Aucun journal enregistré',
			clearLog: 'Effacer le journal',
			accountDatabase: 'Base de données du compte',
			cachedFoods: 'Aliments actuellement en cache : {count}',
			uncacheFoodsNote: 'Pour tous les aliments de userdb qui existent dans globaldb, supprime l\'élément de userdb (provoquera une remise en cache à la prochaine utilisation).',
			testSurveyNote: 'Ceci fera apparaître le sondage appelé « Test survey ».',
			testNotificationNote: 'Envoie une notification push à tous les appareils mobiles connectés à ce compte. Arrive dans la minute qui suit.',
			testNotification: 'Tester la notification push',
			resetHiddenMessagesNote: 'Fait réapparaître tous les messages que vous avez masqués en appuyant sur « Ne plus afficher ». Sans cela, il n\'y a aucun moyen d\'annuler cette action.',
			resetHiddenMessages: 'Réinitialiser les messages masqués',
			hiddenMessagesRestored: '{count} message{{|s}} masqué{{|s}} réapparaîtra{{|ront}}.',
			noHiddenMessages: 'Vous n\'avez masqué aucun message.',
		},
		experimental: {
			showSlotName: 'Afficher le nom de l\'emplacement',
		},
	},
	dbSnapshots: {
		title: 'Instantanés de la base de données',
		createSnapshot: 'Créer un instantané',
		rename: 'Renommer',
		download: 'Télécharger',
		noSnapshots: 'Aucun instantané pour le moment. Créez-en un pour enregistrer l\'état actuel de la base de données.',
		renameTitle: 'Renommer l\'instantané',
		renamePlaceholder: 'Nom de l\'instantané',
		deleteConfirmTitle: 'Supprimer l\'instantané ?',
		deleteConfirmMessage: 'Cela supprimera définitivement l\'instantané « {name} ».',
		creating: 'Création de l\'instantané...',
		snapshotInfo: '{date} · {count} docs',
		restore: 'Restaurer',
		restoreConfirmTitle: 'Restaurer l\'instantané ?',
		restoreConfirmMessage: 'Cela remplacera toutes les données actuelles par l\'instantané « {name} ». Cette action est irréversible.',
		restoring: 'Restauration de l\'instantané...',
		restoreComplete: 'L\'instantané « {name} » a été restauré avec succès.',
		restoreFailed: 'L\'instantané n\'a pas pu être restauré. La connexion s\'est interrompue en cours de route, donc vos données peuvent être un mélange d\'anciens documents et de documents restaurés jusqu\'à la fin de la synchronisation. L\'application va maintenant se recharger. Vérifiez votre connexion et réessayez.',
		restoreFailedTitle: 'Échec de la restauration',
		restoreCleanupFailed: 'L\'instantané a été restauré sur le serveur, mais l\'ancienne copie locale de cet appareil n\'a pas pu être effacée. Ne continuez PAS à utiliser l\'application sur cet appareil pour l\'instant : effacez le stockage de l\'application (ou réinstallez-la) et rouvrez-la, afin que les données restaurées soient téléchargées à neuf.',
	},
	dbRestoreJson: {
		title: 'Restaurer la base de données depuis un fichier JSON',
		description: 'Téléversez un fichier JSON ou collez des données JSON pour restaurer une base de données utilisateur.',
		chooseFile: 'Choisir un fichier JSON',
		orPaste: 'Ou coller du JSON',
		pasteHint: 'Collez un tableau de documents au format JSON',
		parseJson: 'Analyser le JSON',
		restore: 'Restaurer',
		restoring: 'Restauration de la base de données...',
		invalidJson: 'JSON invalide. Doit être un tableau de documents, chacun avec un champ _id.',
		confirmTitle: 'Restaurer la base de données ?',
		confirmMessage: 'Cela remplacera toutes les données utilisateur actuelles par {count} documents. Cette action est irréversible.',
		fileLoaded: '{count} documents chargés depuis le fichier.',
		restoreCompleteTitle: 'Base de données restaurée',
		restoreCompleteMessage: 'La base de données a été restaurée depuis le JSON ({count} documents).',
		restoreFailed: 'La base de données n\'a pas pu être restaurée. La connexion s\'est interrompue en cours de route, donc vos données peuvent être un mélange d\'anciens documents et de documents restaurés jusqu\'à la fin de la synchronisation. L\'application va maintenant se recharger. Vérifiez votre connexion et réessayez.',
		restoreFailedTitle: 'Échec de la restauration',
		restoreCleanupFailed: 'Vos données ont été restaurées sur le serveur, mais l\'ancienne copie locale de cet appareil n\'a pas pu être effacée. Ne continuez PAS à utiliser l\'application sur cet appareil pour l\'instant : effacez le stockage de l\'application (ou réinstallez-la) et rouvrez-la, afin que les données restaurées soient téléchargées à neuf.',
	},
	debug: {
		nextDay: 'Jour suivant',
		more: 'Plus...',
	},
	app: {
		title: 'MH Physique',
		updated: 'Mis à jour vers {version}',
		whatsNew: 'Quoi de neuf ?',
		updateAvailable: {
			message: 'Une nouvelle version est disponible.',
			action: 'Mettre à jour',
			downloading: 'Téléchargement de la mise à jour…',
			ready: 'Mise à jour téléchargée.',
			restart: 'Redémarrer',
			upToDate: 'Vous êtes à jour',
			settingsRow: 'Rechercher des mises à jour',
		},
		updateRequired: {
			title: 'Mettez à jour l\'app',
			message: 'Cette version de l\'app n\'est plus prise en charge. Mettez-la à jour pour continuer à recevoir les correctifs et les nouvelles fonctionnalités.',
			update: 'Mettre à jour',
			later: 'Plus tard',
			cardMessage: 'Cette version n\'est plus prise en charge. Mettez à jour l\'app.',
		},
		starting: 'Démarrage...',
		loading: 'Chargement...',
		databaseRecoveryLoading: 'Restauration de vos données...',
		downloadingExistingData: 'Téléchargement des données existantes...',
		openingCommunity: 'Ouverture de la communauté, veuillez patienter...',
		communityOffline: 'La communauté nécessite une connexion internet. Connectez-vous à internet et réessayez.',
		videoOffline: 'Les vidéos nécessitent une connexion internet.',
		offlineFirstLoadMessage: 'Vous êtes hors ligne. Connectez-vous à internet pour charger votre compte pour la première fois sur cet appareil.',
		offlineFirstLoadChecking: 'Vérification de votre connexion...',
		offlineFirstLoadStillOffline: 'Toujours hors ligne. Connectez-vous à internet, puis réessayez.',
		offlineFirstLoadServerUnreachable: 'Votre connexion est rétablie, mais nous n\'avons pas pu joindre votre compte. Veuillez réessayer dans un instant.',
		accountLoadFailedMessage: 'Nous n\'avons pas pu charger votre compte. Vérifiez votre connexion et réessayez.',
		splashStuckMessage: 'Cela prend plus de temps que d\'habitude. Vérifiez votre connexion et réessayez.',
		splashStuckOfflineMessage: 'Vous semblez être hors ligne. Reconnectez-vous à internet, puis réessayez.',
		retry: 'Réessayer',
		communityTitle: 'Communauté',
		communityFirstTime: 'Si vous ouvrez la communauté pour la première fois, la création de votre compte peut prendre un certain temps. Merci d\'avance pour votre patience.',
		screenshotHelp: 'Utilisez ce bouton pour prendre la capture d\'écran. Vous pouvez le déplacer s\'il vous gêne.',
		screenshotCaptureFailed: 'Nous n\'avons pas pu prendre la capture d\'écran. Votre texte est toujours là, vous pouvez donc l\'envoyer sans.',
		darkModeConflictTitle: 'Conflit avec le mode sombre de Samsung',
		darkModeConflictMessage: 'Cette application est toujours en mode sombre. Samsung Internet impose son propre mode sombre par-dessus, ce qui rend l\'application illisible. Veuillez ouvrir le menu du navigateur et appuyer soit sur « Sites en thème clair », soit sur « Paramètres > Labs > Utiliser le thème sombre des sites web ».',
		darkModeConflictButton: 'Ok, c\'est fait',
		serverConnectionDifficulty: 'Difficulté à se connecter au serveur...',
		serverBehindAccountVersion: 'Ce serveur utilise une version plus ancienne que celle dont votre compte a besoin. Veuillez réessayer dans quelques minutes.',
	},
	appInstallSheet: {
		title: 'Obtenez l\'application MH Physique',
		body: 'Une expérience plus rapide et plus fluide — séances, journal des repas et suivi des progrès directement sur votre téléphone.',
		openInAppCta: 'Ouvrir dans MH Physique',
		openInAppLink: 'Vous avez déjà l\'application ? Ouvrez-la',
		continueInBrowser: 'Continuer dans le navigateur',
		dontShowAgain: 'Ne plus afficher',
		notRightNow: 'Pas maintenant ?',
	},
	progress: {
		title: 'Progrès',
		filters: 'Filtres',
		measurements: 'Mesures',
		exportAsCsv: 'Exporter en CSV',
		noData: 'Aucune donnée',
		lostPerWeek: 'perdu par semaine',
		gainedPerWeek: 'gagné par semaine',
		filterHeaders: {
			bodyComposition: 'Composition corporelle',
			nutrition: 'Nutrition',
			chartDisplaySettings: 'Réglages d\'affichage du graphique',
		},
		chartTitles: {
			bodyComposition: 'Progrès de la composition corporelle',
			nutrition: 'Progrès nutritionnels',
		},
		filterOptions: {
			showAverage: 'Afficher la moyenne',
			showAverageDescription: 'Fait la moyenne des 7 derniers jours de données pour lisser les fluctuations quotidiennes',
			showPoints: 'Afficher les points',
			showPointsDescription: 'Affiche les points de données sous forme de cercles sur les lignes du graphique',
		},
		axisTitles: {
			weight: 'Poids ({unit})',
			waist: 'Tour de taille ({unit})',
			caloriesKcal: 'Calories (kcal)',
			day: 'Jour',
			month: 'Mois',
		},
		trendLegend: {
			falling: 'En baisse',
			rising: 'En hausse',
			flat: 'Stable',
			uncertain: 'Incertain',
			mayChange: 'Peut encore changer',
		},
	},
	intro: {
		start: 'Commencer',
		next: 'Suivant',
		back: 'Retour',
		skip: 'Passer l\'intro',
		slide1: {
			title: 'Votre coach de fitness tout-en-un dans votre poche',
			text: 'L\'entraînement et la nutrition adaptatifs se réunissent dans une seule application puissante. Votre programme évolue avec vos progrès, en veillant à ce que vous développiez du muscle, gagniez en force et perdiez de la graisse.',
		},
		slide2: {
			title: 'Enregistrez vos séances et voyez vos progrès grandir',
			text: 'Votre programme s\'ajuste après chaque séance pour correspondre à vos performances. Si c\'est trop facile, nous vous mettrons au défi. Si c\'est trop, nous réduirons pour vous aider à récupérer.',
		},
		slide3: {
			title: 'Une nutrition sans effort pour vos objectifs',
			text: 'Votre plan nutritionnel est continuellement mis à jour.\nDes repas conçus par des experts éliminent les incertitudes pour atteindre vos objectifs.',
		},
		slide4: {
			title: 'Toujours adapté à vous',
			text: 'Votre plan évolue à mesure que vous devenez plus fort, s\'ajustant sans effort pour vous garder sur la bonne voie.\nVous préférez un autre exercice ou voulez votre propre repas ?\nModifiez vos plans à tout moment.',
		},
	},
	customizeHomepage: {
		title: 'Personnaliser l\'accueil',
		sections: {
			dailyLog: 'Journal quotidien',
			progress: 'Progrès',
		},
		options: {
			wakeUp: 'Réveil',
			weighIn: 'Pesée',
			workout: 'Séance',
			meals: 'Repas',
			sleep: 'Sommeil',
			goal: 'Objectif',
			bodyComposition: 'Composition corporelle',
			nutrition: 'Nutrition',
			coachingTips: 'Conseils de coaching',
		},
	},
	home: {
		tabs: {
			dailyLog: 'Journal quotidien',
			progress: 'Progrès',
		},
		buttons: {
			logActivity: 'Enregistrer une activité',
			logMeal: 'Enregistrer un repas',
			logWorkout: 'Enregistrer une séance',
			weighIn: 'Pesée',
			barcodeScan: 'Scanner un code-barres',
			labelScan: 'Scanner une étiquette',
		},
		hints: {
			nutritionTargetsWaiting: 'Les objectifs nutritionnels seront disponibles une fois vos photos évaluées. Cela ne devrait pas prendre plus de 48 h.',
			offlineNow: 'Vous êtes hors ligne. La synchronisation avec le cloud reprendra à votre reconnexion.',
		},
		messages: {
			noScheduleForDay: 'Il n\'y a pas de programme pour ce jour.',
		},
		emptyState: {
			allHidden: {
				title: 'Tous les éléments masqués',
				subtext: 'Vous avez masqué tous les éléments de cette section. Utilisez le bouton ci-dessous pour personnaliser ce qui apparaît ici.',
			},
			customizeButton: 'Personnaliser l\'accueil',
		},
		alerts: {
			workoutTimeLabel: 'Heure de la séance',
		},
		settingsMenu: {
			customizeDashboard: 'Personnaliser le tableau de bord',
		},
		progress: {
			goalCard: {
				title: 'Objectif',
				target: 'Cible',
				progress: 'Progrès',
				fatLoss: 'Perte de graisse',
				weightLoss: 'Perte de poids',
				weightGain: 'Prise de poids',
				estimatedValueTooltip: 'La valeur actuelle est estimée par algorithme à partir de vos deux dernières semaines de mesures. La variation affichée est la différence depuis que vous avez défini cet objectif.',
				growthMindset: 'État d\'esprit de croissance',
				growthMindsetInfo: 'L\'état d\'esprit de croissance met l\'accent sur la constance et les progrès à l\'entraînement. L\'objectif est de développer la force et le muscle.',
				start: 'Départ',
				goal: 'Objectif',
				onTrack: 'Sur la bonne voie',
				offTrack: 'Hors des rails',
				undetermined: 'Indéterminé',
				notEnoughData: 'Nous n\'avons pas encore assez de mesures pour évaluer vos progrès. Continuez à enregistrer vos pesées et vos mesures de masse grasse.',
				measureMoreOften: 'Nous avons besoin de plus de mesures de masse grasse (mètre ruban ou pince à plis) pour déterminer si vous êtes sur la bonne voie ou non.',
				dataErratic: 'Vos mesures fluctuent beaucoup, ce qui rend difficile la détermination d\'une tendance claire. Essayez de mesurer dans des conditions constantes.',
				weightTooFlat: 'Vos relevés de poids sont étrangement identiques. Veuillez vérifier que votre balance fonctionne correctement.',
				insufficientFatnessConfidence: 'Nous ne sommes pas encore sûrs de la tendance de votre masse grasse. Ajoutez quelques mesures supplémentaires (mètre ruban ou pince à plis) avant que nous ajustions votre plan.',
				nutritionAdjusted: 'Nutrition ajustée il y a {N1} {{jour|jours}}. Continuez à enregistrer — l\'évaluation reprend dans environ {N2} {{jour|jours}}.',
				nutritionAdjustedToday: 'Nutrition ajustée aujourd\'hui. Continuez à enregistrer — l\'évaluation reprend dans environ {N2} {{jour|jours}}.',
				planJustStarted: 'Plan commencé il y a {N1} {{jour|jours}}. Continuez à enregistrer — l\'évaluation commence dans environ {N2} {{jour|jours}}.',
				planJustStartedToday: 'Plan commencé aujourd\'hui. Continuez à enregistrer — l\'évaluation commence dans environ {N2} {{jour|jours}}.',
			},
			bodyComposition: {
				title: 'Composition corporelle',
			},
			nutrition: {
				title: 'Nutrition',
			},
			coachingTips: {
				title: 'Conseils de coaching',
				noTips: 'Vous vous débrouillez très bien ! Continuez comme ça.',
			},
		},
	},
	editTrainingGoal: {
		title: 'Modifier les objectifs d\'entraînement',
		primaryGoal: 'Objectif principal',
		method: 'Méthode',
		targetUnit: 'Unité cible',
		targetUnitDescription: 'Choisissez comment vous souhaitez suivre votre progression',
		goalWeight: 'Poids objectif',
		goalBodyFat: 'Masse grasse objectif',
		growthMindset: 'État d\'esprit de progression',
		growthMindsetDescription: 'L\'état d\'esprit de progression met l\'accent sur la régularité et les progrès à l\'entraînement. L\'objectif est de gagner en force et en muscle.',
		fixedTarget: 'Cible fixe',
		fixedTargetDescription: 'Laissez l\'app suivre votre progression par rapport à un poids cible ou un pourcentage de masse grasse.',
		weight: 'Poids',
		bodyFatPercent: '% de masse grasse',
		fatLoss: 'Perte de gras',
		muscleGrowth: 'Prise de muscle',
		update: 'Mettre à jour',
		updateAlert: {
			title: 'Mettre à jour l\'objectif d\'entraînement',
			message: 'Modifier votre objectif peut nécessiter la reconstruction et le redémarrage complets de votre programme d\'entraînement.',
			updateGoal: 'Mettre à jour l\'objectif',
		},
	},
	consent: {
		cookies: {
			header: 'Des cookies zéro calorie, la meilleure sorte de cookies.',
			message: 'En cliquant sur « Tout accepter », vous acceptez que MH Physique puisse stocker des cookies sur votre appareil et divulguer des informations conformément à notre ',
			privacyPolicy: 'Politique de confidentialité',
			customize: 'Personnaliser',
			customizeHeader: 'Personnaliser les cookies',
			saveSettings: 'Enregistrer les réglages',
			acceptAll: 'Tout accepter',
			rejectAll: 'Tout refuser',
			required: 'Obligatoire',
			types: {
				functionality: {
					name: 'Fonctionnalité',
					description: 'Active le stockage qui prend en charge les fonctionnalités nécessaires au bon fonctionnement du site ou de l\'app, comme les réglages de langue.',
				},
				security: {
					name: 'Sécurité',
					description: 'Active le stockage lié à la sécurité, comme l\'authentification, la prévention de la fraude et d\'autres protections de l\'utilisateur.',
				},
				personalization: {
					name: 'Personnalisation',
					description: 'Active le stockage lié à la personnalisation, comme les recommandations de vidéos.',
				},
				advertising: {
					name: 'Publicité',
					description: 'Aide MH Physique à grandir : permet à nos partenaires publicitaires de savoir comment vous utilisez l\'app, pour que nos publicités atteignent les bonnes personnes et que nous voyions lesquelles fonctionnent.',
					gpcNotice: 'Publicité est désactivée car votre navigateur a envoyé un signal Global Privacy Control.',
				},
				performance: {
					name: 'Performance',
					description: 'Active le stockage, comme les cookies, lié à la performance du site et de l\'application, par exemple les options les plus utilisées. Nous utilisons cela pour améliorer l\'app.',
				},
			},
			chooseEach: 'Choisissez activé ou désactivé pour chaque option afin d\'enregistrer vos réglages.',
		},
		user: {
			header: 'Conditions et accords',
			subtitle: 'Ouvrez les liens ci-dessous et lisez attentivement les conditions. En continuant, vous reconnaissez avoir lu et accepté les conditions suivantes.',
			updatedHeader: 'Nous avons mis à jour nos Conditions et notre Politique de confidentialité',
			updatedSubtitle: 'Nous avons mis à jour nos conditions. Veuillez les consulter et les accepter pour continuer.',
			later: 'Plus tard',
			updatedCard: 'Nous avons mis à jour nos Conditions et notre Politique de confidentialité.',
			updatedCardAction: 'Consulter',
			reviewOffline: 'Vous êtes hors ligne. Connectez-vous à internet pour consulter la politique mise à jour.',
			additionalOptions: 'Options supplémentaires :',
			acceptAll: 'Tout accepter',
			tosLabel: 'Conditions d\'utilisation',
			healthLabel: 'Avertissement santé',
			privacyLabel: 'Politique de confidentialité',
			researchLabel: 'Aidez à améliorer l\'application en partageant des données d\'entraînement anonymisées à des fins d\'analyse.',
			marketingLabel: 'Recevez des conseils sur l\'application, les nouveautés et des offres occasionnelles.',
			advertisingLabel: 'Aider MH Physique à grandir : permettre à nos partenaires publicitaires de savoir comment j\'utilise l\'app, pour que nos publicités atteignent les bonnes personnes et que nous voyions lesquelles fonctionnent.',
			continue: 'Continuer',
			details: 'Détails',
			requiredError: 'Vous devez accepter les Conditions d\'utilisation, la Politique de confidentialité et l\'Avertissement santé pour continuer.',
			persistFailed: 'Nous n\'avons pas pu enregistrer votre accord. Veuillez vérifier votre connexion et réessayer.',
		},
	},
	profile: {
		title: 'Profil utilisateur',
		signOut: 'Se déconnecter',
		profileSection: 'Profil',
		subscriptionSection: 'Abonnement',
		subscription: 'Abonnement',
		subscriptionType: 'Type',
		subscriptionTypeMonthly: 'Mensuel',
		subscriptionTypeYearly: 'Annuel',
		renewalDate: 'Date de renouvellement',
		expiresOn: 'Expire le',
		renewalPrice: 'Prix de renouvellement',
		emailSupport: 'Contacter le support par e-mail',
		switchPlanPromo: 'Votre offre actuelle est « {current} ». Passez à « {other} » pour {price} et économisez {saving} !',
		perpetualLicense: 'Licence {type}',
		refreshingStatus: 'Actualisation du statut de l\'abonnement...',
		subscriptionInfoError: 'Impossible de charger les détails de l\'abonnement. Rouvrez cette page pour réessayer.',
		coachCoversMembership: 'Le forfait de votre coach couvre actuellement votre adhésion Premium. Vous payez également votre propre abonnement.',
		boostYourGains: 'Boostez vos gains !',
		upgradeToPremium: 'Passez à Premium et débloquez toutes les fonctionnalités, y compris les programmes d\'entraînement avancés, le suivi détaillé de la progression et les plans nutritionnels personnalisés.',
		upgradeNow: 'Passer à Premium',
		trialEndsOn: 'Votre essai se termine le {date}',
		trialCancelInfo: 'Si vous annulez maintenant, vous pouvez continuer à utiliser les fonctionnalités Premium jusqu\'à la fin de votre essai.',
		cancelSubscription: 'Annuler l\'abonnement',
		trialCanceled: 'Votre essai est annulé et se terminera le {date}',
		trialPaused: 'Votre essai sera suspendu le {date}',
		trialResumeInfo: 'Vous pouvez reprendre votre abonnement à tout moment avant la fin de l\'essai.',
		resumeSubscription: 'Reprendre l\'abonnement',
		currentPlanWithSaving: 'Votre offre actuelle est « {current} ». Vous pouvez passer à « {other} » pour {price} et économiser {saving} !',
		currentPlan: 'Votre offre actuelle est « {current} ». Vous pouvez passer à « {other} » pour {price}.',
		switchToPlan: 'Passer à {plan}',
		paymentFailing: 'Votre dernier paiement n\'a pas abouti. Nous continuerons d\'essayer, et votre abonnement reste actif entre-temps. Si le paiement échoue à nouveau, votre abonnement prendra fin le {date}.',
		paymentProcessing: 'Votre paiement est en cours de traitement.',
		paymentProcessingHelp: 'Cela ne prend généralement que quelques minutes. Revenez d\'ici peu.',
		subscriptionEnds: 'Votre abonnement se termine le {date}',
		resubscribeInfo: 'Vous pouvez reprendre votre abonnement à tout moment pour continuer à profiter des fonctionnalités Premium.',
		support: 'Support',
		reportIssueInfo: 'L\'app vous a semblé étrange, ou vous ne savez pas quoi faire ensuite ? La réponse que vous cherchez se trouve peut-être ici. Sinon, n\'hésitez pas à en discuter avec d\'autres membres de notre <a href="https://community.mh-physique.app/" target="_blank">Communauté</a>.',
		reportIssueInfoFeedback: 'Si vous ne parvenez pas à envoyer votre retour avec les boutons ci-dessus, vous pouvez aussi nous contacter par e-mail.',
		termsAndConditions: 'Conditions générales',
		privacyPolicy: 'Politique de confidentialité',
		healthDisclaimer: 'Avertissement santé',
		refundPolicy: 'Politique de remboursement',
		menu: {
			logout: 'Se déconnecter',
			deletePrivateData: 'Supprimer les données privées',
		},
		deleteData: {
			title: 'Êtes-vous sûr ?',
			message: 'Cela supprimera toutes vos données privées des serveurs et de cet appareil. Votre compte et votre abonnement seront conservés, mais tout votre historique d\'entraînement et de nutrition sera perdu à jamais. Notez que certaines données peuvent toujours subsister sur d\'autres appareils si vous vous y êtes connecté auparavant.',
			deleteButton: 'SUPPRIMER',
			deleting: 'Suppression de toutes les données utilisateur...',
			error: 'Impossible de purger le compte. Veuillez réessayer plus tard.',
		},
		signOutOfflineWarning: {
			title: 'Se déconnecter sans téléverser ?',
			message: 'Certaines de vos modifications récentes n\'ont pas encore été téléversées vers le cloud. Si vous vous déconnectez maintenant, ces modifications seront supprimées de cet appareil et ne pourront pas être récupérées. Pour les conserver, restez connecté, assurez-vous d\'avoir une connexion internet qui fonctionne et laissez à l\'app un moment pour terminer le téléversement avant de vous déconnecter.',
			signOutAnyway: 'Se déconnecter quand même',
		},
		reportProblemEmail: {
			subject: 'Issue-name-goes-here',
		},
		contactSupport: {
			title: 'Contacter le support',
			message: 'Contactez-nous par e-mail à {email}. Copiez l\'adresse ci-dessous, ou ouvrez votre app d\'e-mail pour rédiger un message.',
			copyAddress: 'Copier l\'adresse',
			openMailApp: 'Ouvrir l\'app d\'e-mail',
			close: 'Fermer',
			copied: 'Adresse e-mail du support copiée',
			copyFailed: 'Impossible de copier. Veuillez copier l\'adresse affichée ci-dessus à la main.',
		},
		resubscribe: {
			confirm: 'Voulez-vous reprendre votre abonnement ?',
			success: 'Vous vous êtes réabonné avec succès. Nous devons redémarrer l\'application pour appliquer les changements.',
			confirmPaused: 'Reprendre votre abonnement ? Cela démarre une nouvelle période de facturation et débite maintenant votre moyen de paiement enregistré, sauf s\'il vous reste du temps déjà payé.',
		},
		manageSubscription: {
			title: 'Gérer l\'abonnement',
			emailSent: 'Nous avons envoyé un lien de connexion à votre e-mail. Utilisez-le pour accéder au portail de compte de PayPro Global afin de gérer votre abonnement, consulter vos factures et mettre à jour vos moyens de paiement.',
		},
		googlePlayCancel: {
			confirm: 'Annuler votre abonnement ? Vous conserverez l\'accès jusqu\'à la fin de votre période de facturation actuelle.',
			confirmButton: 'Annuler l\'abonnement',
			success: 'Votre abonnement a été annulé. Vous conserverez l\'accès jusqu\'au {date}.',
			error: 'Échec de l\'annulation de l\'abonnement. Veuillez réessayer.',
		},
		paddleStaleState: 'Votre abonnement a changé ailleurs, donc cette action ne s\'applique plus. Rouvrez cette page pour voir son état actuel.',
		paddleCancel: {
			confirm: 'Annuler votre abonnement ? Vous conserverez l\'accès jusqu\'à la fin de votre période de facturation actuelle.',
			confirmImmediate: 'Annuler votre abonnement ? Votre abonnement est en pause, donc l\'annuler y met fin immédiatement.',
			confirmButton: 'Annuler l\'abonnement',
			successImmediate: 'Votre abonnement a été annulé.',
			error: 'Échec de l\'annulation de l\'abonnement. Veuillez réessayer.',
			successScheduled: 'Votre abonnement a été annulé. Vous conserverez l\'accès jusqu\'à la fin de votre période de facturation actuelle.',
			alreadyScheduled: 'Votre abonnement est déjà programmé pour être annulé, vous n\'avez donc rien de plus à faire. Vous conserverez l\'accès jusqu\'à la fin de votre période de facturation actuelle.',
		},
		subscriptionPausesOn: 'Votre abonnement sera suspendu le {date}',
		subscriptionPaused: 'Votre abonnement est en pause. Reprenez-le quand vous voulez pour récupérer votre accès.',
		appleCancel: {
			confirm: 'Pour annuler votre abonnement, nous allons ouvrir la gestion des abonnements d\'Apple, où vous pourrez l\'annuler.',
			confirmButton: 'Gérer l\'abonnement',
			success: 'Si vous avez annulé dans la gestion des abonnements d\'Apple, votre accès se poursuivra jusqu\'à la fin de votre période de facturation actuelle.',
			error: 'Impossible d\'ouvrir la gestion des abonnements. Vous pouvez gérer votre abonnement dans les Réglages de votre appareil, sous votre compte Apple.',
		},
		appleResume: {
			confirm: 'Pour reprendre votre abonnement, nous allons ouvrir la gestion des abonnements d\'Apple, où vous pourrez réactiver le renouvellement automatique.',
			confirmButton: 'Gérer l\'abonnement',
			success: 'Si vous avez réactivé le renouvellement automatique dans la gestion des abonnements d\'Apple, votre abonnement continuera à se renouveler automatiquement.',
			error: 'Impossible d\'ouvrir la gestion des abonnements. Vous pouvez gérer votre abonnement dans les Réglages de votre appareil, sous votre compte Apple.',
		},
		subscribedViaOtherPlatform: 'Votre abonnement est géré via {provider}. Ouvrez cette plateforme pour gérer votre abonnement.',
		subscribedViaWeb: 'Votre adhésion est gérée sur le web. Connectez-vous sur notre site pour effectuer des changements.',
		webMembershipProblem: 'Nous n\'avons pas pu charger les détails de votre abonnement, nous ne pouvons donc pas le modifier ici pour le moment. Votre abonnement est facturé sur notre site web — connectez-vous là-bas pour le gérer, ou contactez le support et nous vous aiderons.',
		switchPlan: {
			confirm: 'Voulez-vous changer votre offre pour {plan} au prix de {price} ?',
			confirmNoPrice: 'Voulez-vous changer votre plan pour {plan} ? La différence de prix pour le reste de votre période actuelle sera débitée ou créditée immédiatement, via votre moyen de paiement enregistré.',
			success: 'Vous avez changé d\'offre avec succès. Nous devons redémarrer l\'application pour appliquer les changements.',
			scheduledConfirm: 'Votre offre passera à « {plan} » à la fin de votre cycle d\'abonnement actuel, le {date}.',
			error: 'Échec du changement d\'offre.',
			trialNotSupported: 'Le changement d\'offre est disponible après la fin de votre essai. Vous pourrez changer d\'offre une fois votre premier paiement effectué, ou annuler maintenant et acheter une autre offre à l\'expiration de l\'essai.',
			grantedPriceWouldBeLost: 'Vous bénéficiez d\'un tarif spécial convenu avec vous, et ce tarif s\'applique uniquement à votre offre actuelle. Changer d\'offre vous ramènerait au tarif standard, alors contactez le support et nous effectuerons le changement en conservant votre tarif.',
			notYetConfirmed: 'Votre changement d\'offre a bien été effectué sur la boutique. Nous n\'avons pas pu terminer de le confirmer à l\'instant, mais il devrait s\'appliquer tout seul d\'ici quelques minutes. Inutile de réessayer.',
		},
		pendingPlanChange: 'Votre offre doit passer à « {plan} » le {date}.',
		pausesOn: 'En pause le',
	},
	intake: {
		title: {
			updateProgram: 'Mettre à jour le programme d\'entraînement',
		},
		steps: {
			basicInfo: 'Informations de base',
			bodyComposition: 'Composition corporelle',
			strength: 'Force',
			lifestyle: 'Mode de vie',
			advancedTraining: 'Entraînement avancé',
			schedule: 'Planning',
			nutritionOptions: 'Options de nutrition',
			goals: 'Objectifs',
			trainingVolume: 'Volume d\'entraînement',
			energyBalance: 'Balance énergétique',
			programOverview: 'Aperçu du programme',
			firstWorkoutHandoff: 'Commencer',
		},
		step: 'Étape {current} sur {total}',
		validation: {
			selectOption: 'Veuillez sélectionner une option',
			checkInputs: 'Veuillez vérifier vos saisies et assurez-vous que tous les champs obligatoires sont correctement remplis.',
			gender: 'Veuillez indiquer votre sexe. La nutrition et la planification des séances en dépendent fortement.',
			age: 'Nous avons besoin de votre âge pour en tenir compte et optimiser le programme.',
			ageMinimum: 'Vous devez avoir 18 ans ou plus pour utiliser cette application.',
			ageTooOld: 'Vous ne pouvez pas être aussi âgé.',
			birthdayFuture: 'Oh, bonjour, cher visiteur du futur. Essayez encore. :)',
			height: 'Veuillez saisir votre taille',
			bodyMeasurements: 'Les mesures du doigt, du poignet et de la cheville sont d\'importants indicateurs génétiques. Appuyez sur le bouton d\'info ci-dessus pour en savoir plus.',
			weight: 'Veuillez indiquer votre poids actuel.',
			chooseOption: 'Veuillez choisir une des options.',
			weekdaySelection: 'Veuillez répondre oui ou non pour chaque jour de la semaine.',
			trainingDaysAtLeastOne: 'Sélectionnez les jours où vous vous entraînerez le plus souvent.',
			bothTimes: 'Veuillez saisir les deux heures. Pas besoin d\'être précis.',
			unknownField: 'Champ inconnu',
			internalError: 'Erreur interne [{code}]',
			strengthTooGoodToBeTrue: 'Cela semble trop beau pour être vrai. Pouvez-vous revérifier ces chiffres ?',
			strengthTestsNotLoaded: 'Appuyez sur Réessayer, ou sur Passer pour continuer sans statistiques de force.',
		},
		strength: {
			liftingStatsOptional: 'Statistiques de force (facultatif)',
			liftingStatsNote1: 'Indiquez le poids maximal x répétitions que vous estimez pouvoir soulever actuellement ou vos records personnels récents.',
			liftingStatsNoteHighlight: 'Plus c\'est proche d\'un maximum sur une répétition (1RM), mieux c\'est.',
			liftingStatsNote2: 'Si vous n\'avez aucune idée, laissez cet exercice vide.',
			addedWeightOnly: 'Saisissez uniquement le poids ajouté au-delà du poids de corps. S\'il n\'y en a pas, saisissez 0.',
			skipExerciseReason: 'Pourquoi voulez-vous ignorer cet exercice ?',
			neverTrained: 'Je n\'ai jamais fait cet exercice auparavant.',
			injuryOrEquipment: 'Je dois l\'éviter à cause d\'une blessure ou d\'un manque de matériel.',
			skipEstimate: 'Ignorer l\'estimation',
			selectExercisePlaceholder: 'Sélectionner un exercice',
			loadFailed: 'Les tests de force n\'ont pas pu être chargés. Vérifiez votre connexion Internet et appuyez sur Réessayer, ou sur Passer pour continuer sans statistiques de force.',
		},
		nutrition: {
			morningAppetite: 'Appétit matinal',
			morningAppetiteQuestion: 'Avez-vous naturellement faim le matin ?',
			mealFrequency: 'Fréquence des repas',
			mealFrequencyDescription: 'Choisissez combien de repas vous prévoyez de prendre chaque jour. (Astuce : pour de meilleurs résultats, mangez à des heures régulières et évitez de grignoter entre les repas.)',
		},
		nutritionOptions: {
			header: 'Options de nutrition',
			macroTargets: 'Cibles de macros',
			enabled: 'Activé',
			enabledNote: 'Je veux que l\'app prescrive des cibles de macros et de calories, et qu\'elle les mette à jour en fonction de ma progression.',
			disabled: 'Désactivé',
			disabledNote: 'Je ne veux pas que l\'app détermine mes cibles de macros.',
			macroTracking: 'Suivi des macros',
			trackInApp: 'Suivre dans l\'app',
			trackInAppNote: 'Je vais enregistrer mes repas dans cette app.',
			trackElsewhere: 'Suivre ailleurs',
			trackElsewhereNote: 'Je vais enregistrer mes repas sur papier ou dans une autre app (ou pas du tout).',
			trackingType: 'Type de suivi',
			flexibleNutrition: 'Nutrition flexible',
			flexibleNutritionNote: 'Vous travaillerez avec des fourchettes flexibles pour vos macros. La répartition exacte des macros n\'a souvent pas d\'effet significatif sur vos résultats.',
			fixedTargets: 'Cibles fixes',
			fixedTargetsNote: 'L\'app définit des cibles exactes de macronutriments pour chaque repas.',
		},
		goals: {
			physiqueGoal: 'Objectif de physique',
			physiqueGoalQuestion: 'Quel est votre objectif de forme principal ?',
			bareMinimum: 'Minimum',
			bareMinimumNote: 'S\'entraîner avec un volume minimal pour maintenir la masse musculaire actuelle.',
			balanced: 'Développement équilibré du corps entier',
			balancedNote: 'C\'est notre recommandation par défaut. Elle convient à la plupart des pratiquants loisir, athlètes et bodybuilders.',
			lowerBodyNote: 'Cette option est populaire chez les femmes qui veulent mettre en valeur le bas du corps, y compris les compétitrices Bikini Fitness et Wellness.',
			lowerBodyFocus: 'Focus bas du corps',
			lowerBodyFocusNote: 'Cette option est populaire chez les femmes qui veulent mettre en valeur le bas du corps, y compris les compétitrices Bikini Fitness et Wellness.',
			custom: 'Personnalisé',
			customNote: 'Laissez-moi décider comment personnaliser chaque groupe musculaire.',
			customizationNote: 'Vous pouvez personnaliser votre focus d\'entraînement pour chaque groupe musculaire.',
			bodyPartCustomization: 'Personnalisation par partie du corps',
			lowerBody: 'Bas du corps',
			upperBody: 'Haut du corps',
			primaryGoal: 'Objectif principal',
			trainingVolume: 'Volume d\'entraînement',
			maximize: 'Maximiser',
			maintain: 'Maintenir',
			shrink: 'Réduire',
			decideForMe: 'Décider pour moi',
			decideForMeDescription: 'Laissez l\'app déterminer la meilleure approche selon votre état actuel',
			fatLoss: 'Perte de gras',
			fatLossDescription: 'Se concentrer sur la perte de masse grasse tout en préservant le muscle',
			muscleGrowth: 'Prise de muscle',
			muscleGrowthDescription: 'Se concentrer sur le développement de la masse musculaire',
		},
		training: {
			selectDaysNote: 'Pour commencer, sélectionnez les jours qui représentent votre emploi du temps habituel. Vous pourrez les déplacer plus tard si besoin.',
			volumeDescription: 'Cela correspond au volume d\'entraînement hebdomadaire total pour les groupes musculaires que vous souhaitez développer. Les groupes musculaires non prioritaires pour la croissance auront un volume hebdomadaire plus faible.',
			currentPlanVolume: 'Programme actuel : {volume} séries/semaine',
			setsPerWeek: 'Séries par semaine :',
			recommendSwitchToMuscleGrowth: 'Votre masse grasse est maintenant assez basse pour vous concentrer sur la construction musculaire. Nous vous recommandons de passer votre objectif à Prise de muscle.',
			recommendSwitchToFatLoss: 'Votre masse grasse est maintenant assez élevée pour que la perte de gras passe en premier. Nous vous recommandons de passer votre objectif à Perte de gras.',
			slowAndSteady: 'Lent et régulier',
			slowAndSteadyDescription: 'La durabilité est ce qui compte le plus pour moi. Tant que j\'avance dans la bonne direction, le rythme de progression m\'importe peu.',
			balanced: 'Équilibré',
			balancedDescription: 'Je veux trouver un juste équilibre entre de bons résultats proportionnés à l\'effort et la durabilité.',
			maximumEffort: 'Effort maximal',
			maximumEffortDescription: 'Je ferai tout ce qu\'il faut pour obtenir un maximum de résultats (sans compromettre ma santé).',
			overreachingWarning: 'Attention : le rapport risque-bénéfice est mauvais à des volumes aussi élevés. Le risque de surmenage et de blessures est élevé pour une progression supplémentaire relativement faible.',
			calorie: 'Calorie',
			calorieDeficit: 'Déficit calorique :',
			calorieSurplus: 'Surplus calorique :',
		},
		advancedLabels: {
			progressionTesting: 'Test de progression',
			slot: 'Emplacement',
			sets: 'Séries',
			level: 'Niveau',
			otherSlotsLevel: 'Niveau des autres emplacements',
			intensityPeriodization: 'Intensité/Périodisation',
			slotIntensitiesJSON: 'JSON des intensités d\'emplacement',
		},
		labels: {
			gender: 'Sexe',
			male: 'Homme',
			female: 'Femme',
			birthdate: 'Date de naissance',
			height: 'Taille',
			weight: 'Poids',
			bodyfat: 'Pourcentage de masse grasse',
		},
		alerts: {
			progressSaved: 'Votre progression est enregistrée au fur et à mesure. Vous pouvez quitter et reprendre le formulaire à tout moment.',
			recalculateNeeded: 'Vous avez fait des modifications qui impactent d\'autres réglages, vous devrez recalculer avant de pouvoir accéder à certains onglets et mettre à jour votre programme.',
		},
		updateOptions: {
			title: 'Mettre à jour ton programme',
			intro: 'Tu as modifié certains réglages. Choisis ce que tu veux mettre à jour.',
			workoutsTitle: 'Tes séances',
			workoutsRebuild: 'Reconstruire mon programme',
			workoutsRebuildNote: 'Crée de nouvelles séances à partir de tes nouveaux réglages.',
			workoutsRebuildNoteWithCustomizations: 'Crée de nouvelles séances à partir de tes nouveaux réglages. Les exercices que tu as remplacés toi-même seront écrasés.',
			workoutsVolumesOnly: 'Mettre à jour seulement mon nombre de séries',
			workoutsVolumesOnlyNote: 'Garde tes exercices. Ajuste le nombre de séries que tu fais pour chacun.',
			workoutsKeep: 'Garder mes séances actuelles',
			workoutsKeepNote: 'Rien ne change dans ton entraînement.',
			nutritionTitle: 'Ta nutrition',
			nutritionUpdate: 'Mettre à jour mon objectif de calories',
			nutritionUpdateNote: 'Recalcule tes calories quotidiennes à partir de tes nouveaux réglages.',
			nutritionKeep: 'Garder mon objectif de calories',
			nutritionKeepNote: 'Tes calories quotidiennes restent à {target}.',
			nutritionKeepNoteNoTarget: 'Tes calories quotidiennes restent telles quelles.',
			warnKeepEnergyBalance: 'Ton nouveau déficit ou surplus ne changera pas tes calories quotidiennes, puisque tu gardes ton objectif actuel.',
			warnKeepGoal: 'Tu as changé d\'objectif. En gardant ton objectif de calories, tu continues à manger la quantité calculée pour ton objectif précédent.',
			warnKeepBodyData: 'Ton objectif de calories reste calculé avec ton poids et ta masse grasse précédents.',
			scrollToMessages: 'Fais défiler pour lire ce qui change',
			warnKeepActivityLevel: 'Tu as changé ton niveau d\'activité, mais en gardant ton objectif tes calories quotidiennes restent calculées pour ton niveau d\'activité précédent.',
			warnUpdateReplacesTarget: 'Ton objectif de {target} sera remplacé par {recommended}. Tu peux le redéfinir sur l\'écran de ton objectif nutritionnel quotidien.',
			warnUpdateReplacesTargetUnknown: 'Ton objectif de {target} sera remplacé par un nouvel objectif calculé. Tu peux le redéfinir sur l\'écran de ton objectif nutritionnel quotidien.',
		},
		buttons: {
			next: 'Suivant',
			back: 'Retour',
			skip: 'Passer',
			saveAndUpdate: 'Enregistrer et mettre à jour',
			recalculate: 'Recalculer',
		},
		lifestyle: {
			activityLevel: 'Niveau d\'activité, y compris cardio et sports',
			sedentary: 'Sédentaire',
			sedentaryNote: 'Exemple : vous avez un travail de bureau avec les tâches habituelles de la vie quotidienne.',
			somewhatActive: 'Modérément actif',
			somewhatActiveNote: 'Exemple : vous avez un long trajet à vélo, ou vous allez parfois courir ou faire du sport, mais vous êtes autrement plutôt sédentaire.',
			active: 'Actif',
			activeNote: 'Exemple : vous êtes coach sportif à plein temps, littéralement debout la majeure partie de la journée, ou vous faites beaucoup de sport en plus de la musculation.',
			veryActive: 'Très actif',
			veryActiveNote: 'Exemple : vous avez un travail physique et/ou vous faites de nombreuses activités physiquement exigeantes en plus de la musculation.',
			stressLevel: 'Niveau de stress',
			mildStress: 'Stress léger/occasionnel uniquement',
			mildStressNote: 'Exemple : étudiant en dehors de la période d\'examens.',
			averageStress: 'Stress moyen',
			averageStressNote: 'Exemple : travail à plein temps avec des échéances et des trajets.',
			highStress: 'Stress élevé',
			highStressNote: 'Exemple : environnement de travail très intense avec de grandes responsabilités.',
		},
		advanced: {
			myoReps: 'Myo-reps',
			myoRepsPrefer: 'Préférer (gain de temps)',
			myoRepsPreferNote: 'Vos séances seront aussi courtes que possible, tout en tenant compte de vos objectifs et de votre progression individuelle. Cela inclut l\'utilisation des myo-reps chaque fois que c\'est justifié.',
			myoRepsAvoid: 'Éviter (entraînement classique)',
			myoRepsAvoidNote: 'N\'utiliser que des séries droites classiques pour tous les exercices. Les myo-reps ne seront pas appliqués automatiquement. Cependant, vous pouvez toujours les activer pour les exercices adaptés à tout moment.',
			automatic: 'Automatique',
			myoRepsAutomaticNote: 'Les myo-reps seront mis en place pour vous chaque fois qu\'ils sont particulièrement bénéfiques.',
			rmTesting: 'Méthode d\'hypertrophie spécifique au muscle (test RM)',
			rmTestingPrefer: 'Préférer',
			rmTestingPreferNote: 'Vous effectuerez un test de force pour la plupart des exercices, et ensemble nous déterminerons vos répétitions cibles personnalisées.',
			rmTestingAvoid: 'Éviter',
			rmTestingAvoidNote: 'Nous vous donnerons une répétition cible pour chaque exercice, et vous trouverez le poids approprié lors de vos premières séances. Vous pourrez ensuite activer des répétitions cibles autorégulées.',
			calorieCycling: 'Cyclage calorique',
			calorieCyclingOn: 'Activé',
			calorieCyclingOnNote: 'Pour les pratiquants plus avancés très familiers avec le suivi de leurs macros, l\'app peut répartir davantage de nutriments dans vos fenêtres anaboliques (les repas après vos séances) et moins de nutriments en dehors de ces fenêtres. Cela améliore la répartition des nutriments — le ratio muscle/graisse que vous gagnez — selon certaines recherches.',
			calorieCyclingOff: 'Désactivé (plus simple)',
			calorieCyclingOffNote: 'Cela répartira vos macros de manière égale sur la semaine sans timing des nutriments, dans un style « if it fits your macros ».',
			myoRepsTooltip: 'Une technique efficace en temps utilisant une série d\'activation suivie de mini-séries en rest-pause courtes pour maximiser le stimulus musculaire.',
			rmTestingTooltip: 'Des tests de force pour autoréguler vos répétitions cibles (idéal pour les pratiquants avancés).',
			calorieCyclingTooltip: 'Répartit davantage de nutriments autour de vos séances et moins en dehors des fenêtres anaboliques pour améliorer la répartition des nutriments.',
		},
		schedule: {
			trainingFrequency: 'Fréquence d\'entraînement',
			daysPerWeek: 'Jours par semaine :',
			mealsPerDay: 'Repas par jour :',
			hoursPerNight: 'Heures par nuit :',
			sleep: 'Sommeil',
			sleepDescription: 'Combien d\'heures de sommeil avez-vous en moyenne par nuit ? Soyez réaliste !',
		},
		firstWorkout: {
			heading: 'Votre plan est prêt.',
			subheading: 'Voici ce qui se passe ensuite :',
			step1: 'Un court test de force définit vos poids de départ.',
			step2: 'Ensuite, l\'app met à jour votre entraînement et votre nutrition chaque semaine, selon vos performances.',
			startButton: 'Commencer votre première séance',
			finishLaterButton: 'Terminer, je commencerai plus tard',
		},
		planOverview: {
			successAlert: 'Votre programme personnalisé est prêt, optimisé pour vos objectifs d\'entraînement et de nutrition.',
			keepingProgramAlert: 'Votre programme d\'entraînement actuel restera inchangé. Vos autres réglages ont été mis à jour.',
			nutritionPlan: 'Plan nutritionnel',
			nutritionGoal: 'Votre objectif principal est actuellement défini sur',
			nutritionGoalSuffix: 'Les objectifs nutritionnels suivants sont conçus pour vous aider à atteindre ce but :',
			dailyAverageCalories: 'Calories moyennes quotidiennes',
			dailyAverageTooltip: 'Votre apport calorique moyen sur plusieurs jours, pas un objectif quotidien.',
			mealCalories: 'Calories par repas',
			mealCaloriesTooltip: 'Calories cibles par repas moyen. Les totaux hebdomadaires comptent plus que la précision par repas.',
			cutMealCalories: 'Calories des repas de sèche',
			cutMealTooltip: 'Calories cibles pour les repas en dehors de votre fenêtre anabolique.',
			bulkMealCalories: 'Calories des repas de prise de masse',
			bulkMealTooltip: 'Calories cibles pour les repas après un entraînement en résistance.',
			macroTabs: {
				day: 'Jour',
				bulkMeal: 'Masse',
				cutMeal: 'Sèche',
				perDay: 'Par jour',
				perMeal: 'Par repas',
			},
			macroTitles: {
				estimatedDailyAverage: 'Macros moyennes quotidiennes estimées',
				bulkMeal: 'Macros du repas de prise de masse',
				cutMeal: 'Macros du repas de sèche',
				daily: 'Macros quotidiennes',
				meal: 'Macros du repas',
			},
			macroMin: '(min)',
			macroMax: '(max)',
			protein: 'Protéines',
			carbs: 'Glucides',
			fat: 'Lipides',
			fiber: 'Fibres',
			workouts: 'Séances ({count})',
			workoutsDescription: 'Les séances suivantes ont été conçues pour vous, vous les alternerez chaque semaine.',
			learnMoreProgramming: 'En savoir plus sur le raisonnement derrière la programmation',
			edit: 'Modifier',
			gainWeightQuicker: 'Vous prendrez du poids plus vite à des pourcentages plus élevés, mais aller trop haut signifie prendre de la graisse.',
			loseWeightQuicker: 'Vous perdrez du poids plus vite à des pourcentages plus élevés, mais perdre du poids trop vite risque une perte de muscle.',
			currentPlan: 'Programme actuel : {percent} %',
			muscleLossWarning: 'Une perte de masse musculaire est probable avec votre sélection actuelle.',
			fatGainWarning: 'Une prise de graisse excessive est probable avec votre sélection actuelle.',
		},
		dedication: {
			slowAndSteady: 'Lent et régulier',
			slowAndSteadyNote: 'La durabilité est ce qui compte le plus pour moi. Tant que j\'avance dans la bonne direction, le rythme de progression m\'importe peu.',
			balanced: 'Équilibré',
			balancedNote: 'Je veux trouver un juste équilibre entre de bons résultats proportionnés à l\'effort et la durabilité.',
			maximumEffort: 'Effort maximal',
			maximumEffortNote: 'Je ferai tout ce qu\'il faut pour obtenir un maximum de résultats (sans compromettre ma santé).',
		},
		trainingSplit: {
			title: 'Répartition des séances',
			optimal: 'Optimale',
			optimalNote: 'L\'application optimise votre fréquence d\'entraînement par groupe musculaire, sans être limitée par un modèle prédéfini.',
			pushPullLegs: 'Poussée / Tirage / Jambes',
			pushPullLegsNote: 'Vous alternez entre des séances d\'exercices de poussée, puis de tirage, puis du bas du corps.',
			upperLower: 'Haut / Bas',
			upperLowerNote: 'Vous alternez entre des séances pour le haut du corps et pour le bas du corps.',
			fullBody: 'Corps entier',
			fullBodyNote: 'Vous travaillez chaque groupe musculaire principal à chaque séance.',
			availableAtFrequency: 'Disponible à partir de {minimum} séances par semaine',
		},
		testMode: {
			options: 'Options du mode test',
			novice: 'Débutant',
			intermediate: 'Intermédiaire',
			advanced: 'Avancé',
			initial: 'Initial',
		},
		loading: {
			analyzingFitness: 'Analyse des objectifs et du niveau de forme.\nCela peut prendre une minute ou deux.',
			generatingProgram: 'Génération d\'un programme d\'entraînement personnalisé.\nCela peut prendre une minute ou deux.',
			finishingPlan: 'Finalisation de votre plan et de votre planning...',
		},
		errors: {
			internalError: 'Erreur interne [{code}]. Veuillez actualiser la page et réessayer.',
			couldntGeneratePlan: 'Impossible de générer le plan de fitness.',
			subscriptionRequired: 'Votre abonnement n\'est pas actif, peut-être parce que le paiement n\'a pas abouti. Veuillez réessayer de vous abonner pour continuer.',
		},
		notes: {
			bodyfatEstimate: 'Quelle est la meilleure estimation de votre pourcentage de masse grasse que vous pouvez obtenir ?',
			immutableStats: 'Les informations de cette section ne peuvent pas être modifiées une fois le formulaire d\'inscription terminé. Si vous devez modifier ces informations plus tard, vous devrez effacer vos données et recréer votre compte dans les Réglages.',
		},
	},
	fatalError: {
		title: {
			whoops: 'Oups...',
			testError: 'Erreur fatale de test',
			storageNotResponding: 'Le stockage de votre appareil ne répond pas',
		},
		messages: {
			cantAccessData: 'Impossible d\'accéder aux données locales hors ligne.',
			testError: 'Une erreur fatale de test s\'est produite.',
			appFailedToStart: 'L\'app n\'a pas réussi à démarrer.',
			lockdownMode: 'Le mode isolement est activé sur votre appareil.',
			serverError: 'Impossible de se connecter au serveur.',
			localStorageWedged: 'L\'application n\'arrive pas à accéder à la copie hors ligne de vos données sur cet appareil. Votre compte et tout ce qui est déjà synchronisé sont en sécurité sur nos serveurs.',
			resetLocalDataOffer: 'Si cela ne suffit pas, vous pouvez repartir de zéro avec la copie de cet appareil. Tout ce qui est déjà synchronisé sera téléchargé à nouveau ; ce qui a été enregistré sur cet appareil sans être encore synchronisé sera perdu.',
		},
		help: {
			tryAgainLater: 'Veuillez réessayer plus tard.',
			retryOrLogout: 'Si réessayer ne fonctionne pas, essayez de vous déconnecter puis de vous reconnecter.',
			testError: 'Simple test, veuillez ignorer.',
			retryOrRelogin: 'Veuillez réessayer, ou essayez de vous déconnecter puis de vous reconnecter.',
			disableLockdown: 'Veuillez désactiver le mode isolement sur votre appareil puis réessayer, ou contactez le support si le problème persiste après.',
			storageForceQuitIos: 'Fermer l\'onglet ne résoudra pas le problème. Fermez complètement l\'application (faites-la glisser hors du sélecteur d\'applications), puis rouvrez-la.',
			storageRestartApp: 'Fermez complètement l\'application, puis rouvrez-la.',
			storageRestartBrowser: 'Fermez et rouvrez votre navigateur, puis ouvrez à nouveau l\'application.',
		},
		buttons: {
			retry: 'Réessayer',
			logout: 'Se déconnecter',
			resetLocalData: 'Repartir de zéro sur cet appareil',
		},
		support: {
			prefix: 'Si ce qui précède ne vous aide pas et que le problème persiste, veuillez contacter',
		},
		alerts: {
			resetLocalDataTitle: 'Repartir de zéro sur cet appareil ?',
			resetLocalDataMessage: 'Votre compte est en sécurité, et tout ce qui est déjà synchronisé sera téléchargé à nouveau. Ce qui a été enregistré sur cet appareil sans être encore synchronisé sera perdu.',
		},
	},
	calorieChange: {
		decrease: 'Diminuer',
		increase: 'Augmenter',
		self: {
			less: '{percent} % de moins que les {base} kcal que vous avez indiquées, soit {kcal} kcal.',
			more: '{percent} % de plus que les {base} kcal que vous avez indiquées, soit {kcal} kcal.',
			same: 'Identique aux {base} kcal que vous avez indiquées.',
		},
		coach: {
			less: '{percent} % de moins que les {base} kcal indiquées, soit {kcal} kcal.',
			more: '{percent} % de plus que les {base} kcal indiquées, soit {kcal} kcal.',
			same: 'Identique aux {base} kcal indiquées.',
		},
		belowMinimum: '{kcal} kcal est inférieur à {minimum} kcal, l\'objectif le plus bas que l\'application fixerait. Votre nombre est utilisé tel que saisi. L\'application peut le relever à {minimum} kcal la prochaine fois qu\'elle recalcule le plan.',
	},
	nextIntake: {
		title: 'Apport de la semaine prochaine',
		now: 'Actuellement {kcal} kcal/jour',
		sourceLogged: 'Apport quotidien moyen de la semaine dernière (enregistré)',
		sourceTargetSelf: 'Votre objectif calorique, indiqué comme l\'apport de la semaine dernière',
		sourceTargetCoach: 'Son objectif calorique, indiqué comme l\'apport de la semaine dernière',
		sourceCustom: 'Saisi à la main comme l\'apport de la semaine dernière',
		recommendedChange: 'Recommandé : {change} kcal/jour ({percent} %) → {kcal} kcal/jour',
		recommendedChangeNoPercent: 'Recommandé : {change} kcal/jour → {kcal} kcal/jour',
		recommendedKeep: 'Recommandé : garder {kcal} kcal/jour',
	},
	bodyCompOverview: {
		progressCheck: 'Contrôle des progrès',
		statusOnTrack: 'En bonne voie',
		statusOffTrack: 'Hors trajectoire',
		statusUndetermined: 'Pas encore de verdict',
		statusInfoHome: {
			onTrack: 'Évalué sur les 14 derniers jours : ta progression correspond à ton objectif, ton plan n\'a donc pas besoin de changer.',
			offTrack: 'Évalué sur les 14 derniers jours : ta progression ne correspond pas à ton objectif, ton plan doit donc changer.',
			undetermined: 'L\'app ne peut pas encore évaluer les 14 derniers jours, par exemple après un changement de plan ou avec trop peu de mesures.',
		},
		statusInfoCheckup: {
			onTrack: 'Évalué sur les 14 jours avant ce bilan : ton plan n\'avait pas besoin de changer.',
			offTrack: 'Évalué sur les 14 jours avant ce bilan : ton plan devait changer.',
			undetermined: 'Ce bilan n\'a pas pu évaluer les 14 jours précédents, par exemple après un changement de plan ou avec trop peu de mesures.',
		},
		fatTrendDown: 'Ta masse grasse diminue',
		fatTrendUp: 'Ta masse grasse augmente',
		fatTrendUnclear: 'Ta masse grasse n\'a pas de direction claire',
		notEnoughFatReadings: 'Pas assez de mesures de plis ou de tour de taille pour une tendance',
		notEnoughWeighIns: 'Pas assez de pesées pour une tendance',
		readFromSkinfolds: 'd\'après tes plis cutanés',
		readFromWaist: 'd\'après ton tour de taille',
		trendWithSource: '{trend}, {source}.',
		skinfoldsWord: 'plis cutanés',
		waistWord: 'tour de taille',
		perWeek: '{value} {unit}/sem',
		ofBodyWeightPerWeek: 'du poids corporel par semaine',
		ofBodyWeightGainedPerWeek: 'du poids corporel gagné par semaine',
		ofBodyWeightLostPerWeek: 'du poids corporel perdu par semaine',
		countedFrom: 'Le contrôle a pris en compte les mesures à partir du {date}.',
		judgedOnLast14Days: 'Le verdict se base sur les 14 derniers jours. Cette carte montre la tendance sur la période choisie.',
		periodTrendOnly: 'Tendance sur la période choisie.',
		storedAtCheckup: 'Tel qu\'évalué quand ce bilan a été terminé.',
		weightResponse: 'Réponse du poids',
		atKcal: 'À {kcal} kcal/jour',
		baselineLogged: 'Moyenne enregistrée',
		baselineTarget: 'Objectif calorique',
		baselineCustom: 'Saisi à la main',
		intakeReportedOn: '{how}, indiqué lors du bilan du {date}.',
		fillsAfterFirstCheckup: 'Se remplit après votre premier bilan hebdomadaire.',
		weightNow: 'Dernière pesée {value} {unit}',
		energyIntake: 'Apport énergétique',
		avgKcalPerDay: '{kcal} kcal/jour en moyenne',
		daysCounted: '{counted} jours sur {total}',
		checkupWeek: 'Semaine du bilan {from} - {to}',
		legendLogged: 'Calories enregistrées',
		legendTarget: 'Calories cibles',
		mean: 'Moyenne',
		valueWithUnit: '{value} {unit}',
		readingsInRange: '{count} mesures sur cette période',
		adherence: 'Assiduité',
		adherenceCalories: 'Calories',
		adherenceTrainingDays: 'Jours d\'entraînement',
		adherenceDaysLogged: 'Jours enregistrés',
		ofTargetKcal: '/ {target} kcal',
		percentOfTarget: '{percent} % de l\'objectif',
		kcalPerDay: 'kcal/jour',
		ofTotal: 'sur {total}',
		noWorkoutsPlanned: 'Aucune séance prévue cette semaine-là.',
		noWeighIns: 'Aucune pesée sur cette période.',
		noFatReadings: 'Pas encore de mesures de plis ou de tour de taille.',
		loadFailed: 'Impossible de charger l\'aperçu.',
		retry: 'Réessayer',
	},
	trainingOverview: {
		title: 'Aperçu de l\'entraînement',
		notAvailable: 'Cette page n\'est pas disponible.',
		deletedExercise: 'Exercice supprimé',
		otherSessions: 'Autres séances',
		noLongerInWorkout: 'Ne fait plus partie de cette séance',
		columnExercise: 'Exercice',
		columnSets: 'Séries',
		columnLastSession: 'Dernière séance',
		showingSessions: '{shown} sur {total} {{séance affichée|séances affichées}}',
		showEarlier: 'Voir Plus Ancien',
		showLater: 'Voir Plus Récent',
		phoneNote: 'Dernière séance {date} · touchez un exercice pour son historique',
		skipped: 'passé',
		noWorkouts: 'Aucune séance enregistrée au cours des {weeks} dernières semaines.',
		noSessions: 'Pas encore de séances.',
		olderDownloading: 'Les séances plus anciennes sont encore en cours de téléchargement.',
		loadFailed: 'L\'aperçu de l\'entraînement n\'a pas pu être chargé.',
		retry: 'Réessayer',
		marks: {
			same: 'Pareil',
			down: 'En baisse',
		},
		markInfo: {
			same: 'Même poids et mêmes répétitions sur la première série que la dernière fois',
			down: 'Poids plus bas, ou même poids avec moins de répétitions, sur la première série que la dernière fois',
		},
		tags: {
			heavy: 'Lourd',
			medium: 'Moyen',
			light: 'Léger',
			test: 'Test',
			deload: 'Délestage',
			break: 'Pause',
			cap: 'Plafonné',
		},
		tagInfo: {
			heavy: 'Jour lourd',
			medium: 'Jour moyen',
			light: 'Jour léger',
			test: 'Test de force ou de répétitions',
			deload: 'Plus léger après un délestage',
			break: 'Plus léger après une pause d\'entraînement',
			cap: 'L\'app a limité le poids à ce que vous pouvez soulever maintenant',
		},
		menu: {
			exerciseSettings: 'Réglages de l\'exercice',
			history: 'Historique',
			editWorkouts: 'Modifier les séances',
		},
		programChanged: 'Le programme a changé pendant votre modification. Rien n\'a été enregistré.',
		saveFailed: 'Les réglages de l\'exercice n\'ont pas pu être enregistrés. Veuillez réessayer.',
		openOverview: 'Ouvrir l\'aperçu de l\'entraînement',
		upToToday: 'Entraînement jusqu\'à aujourd\'hui',
		tabTraining: 'Entraînement',
		checkupCount: '{same} identique, {down} en baisse',
	},
	dateRange: {
		week: 'Semaine',
		month: 'Mois',
		quarter: 'Trimestre',
		year: 'Année',
		all: 'Tout',
		twoWeeks: '2 sem',
		fourWeeks: '4 sem',
		eightWeeks: '8 sem',
		twelveWeeks: '12 sem',
	},
	dayItems: {
		titles: {
			weighIn: 'Pesée',
			weeklyCheckup: 'Bilan hebdomadaire',
			wakeUp: 'Réveil',
			sleep: 'Sommeil',
			restDay: 'Jour de repos',
			meal: 'Repas {number}',
			workout: 'Séance',
			workoutNamed: 'Séance {name}',
		},
		text: {
			reviewYourWeek: 'Passez votre semaine en revue',
		},
		alerts: {
			rescheduleWorkout: 'Vous n\'avez actuellement pas de séance programmée pour demain. Voulez-vous reprogrammer cette séance à demain ?',
		},
		warnings: {
			daysSinceLastWeighIn: 'Cela fait {days} {{jour|jours}} depuis votre dernière pesée.',
			weeksSinceLastWeighIn: 'Cela fait {weeks} {{semaine|semaines}} depuis votre dernière pesée.',
			longTimeSinceLastWeighIn: 'Cela fait longtemps que vous ne vous êtes pas pesé.',
			logWeightLink: 'Enregistrer le poids',
			planUpdateNeeded: 'Votre progression indique que votre programme d\'entraînement doit être mis à jour pour correspondre à vos capacités actuelles.',
			updateProgramLink: 'Mettre à jour le programme',
			pendingWorkout: 'Vous avez une séance non terminée du',
			unfinishedWeeklyCheckup: 'Vous avez un bilan hebdomadaire non terminé du',
			firstWorkoutReminder: 'Votre première séance a lieu le {day}. N\'oubliez pas de vous reconnecter !',
			coachLapseManageInApp: 'Gérer l\'Abonnement',
			coachLapseManageInStore: 'Pour le maintenir actif, mettez à jour cet abonnement dans les réglages d\'abonnement de votre magasin d\'applications.',
			coachPaymentFailedTitle: 'Votre paiement coach n\'a pas abouti',
			coachPaymentFailed: 'Nous n\'avons pas pu encaisser votre abonnement coach. Nous continuerons d\'essayer, mais si le paiement n\'aboutit pas, votre accès prendra fin le {date}.',
			coachPaymentFailedNoDate: 'Nous n\'avons pas pu encaisser votre abonnement coach. Nous continuerons d\'essayer, mais si le paiement n\'aboutit pas, vous perdrez votre accès.',
			coachNotRenewingTitle: 'Votre formule coach ne sera pas renouvelée',
			coachNotRenewing: 'Votre abonnement coach n\'est plus configuré pour se renouveler. Vous conservez l\'accès jusqu\'au {date}.',
			coachNotRenewingNoDate: 'Votre abonnement coach n\'est plus configuré pour se renouveler.',
			coachPlanStoppedTitle: 'Votre formule coach n\'est pas active',
			coachPlanStopped: 'Votre abonnement coach n\'est pas actif. Rien n\'a été supprimé : tout revient dès que l\'abonnement est de nouveau actif.',
			coachClientsWillLoseAccess: 'Cela touche aussi {count} de vos clients, qui perdr{{a|ont}} l\'accès Premium qu\'il couvre.',
			coachClientsLostAccess: 'Cela touche aussi {count} de vos clients, qui n\'{{a|ont}} plus l\'accès Premium qu\'il couvrait.',
			memberPaymentFailedTitle: 'Votre dernier paiement n\'a pas abouti',
			memberPaymentFailed: 'Nous n\'avons pas pu encaisser votre paiement. Nous continuerons d\'essayer, et votre abonnement reste actif entre-temps. Si le paiement échoue à nouveau, votre abonnement prendra fin le {date}.',
			memberPaymentFailedNoDate: 'Nous n\'avons pas pu encaisser votre paiement. Nous continuerons d\'essayer, et votre abonnement reste actif entre-temps. Si le paiement échoue à nouveau, votre abonnement prendra fin.',
			memberPaymentFailedViewMembership: 'Voir l\'Abonnement',
		},
		success: {
			weightChange: 'Votre changement de poids estimé est de {direction} {amount}{unit} / semaine.',
			viewProgress: 'Voir la progression',
		},
		info: {
			notEnoughWeightData: 'Nous avons besoin de quelques pesées supplémentaires pour estimer votre tendance hebdomadaire.',
		},
		badges: {
			mealPlanner: 'Planificateur de repas',
			mealPlannerInfo: 'Ce repas a été généré à l\'aide du Planificateur de repas, conçu pour correspondre à vos objectifs de macros. Les nutriments seront proches de vos objectifs, bien que de légères variations permettent souplesse et variété alimentaire.',
			macrosMatch: 'Dans la cible',
			macrosMatchInfo: 'Les macros de ce repas sont à moins de 5 % de vos objectifs. Bravo !',
		},
		buttons: {
			logMacrosManually: 'Enregistrer les macros manuellement',
			reschedule: 'Reprogrammer',
			markAsComplete: 'Marquer comme fait',
			addFood: 'Ajouter un aliment',
			logWeight: 'Noter le poids',
			resume: 'Reprendre',
			start: 'Démarrer',
			done: 'Fait',
		},
		skippedWorkout: {
			message: 'Séance déplacée au {date}.',
			moveToToday: 'Déplacer à aujourd\'hui',
			moveToTodayButton: 'Déplacer à aujourd\'hui',
			restore: 'Restaurer',
		},
		noWorkout: {
			nextWorkout: 'La prochaine séance est le {day}.',
			message: 'Entraîne-toi aujourd\'hui si tu veux.',
		},
	},
	unsavedChanges: {
		title: 'Appliquer les modifications ?',
		alerts: {
			incompleteData: 'Les données sont incomplètes et ne peuvent pas être enregistrées. Que veux-tu faire ?',
			applyChanges: 'Tu as des modifications non enregistrées. Veux-tu les appliquer avant de quitter ?',
		},
		errors: {
			saveFailed: 'Impossible d\'enregistrer tes modifications. Ton travail est toujours là - réessaie.',
		},
		buttons: {
			keepEditing: 'Continuer à modifier',
		},
		discard: {
			feedbackTitle: 'Abandonner tes commentaires ?',
			feedbackMessage: 'Tu ne les as pas encore envoyés. Si tu pars maintenant, ce que tu as écrit sera perdu.',
			coachMessageTitle: 'Abandonner ton message ?',
			coachMessageMessage: 'Tu ne l\'as pas encore envoyé. Si tu pars maintenant, ce que tu as écrit sera perdu.',
			noteTitle: 'Abandonner ta note ?',
			noteMessage: 'Tu n\'as pas encore enregistré cette note. Si tu pars maintenant, ce que tu as écrit sera perdu.',
			brandingTitle: 'Abandonner les modifications de ta marque ?',
			brandingMessage: 'Tu ne les as pas encore enregistrées. Si tu pars maintenant, ton logo, ta couleur et ton nom redeviendront ce qu\'ils étaient.',
			checkupTitle: 'Quitter le bilan hebdomadaire ?',
			checkupMessage: 'Tu ne l\'as pas encore terminé. Si tu pars maintenant, les réponses que tu as saisies seront perdues.',
			coachTargetTitle: 'Abandonner votre objectif calorique ?',
			coachTargetMessage: 'Vous ne l\'avez pas encore appliqué. Si vous partez maintenant, le nombre que vous avez saisi sera perdu.',
			nutritionPlanTitle: 'Abandonner tes modifications de calories et de macros ?',
			nutritionPlanMessage: 'Tu ne les as pas encore enregistrées. Si tu pars maintenant, les valeurs redeviendront ce qu\'elles étaient.',
			ingredientTitle: 'Abandonner tes modifications de cet ingrédient ?',
			ingredientMessage: 'Tu ne les as pas encore enregistrées. Si tu pars maintenant, la quantité redeviendra ce qu\'elle était.',
		},
	},
	training: {
		startWorkout: 'Commencer la séance',
		resumeWorkout: 'Reprendre la séance',
		openWorkout: 'Ouvrir la séance',
		skipWorkout: 'Ignorer aujourd\'hui',
		editWorkout: 'Modifier la séance {letter}',
		editWorkoutShort: 'Modifier la séance',
		changeWorkout: {
			title: 'Séance différente',
			description: 'Choisis la séance que tu souhaites effectuer à cette date.',
			menuOption: 'Séance différente',
		},
		workoutChangedInfo: 'Ce changement ne sera enregistré que lorsque tu commences la séance et termines au moins une série. Sinon, il sera réinitialisé après l\'actualisation de l\'application.',
		noWorkout: 'Aucune séance prévue pour ce jour',
		noWorkoutScheduled: 'Aucune séance prévue',
		nextWorkoutOn: 'Ta prochaine séance est le {day}.',
		trainAnyway: 'Veux-tu t\'entraîner aujourd\'hui ?',
		trainToday: 'S\'entraîner aujourd\'hui',
		workout: 'Séance',
		trainingProgram: {
			muscleVolume: 'Volume musculaire',
			workoutLetter: 'Séance {letter}',
			sets: 'Séries',
			myoReps: 'Myo-reps',
			rmTesting: 'Test de RM',
			set: 'Série',
			notCountedTitle: 'Pas encore compté',
			notCountedExplanation: 'Ces exercices n\'ont pas d\'« exercice le plus similaire » défini, donc nous ne pouvons pas savoir quels muscles ils sollicitent. Touches-en un pour le définir et l\'inclure dans le volume ci-dessus.',
			notCountedUntrackedTitle: 'Non mesuré par ce programme',
			notCountedUntrackedExplanation: 'Ces exercices sollicitent une zone du corps que ce programme ne mesure pas, ils ne peuvent donc pas être ajoutés aux totaux ci-dessus. Tu continues à les faire et à les enregistrer comme d\'habitude.',
			notCountedSummary: '{count} non compté(s)',
		},
		goals: {
			muscleGrowth: 'Croissance musculaire',
			bodyRecomposition: 'Recomposition corporelle',
		},
		emptyProgramDay: {
			message: 'Cette séance n\'a pas encore d\'exercices.',
			editLink: 'Ajouter des exercices',
		},
	},
	schedule: {
		warnings: {
			mealBeforeWorkout: 'Tu peux t\'entraîner à jeun, mais nous recommandons de prendre au moins un repas avant la séance.',
			mealAfterWorkout: 'Au moins un repas après une séance aide à maximiser la croissance musculaire.',
			minTimeBetweenMeals: 'S\'il y a moins de 3 heures entre deux repas, tu peux envisager de les combiner en un seul.',
			oneMealCloseToWo: 'Prendre un repas dans l\'heure qui précède ou suit la séance est bénéfique.',
			prePostWoMealDistance: 'Nous te suggérons d\'encadrer ta séance entre deux repas, espacés d\'au maximum 5 heures.',
			shortFeedingWindow: 'Le jeûne intermittent convient très bien, mais nous te suggérons de garder ta fenêtre d\'alimentation quotidienne totale (le temps entre le premier et le dernier repas) d\'au moins 8 heures.',
			workoutTimingIrregular: 'Entraîne-toi quand tu peux, mais nous te suggérons de t\'entraîner à peu près à la même heure chaque jour (d\'entraînement).',
			mealTimingIrregular: 'Tu peux manger quand tu veux, mais nous recommandons de prendre tes repas à peu près aux mêmes heures chaque jour.',
			sleepTimingIrregular: 'Si tu le peux, nous recommandons de te coucher et de te lever à peu près aux mêmes heures chaque jour.',
			shortSleep: 'Si tu peux dormir plus, tu devrais probablement le faire. Au moins 8 heures chaque nuit sont fortement recommandées.',
		},
		tips: 'Conseils sur le planning',
	},
	editFood: {
		labelScanLowConfidence: 'Faible confiance — vérifie les nutriments manuellement',
		labelScanJsonRepaired: 'La réponse de l\'IA a été tronquée — certains nutriments peuvent manquer',
		placeholders: {
			enterName: 'Saisir un nom',
		},
		labels: {
			servingSize: 'Taille de la portion',
			servingSizes: 'Mesures',
			measureName: 'Nom de la mesure',
			valuesPer: 'Pour',
			instructions: 'Instructions',
			labelStyle: 'Style d\'étiquette',
			details: 'Détails',
			source: 'Source :',
			barcode: 'Code-barres',
			noBarcode: 'Aucun code-barres',
			macros: 'Macros',
			nutrients: 'Nutriments',
			usLabel: 'Étiquette US',
			euLabel: 'Étiquette UE',
			serving: 'Portion',
			portion: 'portion',
			perPortionOfWeight: '{per} {portion} de {weight}',
			foodName: 'Nom de l\'aliment',
			image: 'Image',
			nutritionFacts: 'Valeurs nutritionnelles',
			nutritionInformation: 'Informations nutritionnelles',
			hideAdditionalNutrients: 'Masquer les nutriments supplémentaires',
			showAdditionalNutrients: 'Afficher les nutriments supplémentaires',
			description: 'Description',
		},
		buttons: {
			addServingSize: 'Ajouter une mesure',
			addImage: 'Ajouter une image',
			scanBarcode: 'Scanner le code-barres',
			log: 'Enregistrer',
			duplicate: 'Dupliquer',
			delete: 'Supprimer',
			editFood: 'Modifier l\'aliment',
			scanRecipe: 'Scanner une recette',
			useScannedBarcode: 'Celui que j\'ai scanné',
			useBarcodeOnLabel: 'Celui de l\'étiquette',
			useAnyway: 'Utiliser quand même',
			doubleCheck: 'Je vais vérifier',
			share: 'Partager la recette',
			unshare: 'Arrêter le partage',
			importRecipe: 'Importer dans mes recettes',
			recipeImported: 'Recette importée',
			linkCopied: 'Lien copié',
			updateAvailable: 'Mise à jour disponible',
			refreshFromOriginal: 'Actualiser',
			originalUnavailable: 'Recette d\'origine non disponible',
			importedRecipe: 'Recette importée',
			recipeRefreshed: 'Recette mise à jour',
			sharedRecipeInfo: 'Cette recette a été partagée avec toi.',
			shareFailed: 'Impossible de partager la recette. Réessaie.',
			unshareFailed: 'Impossible d\'arrêter le partage de la recette. Réessaie.',
			shareIngredientsFailed: 'Certains ingrédients n\'ont pas pu être publiés. La recette partagée risque de ne pas fonctionner correctement pour les autres.',
		},
		titles: {
			newRecipe: 'Nouvelle recette',
			newFood: 'Nouvel aliment',
		},
		tabs: {
			overview: 'Aperçu',
			ingredients: 'Ingrédients',
		},
		nutrients: {
			calories: 'Calories',
			totalFat: 'Lipides totaux',
			saturatedFat: 'Acides gras saturés',
			transFat: 'Acides gras trans',
			cholesterol: 'Cholestérol',
			sodium: 'Sodium',
			totalCarbohydrate: 'Glucides totaux',
			dietaryFiber: 'Fibres alimentaires',
			totalSugars: 'Sucres totaux',
			includesAddedSugars: 'Dont sucres ajoutés',
			protein: 'Protéines',
			vitaminD: 'Vitamine D',
			calcium: 'Calcium',
			iron: 'Fer',
			potassium: 'Potassium',
			energy: 'Énergie',
			fat: 'Lipides',
			saturates: 'dont acides gras saturés',
			carbohydrate: 'Glucides',
			sugars: 'dont sucres',
			fiber: 'Fibres',
			salt: 'Sel',
		},
		alerts: {
			inconsistentValues: 'Les valeurs semblent incohérentes !',
			confirmDelete: 'Es-tu sûr de vouloir supprimer ce(tte) {type} ?',
			removeBarcode: 'Retirer le code-barres',
			removeBarcodeMessage: 'Veux-tu retirer le code-barres {barcode} de cet aliment ?',
			confirmScannedBarcode: 'Est-ce le même produit ?',
			confirmScannedBarcodeMessage: 'Tu as scanné le code-barres {barcode}, mais aucun code-barres n\'a été trouvé sur cette étiquette. Veux-tu attribuer ce code-barres à ce nouvel aliment ?',
			barcodeMismatch: 'Deux codes-barres différents',
			barcodeMismatchMessage: 'Tu as scanné {scanned}, mais l\'étiquette indique {onLabel}. Lequel correspond à cet aliment ?',
			foodSourceBody: '{attribution}\n\n{trustNote}',
		},
		errors: {
			caloriesInconsistent: 'Les calories sont incohérentes avec les valeurs des macronutriments ! Environ {expectedCalories} kcal attendues.',
			nameRequired: 'Le nom de l\'aliment est requis.',
			ingredientRequired: 'Au moins un ingrédient doit être ajouté.',
			portionRequired: 'La taille de la portion est requise.',
			nutrientMissing: 'Nutriment clé manquant.',
			measureWeightRequired: 'Saisis le poids en grammes',
		},
		messages: {
			barcodeExists: 'Le code-barres existe déjà dans cet aliment.',
		},
		types: {
			recipe: 'recette',
			food: 'aliment',
		},
		foodSources: {
			appRecipe: {
				name: 'Recette MH Physique',
				shortName: 'Recette',
				description: 'Recette fournie et vérifiée par l\'équipe de l\'application MH Physique.',
			},
			community: {
				name: 'Aliment créé par la communauté',
				shortName: 'Communauté',
				description: 'Aliment créé par la communauté de l\'application MH Physique.',
			},
			staple: {
				name: 'Aliment de base MH Physique',
				shortName: 'Base',
				description: 'Un aliment courant vérifié par l\'équipe MH Physique, établi à partir de bases de données alimentaires fiables.',
			},
		},
		sourceFoods: {
			header: 'Établi à Partir de Ces Aliments',
			row: '{name} ({database})',
			nameUnavailable: 'Nom Non Disponible',
		},
		trustLevel: {
			official: 'Ce sont des informations alimentaires **très précises**, issues de bases de données vérifiées.',
			crowdsource: 'Ces informations alimentaires proviennent d\'une base de données modifiable par le public. Des erreurs sont souvent possibles. **Vérifie les valeurs toi-même avant de les utiliser !**',
			community: 'Ces informations alimentaires sont fournies par la communauté de l\'application MH Physique. Elles sont généralement de bonne qualité, mais des erreurs sont possibles. **Vérifie les valeurs toi-même avant de les utiliser !**',
		},
	},
	editMeal: {
		basedOn: 'D\'après {name}, {day}',
		recipeInstructions: 'Instructions de {name}',
		macrosLogged: 'Macros enregistrées',
		macrosRemaining: 'Macros restantes',
		dayMacrosLogged: 'Macros du jour enregistrées',
		dayMacrosRemaining: 'Macros du jour restantes',
		instructions: 'Instructions',
		skippedNotice: 'Vous avez sauté ce repas, donc ses aliments ne comptent pas dans les totaux de la journée.',
		buttons: {
			clear: 'Vider',
			saveAsRecipe: 'Enregistrer comme recette',
			copyFrom: 'Copier depuis un jour',
			scanMeal: 'Scanner le repas',
		},
		addToMeal: {
			title: 'Ajouter à ce repas',
			addFoodsDescription: 'Recherchez des aliments, recettes et repas',
			scanBarcode: 'Scanner un code-barres',
			scanBarcodeDescription: 'Un produit emballé',
			scanLabel: 'Scanner une étiquette',
			scanLabelDescription: 'Photographiez le tableau nutritionnel',
			logMacrosManuallyDescription: 'Saisissez directement les chiffres',
			scanMealDescription: 'Photographiez votre assiette',
			autoSuggestionsDescription: 'Complète le repas jusqu\'à vos objectifs restants',
			copyFromDescription: 'Le même repas un autre jour',
			short: {
				addFoods: 'Ajouter',
				scanBarcode: 'Code-barres',
				scanLabel: 'Étiquette',
				logMacrosManually: 'Macros',
				scanMeal: 'Repas',
				autoSuggestions: 'Suggestions',
				copyFrom: 'Copier un jour',
			},
		},
		placeholders: {
			recipeName: 'Saisir le nom de la recette',
		},
		labels: {
			recipeName: 'Nom de la recette',
		},
		alerts: {
			clearMealTitle: 'Vider {mealName} ?',
			deleteMealTitle: 'Supprimer {mealName} ?',
			clearMealMessage: 'Es-tu sûr de vouloir vider le contenu de ce repas ?',
			deleteMealMessage: 'Es-tu sûr de vouloir supprimer ce repas ?',
			cannotTuneTitle: 'Impossible d\'ajuster',
			cannotTuneMessage: 'Ce repas ne peut pas être ajusté pour correspondre à tes objectifs.\n\nL\'ajustement automatique modifie la quantité de chaque aliment du repas, il lui faut donc de la marge. Essaie d\'ajouter un autre aliment, ou un aliment d\'un autre groupe.',
			splitRecipesTitle: 'Diviser les recettes ?',
			splitRecipesMessage: 'Pour ajuster une recette, elle doit être divisée en ingrédients individuels. Veux-tu le faire maintenant ?',
			splitAndTune: 'Diviser et ajuster',
			tuneSuccessTitle: 'Conseils d\'ajustement',
			tuneSuccessMessage: 'Le repas a été ajusté au plus près possible, mais ne peut pas correspondre entièrement aux objectifs avec ces ingrédients.\n\nL\'ajustement automatique fonctionne mieux avec un repas complet contenant un mélange raisonnable de sources de protéines, de lipides, de glucides et idéalement de fibres.',
			mealOnTarget: 'Le repas correspond maintenant à l\'objectif',
			copyFromNoMatchTitle: 'Rien à copier',
			copyFromNoMatchMessage: 'Tu n\'as pas enregistré {mealName} le jour que tu as choisi. Choisis un autre jour ou ajoute les aliments à ce repas toi-même.',
			cannotTuneLockedTitle: 'Plus rien à ajuster',
			cannotTuneLockedMessage: 'Une partie de ce repas est verrouillée ou a été saisie à la main sous forme de macros, et l\'ajustement automatique ne peut modifier ni l\'une ni l\'autre. Ce qui reste ne lui suffit pas.\n\nDéverrouille un aliment, ou remplace une saisie manuelle par un vrai aliment, puis réessaie.',
		},
		toasts: {
			mealTuned: 'Le repas a été ajusté.',
			undoTuneFailed: 'Le repas n\'a pas pu être remis dans son état précédent.',
			mealAlreadyOptimal: 'Ce repas est déjà aussi proche de tes objectifs que l\'ajustement automatique peut le rendre.',
		},
		errors: {
			couldNotSizeSuggestions: 'Les suggestions de repas n\'ont pas pu être calées sur tes objectifs pour le moment. Réessaie.',
			autoTuneFailed: 'L’ajustement automatique a rencontré un problème et n’a pas pu ajuster ce repas. Réessaie.',
		},
	},
	mealPlan: {
		title: 'Planificateur de repas',
		dailyMacroTargets: 'Objectifs de macros quotidiens',
		emptyState: {
			selectDatesTitle: 'Sélectionne des dates pour commencer',
			selectDatesSubtext: 'Le Planificateur de repas génère automatiquement des repas qui correspondent à tes objectifs de macros quotidiens. Sélectionne les jours pour lesquels tu veux générer des repas.',
		},
		labels: {
			startDate: 'Date de début',
			numberOfDays: 'Nombre de jours',
		},
		duration: {
			days7: '7 jours',
			days14: '14 jours',
			untilSunday: 'Jusqu\'à dimanche prochain',
			untilSaturday: 'Jusqu\'à samedi prochain',
		},
		buttons: {
			generateMeals: 'Générer les repas',
			favorite: 'Favori',
			dontSuggest: 'Ne plus suggérer',
			copyMeals: 'Copier les repas',
			acceptAll: 'Tout accepter',
			editMeal: 'Modifier le repas',
			viewDetails: 'Voir les détails',
		},
		exitDialog: {
			title: 'Quitter le Planificateur de repas',
			message: 'Tu n\'as pas planifié tous tes repas pour la plage de dates sélectionnée. Comment veux-tu procéder ?',
			saveAndExit: 'Enregistrer mes sélections de repas actuelles.',
			keepPlanning: 'Continuer à planifier le reste de mes repas.',
			discardAndExit: 'Quitter sans enregistrer mes modifications.',
		},
		errors: {
			saveFailed: 'Impossible d\'enregistrer ton plan de repas. Tes jours planifiés sont toujours là — réessaie.',
			dayCouldNotBeOpened: 'Impossible d\'ouvrir {day} pour la planification, il a donc été ignoré. Tes autres jours ne sont pas concernés.',
		},
		copyDialog: {
			title: 'Copier le repas vers d\'autres jours',
			message: 'Sélectionne les jours vers lesquels tu souhaites copier {meals}.',
			selectAll: 'Tout sélectionner',
			copyButton: 'Copier les repas',
			multipleMeals: '{count} repas',
		},
	},
	mealSuggestions: {
		title: 'Suggestions de repas',
		replaceMealTitle: 'Remplacer le repas',
		match: 'Correspondance',
		targets: 'Objectifs',
		buttons: {
			viewRecipe: 'Voir la recette',
			addMeal: 'Ajouter le repas',
			replace: 'Remplacer',
		},
		errors: {
			serviceUnavailable: 'Impossible de joindre le service de planification des repas, réessayez plus tard.',
			recipeLibraryNotReady: 'Configuration de votre bibliothèque de recettes — réessayez dans une minute.',
		},
	},
	editNutritionPlan: {
		title: 'Modifier le plan nutritionnel',
		description: 'Ne modifiez votre plan nutritionnel que si vous savez combien de calories et de macros vous devez consommer selon votre propre suivi.',
		caloriesLabel: 'Calories',
		macronutrients: 'Macronutriments',
		autoAdjustLabel: 'Ajuster automatiquement les macros',
		autoAdjustTooltip: 'Lorsque cette option est activée, les objectifs de macronutriments se recalculent automatiquement pour maintenir des ratios optimaux quand vous changez votre objectif de calories. Lorsqu\'elle est désactivée, les objectifs de macros restent fixes, quels que soient les changements de calories.',
		proteinLabel: 'Protéines',
		carbsLabel: 'Glucides',
		fatLabel: 'Lipides',
		fiberLabel: 'Fibres',
		recommendedHint: 'Recommandé : {value}',
		carbFatRatioLabel: 'Ratio calorique glucides/lipides',
		resetRecommended: 'Réinitialiser les valeurs',
		calorieOvershoot: 'Les objectifs de macros dépassent votre objectif de calories',
		couldNotComputeTargets: 'Nous n\'avons pas pu calculer tes objectifs nutritionnels pour le moment, donc cet écran ne peut pas être ouvert. Réessaie dans un instant.',
	},
	addMacros: {
		title: 'Enregistrer les macros manuellement',
		defaultFoodName: 'Mon aliment personnalisé',
		labels: {
			foodName: 'Nom de l\'aliment',
		},
		placeholders: {
			enterFoodName: 'Saisissez le nom de l\'aliment',
		},
		warnings: {
			caloriesMismatch: 'Les calories ne correspondent pas aux macros définies',
		},
	},
	reschedule: {
		labels: {
			date: 'Date',
			weighIn: 'Pesée',
			wakeUp: 'Réveil',
			time: 'Heure',
			item: 'Élément',
			meal: 'Repas',
		},
		weighInHelpText: 'Pesez-vous à jeun le matin, après être allé aux toilettes.',
		weekdaySelect: {
			placeholder: 'Choisir un jour de la semaine',
			currentBadge: 'Actuel',
		},
		options: {
			thisDayOnly: {
				title: 'Appliquer uniquement à ce jour',
				description: 'Appliquer uniquement à ce {weekday}.',
			},
			allDays: {
				title: 'Appliquer à tous les jours',
				descriptionWakeUp: 'Faire de cette heure mon heure de réveil pour tous les jours.',
				descriptionWorkout: 'Faire de cette heure mon heure d\'entraînement pour toutes les séances.',
				description: 'Faire de cette heure mon heure de {itemName} pour tous les jours.',
			},
			thisWeekday: {
				title: 'Appliquer à ce jour de la semaine',
				descriptionWorkout: 'Déplacer définitivement cette séance à cette heure le {weekday}.',
				descriptionWakeUp: 'Faire de cette heure mon heure de réveil le {weekday}.',
				description: 'Faire de cette heure mon heure de {itemName} le {weekday}.',
			},
		},
		title: 'Reprogrammer {item}',
		titleWakeUpWeighIn: 'Reprogrammer le réveil et la pesée',
		errors: {
			timeAlreadyUsed: 'Cette heure est déjà utilisée par le repas {mealNumber}. Choisissez-en une autre.',
		},
	},
	pinnedNote: {
		viewTitle: 'Notes épinglées',
		description: 'Les notes épinglées restent visibles chaque fois que vous faites cet exercice.',
		placeholder: 'Ex. Notez des conseils sur le matériel ou des rappels que vous voulez toujours avoir sous la main.',
		title: 'Créer une note épinglée',
		titleEdit: 'Modifier la note épinglée',
	},
	setNote: {
		viewTitle: 'Note de série',
		title: 'Note de série',
		titleEdit: 'Modifier la note de série',
		description: 'Une note de série concerne 1 série précise d\'une séance. Vous pouvez la consulter sur la page de la séance et dans les statistiques d\'historique de l\'exercice.',
		placeholder: 'Ex. Notes sur cette série précise...',
	},
	editIngredient: {
		title: 'Modifier l\'ingrédient',
		logMacrosTitle: 'Enregistrer les macros manuellement',
		viewDetails: 'Voir les détails',
		details: 'Détails',
		date: 'Date',
		meal: 'Repas',
		foodName: 'Nom de l\'aliment',
		amount: 'Quantité',
		foods: 'Aliments',
		splitTitle: 'Diviser en aliments individuels',
		splitDescription: 'Cette recette est actuellement enregistrée comme un seul élément. Souhaitez-vous la diviser en ses ingrédients distincts pour pouvoir ajuster les quantités ?',
		splitIntoFoods: 'Diviser en aliments',
		splitAndAutoTune: 'Diviser et ajuster automatiquement les aliments',
		splitMealDescription: 'Divisez ce repas en aliments individuels et ajustez automatiquement leurs quantités pour atteindre vos objectifs.',
		splitMealDescriptionNoTargets: 'Divisez ce repas en aliments individuels pour pouvoir ajuster leurs quantités.',
		splitTuneNoSolutionToast: 'Tes aliments ont été divisés, mais l\'ajustement automatique n\'a pas trouvé de quantités qui correspondent à tes objectifs. Essaie d\'ajouter un autre aliment, ou ajuste les quantités toi-même.',
		splitTuneNoSolutionLockedToast: 'Tes aliments ont été divisés, mais une partie de ce repas est verrouillée ou a été saisie à la main sous forme de macros, et l\'ajustement automatique ne peut modifier ni l\'une ni l\'autre. Déverrouille un aliment ou remplace une saisie manuelle, puis réessaie.',
		caloriesMismatchWarning: 'D\'après la quantité de macronutriments, cet aliment devrait contenir environ {expectedCalories} calories.',
		foodAddedToast: 'Ajout de {food} {amount} à {meal}',
		foodAddedToastNoDestination: 'Ajout de {food} {amount}',
		undoFailedToast: 'Impossible de retirer cet aliment — le repas a changé depuis son ajout.',
		inconsistentNutrientsWarning: 'Les calories indiquées pour cet aliment ne correspondent pas à ses protéines, lipides et glucides, qui donnent environ {expectedCalories} kcal pour 100 g. Vérifiez les chiffres avant de l\'enregistrer, ou choisissez une autre fiche.',
		refuseHint: {
			withParts: 'Pesez-le sans {parts}. Environ {percent} % du poids à l\'achat n\'est pas consommé.',
			percentOnly: 'Les valeurs concernent la partie comestible. Environ {percent} % du poids à l\'achat n\'est pas consommé.',
			partsOnly: 'Pesez-le sans {parts}.',
			withPartsRough: 'Pesez-le sans {parts} pour une quantité précise. Si vous le pesez avant, environ {percent} % est généralement retiré, mais cela varie beaucoup.',
			percentOnlyRough: 'Les valeurs concernent la partie comestible. Pesez-le après l\'avoir préparé pour une quantité précise : environ {percent} % est généralement retiré, mais cela varie beaucoup.',
		},
		refuseParts: {
			shell: 'coquille',
			tail: 'queue',
			bone: 'os',
			skin: 'peau',
			fat: 'gras',
			peel: 'épluchure',
			pit: 'noyau',
			seeds: 'pépins',
			core: 'trognon',
			stem: 'tige',
			leaves: 'feuilles extérieures',
			rind: 'écorce',
			pod: 'cosse',
			husk: 'spathes',
			cob: 'épi',
			top: 'partie supérieure',
			root: 'racine',
			trimmings: 'parures',
		},
		weighedWith: {
			withParts: 'Pesé avec {parts}',
			asBought: 'Pesé tel qu\'acheté',
		},
		weighedWithNote: {
			typical: 'Compté comme {weight} consommés : {percent} % du poids est retiré.',
			rough: 'Compté comme environ {weight} consommés : environ {percent} % est généralement retiré, mais cela varie beaucoup.',
		},
	},
	ingredientSearch: {
		addFood: 'Ajouter un aliment',
		customFood: 'Aliment personnalisé',
		emptyState: {
			title: 'Sélectionnez des aliments pour votre repas',
			titleRecipe: 'Aucun aliment ajouté pour l\'instant',
		},
		buttons: {
			clearMeal: 'Vider le repas',
			lock: 'Verrouiller',
			unlock: 'Déverrouiller',
			viewAll: 'Tout voir',
			addFoods: 'Ajouter des aliments',
			logMacrosManually: 'Enregistrer les macros manuellement',
			autoSuggestions: 'Suggestions automatiques',
			editServingSize: 'Modifier la taille de la portion',
			viewFoodDetails: 'Voir les détails de l\'aliment',
			splitIntoFoods: 'Diviser en aliments',
			lockFood: 'Verrouiller l\'aliment',
			unlockFood: 'Déverrouiller l\'aliment',
			removeFood: 'Retirer l\'aliment',
			reorder: 'Réorganiser',
			done: 'Terminé',
		},
		tooltips: {
			lockFood: 'Verrouiller un aliment l\'empêche d\'être modifié lors de l\'ajustement automatique du repas.',
		},
		alerts: {
			removeTitle: 'Retirer l\'ingrédient ?',
			removeMessage: 'Voulez-vous vraiment retirer {name} ?',
		},
		errors: {
			foodDoesNotExist: 'L\'aliment n\'existe pas',
		},
		titleMeal: 'Aliments',
		repeatMeal: {
			sectionTitle: 'Refaire un repas récent',
			lastTimeIn: 'Dernière fois pour {meal}',
			add: 'Ajouter de Nouveau',
			addedToast: '{count} {{aliment|aliments}} ajouté{{|s}} à {meal}',
			addedToastNoDestination: '{count} {{aliment|aliments}} ajouté{{|s}}',
			undoFailedToast: 'Ces aliments n\'ont pas pu être retirés — le repas a changé depuis que vous les avez ajoutés.',
			couldNotRepeatToast: 'Ce repas n\'a pas pu être ajouté — il ne contient plus aucun aliment.',
		},
		splitToast: 'Divisé en {count} {{aliment|aliments}}',
		splitUndoFailedToast: 'La division n\'a pas pu être annulée — le repas a changé depuis.',
	},
	editExercise: {
		titles: {
			createExercise: 'Créer un exercice',
			editExercise: 'Modifier {name}',
			viewExercise: '{name}',
			relativeStrengthStandard: 'Standard de force relative',
			absoluteStrengthStandard: 'Standard de force absolue ({gender})',
		},
		labels: {
			name: 'Nom',
			id: 'ID',
			shortName: 'Nom court',
			advancedSettings: 'Réglages avancés',
			instructions: 'Instructions',
			videoUrl: 'URL de la vidéo',
			equipmentTemplate: 'Matériel',
			bodyweightPercent: '% du poids de corps',
			myoRep: 'Exercice myo-reps ?',
			rmTesting: 'Utiliser le test RM ?',
			referenceExercise: 'Exercice de référence',
			oneRMFactor: '% du facteur 1RM',
			bodyWeight: 'Poids de corps',
			similarExercise: 'Exercice le plus similaire',
		},
		placeholders: {
			exerciseName: 'Saisissez le nom de l\'exercice',
			shortName: 'Saisissez le nom court',
			instructions: 'Saisissez les instructions de l\'exercice',
			videoUrl: 'Collez un lien YouTube ou Vimeo',
			selectTemplate: 'Sélectionner...',
			selectExercise: 'Sélectionner un exercice',
		},
		hints: {
			bodyweightPercent: 'Le pourcentage de votre poids de corps soulevé pour ce mouvement.',
			similarExercise: 'Cela détermine la musculature ciblée.',
		},
		buttons: {
			addImage: 'Ajouter une image',
			previewInstructions: 'Aperçu des instructions',
			addAbsoluteStandard: 'Ajouter un standard absolu',
			addRelativeStandard: 'Ajouter un standard relatif',
			addWeightCategory: 'Ajouter une catégorie de poids',
			importExercise: 'Importer',
			refreshFromOriginal: 'Mettre à jour',
			revertToOriginal: 'Revenir à l\'original',
			checkForUpdate: 'Rechercher une mise à jour',
		},
		messages: {
			exerciseNotFound: 'Cet exercice n\'est plus disponible.',
			exerciseUnreadable: 'Impossible de charger cet exercice pour le moment. Reviens en arrière et réessaie dans un instant.',
			sharedWithYou: 'Cet exercice a été partagé avec vous.',
			youOwnThisExercise: 'Vous êtes l\'auteur de cet exercice.',
			updateAvailable: 'Une version mise à jour de cet exercice est disponible.',
			originalUnavailable: 'L\'exercice partagé d\'origine n\'est plus disponible.',
			importedExercise: 'Exercice importé',
			basedOn: 'Basé sur : {name}',
		},
		toasts: {
			exerciseImported: 'Exercice importé',
			importFailed: 'Échec de l\'importation de l\'exercice',
			exerciseRefreshed: 'Exercice mis à jour',
			refreshFailed: 'Échec de la mise à jour de l\'exercice',
			exerciseCustomized: 'Exercice personnalisé',
			revertedToOriginal: 'Rétabli à l\'original.',
			originalNoLongerAvailable: 'L\'original n\'est plus disponible.',
			couldNotReachExercises: 'Impossible d\'accéder à tes exercices pour le moment. Réessaie dans un instant.',
			checkForUpdateOffline: 'Impossible de rechercher des mises à jour — vous semblez être hors ligne.',
			partialUpdateApplied: '{count} modification(s) appliquée(s) depuis la source.',
			saveFailed: 'Échec de l\'enregistrement de l\'exercice',
		},
		alerts: {
			saveAndExit: {
				title: 'Enregistrer et quitter ?',
				message: 'Voulez-vous vraiment enregistrer vos modifications et quitter la page ?',
			},
			revertToOriginal: {
				title: 'Revenir à l\'original ?',
				message: 'Abandonner vos modifications et restaurer l\'original ?',
			},
			updateAvailable: {
				title: 'Mise à jour disponible',
				acceptButton: 'Accepter les modifications',
				ignoreButton: 'Ignorer',
				cancelButton: 'Annuler',
				updateRevisionButton: 'Mettre à jour la révision',
				noVisibleChangesBody: 'Aucune modification visible pour l\'utilisateur.',
				alreadyUpToDateToast: 'Déjà à jour',
				pickerApplyButton: 'Appliquer ({count})',
				pickerIgnoreButton: 'Ignorer',
				pickerCheckboxHint: 'Sélectionnez les modifications que vous voulez reprendre de la source.',
				pickerCurrentDescription: 'Description actuelle',
				pickerUpdatedDescription: 'Description mise à jour',
				toggledOn: 'Activé',
				toggledOff: 'Désactivé',
				descriptionChanged: 'Description modifiée',
				standardChanged: 'Standard de force modifié',
				empty: '(vide)',
				fieldDiffLabels: {
					name: 'Nom',
					shortname: 'Nom court',
					description: 'Description',
					videoUrl: 'URL de la vidéo',
					bw_pc: '% du poids de corps',
					allowMyoReps: 'Myo-reps autorisées',
					avoidRMTesting: 'Éviter le test RM',
					standard: 'Standard de force',
					equipmentTemplateId: 'Matériel',
					similarExerciseId: 'Exercice similaire',
				},
			},
		},
		errors: {
			invalidName: 'Nom invalide',
			unknownButton: 'Bouton de modification du matériel inconnu {button}',
		},
	},
	exerciseSwitch: {
		titles: {
			changeExercise: 'Changer d\'exercice',
			addExercise: 'Ajouter un exercice',
			pickExercise: 'Choisir un exercice',
		},
		placeholders: {
			searchExercise: 'Tapez le nom d\'un exercice...',
		},
		filters: {
			all: 'Tous',
			recommended: 'Recommandés',
			myExercises: 'Mes exercices',
			suggested: 'Suggérés',
			filterByCategory: 'Filtrer par catégorie',
		},
		messages: {
			recommendationInfo: 'Nous recommandons les exercices suivants comme remplacement, du plus au moins recommandé.',
		},
		buttons: {
			statsAndNotes: 'Statistiques et notes',
			description: 'Description',
			modify: 'Modifier',
			delete: 'Supprimer',
			share: 'Partager',
			checkForUpdate: 'Rechercher une mise à jour',
			update: 'Mettre à jour',
			createExercise: 'Créer un exercice',
			save: 'Enregistrer',
			add: 'Ajouter',
		},
		indicators: {
			updateAvailable: 'Mise à jour disponible',
		},
		emptyState: {
			noResultsTitle: 'Aucun résultat trouvé',
			noResultsSubtext: 'Essayez un autre terme de recherche',
		},
		alerts: {
			deleteExercise: {
				title: 'Supprimer l\'exercice',
				message: 'Voulez-vous vraiment supprimer « {name} » ? {extra}',
				neverUsed: 'Il n\'a jamais été utilisé dans une séance, il sera donc supprimé définitivement.',
				wasUsed: 'Il a été utilisé dans une séance. Il sera marqué comme supprimé et n\'apparaîtra plus dans la liste des exercices, mais vous pourrez le restaurer plus tard.',
			},
		},
		removeExercise: {
			title: 'Retirer l\'exercice',
			message: 'Voulez-vous vraiment retirer {exercise} de la séance {workout} ?',
		},
		linkWorkouts: {
			title: 'Partager la progression ?',
			message: '{exercise} figure déjà dans {workouts}. Si vous l\'utilisez aussi ici, les deux séances partagent une seule progression : les mêmes charges et répétitions, et une modification ultérieure de cet exercice dans une séance s\'applique aussi à l\'autre.',
			workoutName: 'la séance {workout}',
			share: 'Partager la progression',
		},
		alreadyInWorkout: {
			title: 'Déjà dans cette séance',
			message: '{exercise} figure déjà dans la séance {workout}. Choisissez un autre exercice, ou supprimez plutôt celui que vous modifiez.',
		},
		errors: {
			workoutNotFound: 'Séance {workoutId} introuvable',
			noSelectedItem: 'Aucun élément sélectionné lors de l\'acceptation du changement d\'exercice',
		},
		coachBadge: {
			label: 'Coach',
			info: 'De votre coach {coachName}',
			infoNoName: 'De votre coach',
		},
	},
	editTrainingProgram: {
		labels: {
			sets: '{count} {{série|séries}}',
		},
	},
	editWorkouts: {
		title: 'Modifier les séances',
		setsCount: '{count} séries',
		rmTesting: 'Test de RM',
		myoReps: 'Myo-reps',
		repsCount: '{count} répétitions',
		suggestedRepsCount: '~{count} répétitions',
		dupRepsCount: '{heavy}/{light} répétitions',
		suggestedDupRepsCount: '~{heavy}/{light} répétitions',
		tupRepsCount: '{heavy}/{medium}/{light} répétitions',
		suggestedTupRepsCount: '~{heavy}/{medium}/{light} répétitions',
		buttons: {
			save: 'Enregistrer',
			revert: 'Rétablir',
			deleteWorkout: 'Supprimer la séance {name}',
		},
		menu: {
			volumeOptimization: 'Optimisation du volume',
			scanWorkout: 'Scanner la séance',
			removeExercise: 'Retirer l\'exercice',
			moveExercise: 'Déplacer l\'exercice',
			moveExerciseTo: 'Déplacer l\'exercice vers...',
			workoutName: 'Séance {name}',
		},
		deleteWorkout: {
			confirmTitle: 'Supprimer la séance',
			confirmMessage: 'Voulez-vous vraiment supprimer la séance {name} ? Tous les exercices de cette séance seront retirés.',
			cannotDeleteTitle: 'Suppression impossible',
			cannotDeleteMessage: 'Vous devez avoir au moins une séance.',
		},
		removeExercise: {
			cannotRemoveLastTitle: 'Suppression impossible',
			cannotRemoveLastMessage: 'Ton plan a besoin d\'au moins un exercice, sinon toutes tes séances seraient vides. Ajoute d\'abord un autre exercice, ou remplace celui-ci par un exercice différent.',
		},
		revert: {
			title: 'Rétablir les modifications',
			message: 'Choisissez comment vous souhaitez rétablir vos modifications :',
			undoMessage: 'Cela annulera toutes les modifications effectuées lors de cette session.',
			undoButton: 'Annuler',
			undoSession: 'Annuler les modifications de la session',
			restoreOriginal: 'Restaurer le programme d\'origine',
			noChangesTitle: 'Aucune modification',
			noChangesMessage: 'Vous n\'avez effectué aucune modification lors de cette session.',
			notAvailableTitle: 'Non disponible',
			notAvailableMessage: 'La sauvegarde du programme d\'origine n\'est pas disponible pour les programmes créés avant l\'ajout de cette fonctionnalité.',
			confirmRestoreTitle: 'Restaurer le programme d\'origine',
			confirmRestoreMessage: 'Cela restaurera vos séances au programme issu de l\'intake ou de la dernière mise à jour du programme. Toutes les modifications effectuées après seront perdues.',
			restoreButton: 'Restaurer',
		},
		toast: {
			exerciseMoved: 'Exercice déplacé vers la séance {workout}. ',
			view: 'Voir',
		},
		alerts: {
			reoptimizeConfirm: {
				message: 'Voulez-vous que l\'application mette à jour les volumes de séries de vos exercices pour correspondre à votre volume hebdomadaire cible par groupe musculaire ? L\'ordre de vos exercices et la répartition de vos séances ne seront pas affectés. Seul le nombre de séries par exercice changera.',
				yes: 'Oui, réoptimiser mon volume',
				no: 'Non, ne pas mettre à jour mes volumes d\'exercices',
			},
			reoptimizeResult: {
				title: 'Volume réoptimisé',
				noChanges: 'Vos volumes de séries correspondent déjà à vos objectifs.',
			},
			reoptimizeLoading: 'Réoptimisation du volume...',
		},
		exercisesLoadFailed: {
			title: 'Impossible de charger vos exercices',
			message: 'Vos exercices n\'ont pas pu être chargés pour le moment. Vérifiez votre connexion et appuyez sur Réessayer.',
			saveRefused: 'Vos exercices n\'ont pas pu être chargés, donc rien n\'a encore été enregistré. Vos modifications sont conservées. Vérifiez votre connexion et réessayez.',
		},
		emptyWorkout: {
			title: 'Séance vide',
			message: 'La séance {name} n\'a aucun exercice. Ajoutez-y un exercice ou supprimez-la. Une séance vide apparaîtrait comme une journée vide dans votre entraînement.',
			messageSeveral: 'Les séances {names} n\'ont aucun exercice. Ajoutez-y des exercices ou supprimez-les. Une séance vide apparaîtrait comme une journée vide dans votre entraînement.',
			deleteSeveral: 'Supprimer les séances vides',
		},
	},
	exerciseConfiguration: {
		loadFailed: {
			title: 'Impossible de charger l\'exercice',
			message: 'Cet exercice n\'a pas pu être chargé pour le moment. Vérifiez votre connexion et réessayez.',
		},
		labels: {
			muscleGroup: 'Groupe musculaire',
			myoReps: 'Myo-reps',
			equivalentVolume: 'Volume équivalent',
			volume: 'Volume',
			myoRepsVolume: 'Volume myo-reps',
			rmTesting: 'Test de RM',
			repTarget: 'Répétitions cibles',
			heavyRepTarget: 'Répétitions cibles (lourd)',
			mediumRepTarget: 'Répétitions cibles (moyen)',
			lightRepTarget: 'Répétitions cibles (léger)',
			toBeDetermined: 'À déterminer',
		},
		options: {
			avoid: 'Éviter',
			prefer: 'Préférer',
			auto: 'Automatique',
		},
		buttons: {
			save: 'Enregistrer',
		},
		myoRepsVolumeOneSeries: '1 série d\'activation et {minisets} mini-séries',
		myoRepsVolumeMultipleSeries: '{count} séries d\'activation + {minisets} mini-séries',
		repTargetInfo: 'Les répétitions cibles seront déterminées lors de votre prochaine séance pour cet exercice.',
		repTargetInfoRMTesting: 'Les répétitions cibles seront déterminées une fois le test de RM terminé.',
		repTargetHint: {
			atLeast: 'Doit être d\'au moins {min} répétitions',
			atMost: 'Doit être d\'au plus {max} répétitions',
			between: 'Doit être entre {min} et {max} répétitions',
			dupBanner: 'Les séances lourdes et légères utilisent des répétitions cibles différentes. Gardez au moins {gap} répétitions d\'écart.',
			tupBanner: 'Les séances lourdes, moyennes et légères utilisent des répétitions cibles différentes. Gardez au moins {gap} répétitions d\'écart entre les séances voisines.',
		},
		toast: {
			repTargetRequired: 'Les répétitions cibles ne peuvent pas être vides.',
			repTargetTooLow: 'Les répétitions cibles doivent être d\'au moins {min} répétitions pour cet exercice.',
			dupLightTooLow: 'Les répétitions cibles légères doivent être d\'au moins {min} répétitions (lourd + {gap}).',
			dupHeavyTooHigh: 'Les répétitions cibles lourdes doivent être d\'au plus {max} répétitions (léger - {gap}).',
			tupLightTooLow: 'Les répétitions cibles légères doivent être d\'au moins {min} répétitions (moyen + {gap}).',
			tupMediumTooHigh: 'Les répétitions cibles moyennes doivent être d\'au plus {max} répétitions (léger - {gap}).',
			tupMediumTooLow: 'Les répétitions cibles moyennes doivent être d\'au moins {min} répétitions (lourd + {gap}).',
			tupHeavyTooHigh: 'Les répétitions cibles lourdes doivent être d\'au plus {max} répétitions (moyen - {gap}).',
		},
		coach: {
			intensity: 'Intensité',
			oneTarget: 'Cible unique',
			nextSessionOnly: 'Prochaine séance uniquement',
			nextWeight: 'Prochain poids',
			nextMinReps: 'Prochain minimum de répétitions',
			dayHeavy: 'Jour lourd',
			dayMedium: 'Jour moyen',
			dayLight: 'Jour léger',
			dayOne: 'Chaque séance',
			comesNext: 'Ce jour vient ensuite, lors de la prochaine séance de {exercise}.',
			nextSessionNote: 'L\'app les règle après chaque séance. Une modification ne s\'applique qu\'à la prochaine séance.',
			lastSession: 'Dernière séance : {weight} × {reps} le {date}.',
			calculatedFrom: 'Poids calculés à partir de la meilleure série récente, {weight} × {reps} le {date}. Vous pouvez les modifier.',
			strengthTestNext: 'Déterminé par un test de force lors de la prochaine séance.',
			calculateWeights: 'Calculer les poids',
			historyUnreadable: 'Les séances récentes n\'ont pas pu être lues, l\'intensité ne peut donc pas être modifiée pour le moment. Veuillez réessayer plus tard.',
			minRepsInvalid: 'Au moins 1 répétition, ou vide.',
			strengthAtLastDeload: 'Force au dernier délestage',
			deloadStrength: '{strength}. Un plateau est constaté si un délestage passe sous {limit}.',
			deloadStrengthNone: 'Pas encore.',
			plateauWaiting: 'Question de plateau en attente depuis le {date}. {client} n\'a pas encore répondu. Modifier l\'intensité ou l\'exercice y répond.',
			plateauWillAnswer: 'Enregistrer répond à la question de plateau en attente depuis le {date}. {client} ne sera pas sollicité.',
			volumeWaiting: 'Question de volume en attente depuis le {date}. {client} n\'a pas encore répondu. Modifier le volume y répond.',
			volumeWillAnswer: 'Enregistrer répond à la question de volume en attente depuis le {date}. {client} ne sera pas sollicité.',
			setAside: 'Mis de côté',
			setAsideNone: 'Non',
			setAsidePlateau: '{exercise} a été mis de côté le {date} après un plateau, jusqu\'au {until}.',
			setAsideWeakness: '{exercise} a été mis de côté le {date} après un résultat de point faible, jusqu\'au {until}.',
			bringBackNow: 'Réintégrer maintenant',
			broughtBack: '{exercise} sera de nouveau disponible une fois enregistré.',
			changes: 'Modifications',
			changesNone: 'Aucune modification pour l\'instant.',
			changeBy: '{who} : {what}',
			app: 'App',
			event: {
				plateau: 'Plateau détecté',
				deload: 'Délestage',
				weakness: 'Résultat de point faible',
				volumeUp: 'Volume augmenté d\'1 série',
				volumeDown: 'Volume réduit d\'1 série',
			},
			field: {
				scheme: 'Intensité {before} → {after}',
				targetReps: '{day} : répétitions cibles {before} → {after}',
				targetWeight: '{day} : prochain poids {before} → {after}',
				minReps: '{day} : prochain minimum de répétitions {before} → {after}',
				volume: 'Volume {before} → {after} séries',
				myo: 'Myo-reps modifiés',
				rmTesting: 'Test RM modifié',
				setAsideCleared: 'Exercice mis de côté réintégré',
				plateauAnswered: 'Question de plateau répondue',
				volumeQuestionAnswered: 'Question de volume répondue',
				none: '–',
			},
			advanced: 'Avancé',
			plateauWaitingSelf: 'Question de plateau en attente depuis le {date}. Modifier l\'intensité ou l\'exercice y répond.',
			plateauWillAnswerSelf: 'Enregistrer répond à la question de plateau en attente depuis le {date}.',
			volumeWaitingSelf: 'Question de volume en attente depuis le {date}. Modifier le volume y répond.',
			volumeWillAnswerSelf: 'Enregistrer répond à la question de volume en attente depuis le {date}.',
		},
	},
	equipment: {
		sections: {
			incrementWeights: 'Poids d\'incrément',
			barbellWeight: 'Poids de la barre',
			stackedWeights: 'Poids empilés',
			dumbbellWeights: 'Poids d\'haltères',
			plates: 'Disques',
		},
		stack: {
			additionalMicroloading: 'Disques de « micro-charge » supplémentaires (généralement magnétiques) que vous pouvez fixer à cette pile si nécessaire. Faites une entrée pour chaque disque.',
			additionalMicroloadingWeights: 'Disques de « micro-charge » supplémentaires (généralement magnétiques) que vous pouvez fixer aux poids si nécessaire. Faites une entrée pour chaque disque.',
			unsortedWeights: 'Les poids ne sont pas triés. Ils seront réordonnés lors de l\'enregistrement. Ou vous pouvez appuyer sur Nettoyer à droite pour le faire maintenant.',
		},
		labels: {
			template: '[Modèle]',
			usedIn: 'Utilisé dans : {exercises}',
			minimumWeight: 'Poids minimum',
			weightIncrement: 'Incrément de poids',
			bar: 'Barre',
			from: 'De :',
			to: 'À :',
			increments: 'Incréments :',
			collarWeightOptional: 'Poids des colliers (facultatif)',
			individualWeight: 'Poids individuel',
			noPlatesYet: 'Aucun disque pour l\'instant',
			filters: 'Filtres',
			equipmentType: 'Type d\'équipement',
			details: 'Détails',
			name: 'Nom',
			units: 'Unités',
			microPlatesOptional: 'Micro-disques (facultatif)',
			platesSummary: '{count} disques de {weight}',
			platesSummaryPairs: '{count} paires de {weight}',
			numberOfPairs: 'Nombre de paires',
			numberOfPlates: 'Nombre de disques',
			myEquipmentName: '{name} (perso)',
		},
		summary: {
			manual: 'Spécifié manuellement avec un minimum de {min} et des incréments de {inc}',
			bar: 'Barre de {bar} avec disques de {plates} (par paires)',
			barWithCollars: 'Barre de {bar} avec colliers de {collars} et disques de {plates} (par paires)',
			stack: 'Machine à colonne sélectionnant parmi {weights}',
			freePlates: 'Disques libres : {plates}',
			withMicroloading: '{base} avec microcharge {plates}',
			noPlates: 'sans disques',
			unknown: 'Équipement inconnu',
		},
		templates: {
			barbell: 'Barre',
			dumbbells: 'Haltères',
			plainPlates: 'Disques simples',
			freePlates: 'Disques libres',
			kettlebells: 'Kettlebells',
			cableMachine: 'Machine à poulies',
			customIncrements: 'Incréments personnalisés',
		},
		titles: {
			changeEquipment: 'Changer l\'équipement',
			equipment: 'Équipement',
			createEquipment: 'Créer un équipement',
		},
		placeholders: {
			search: 'Rechercher',
			enterName: 'Saisir un nom',
			noStackedWeights: 'Aucun poids empilé défini. Ajoutez-en un ci-dessous.',
			noWeightsSet: 'Aucun poids défini. Ajoutez-en un ci-dessous.',
			selectTemplate: 'Sélectionner...',
		},
		filters: {
			all: 'Tous',
			suggested: 'Suggérés',
			showTemplates: 'Afficher les modèles',
			showMine: 'Afficher les miens',
		},
		descriptions: {
			barPlates: 'Toutes les paires de disques dont vous disposez pour cette barre. Faites une entrée pour chaque paire.',
			plates: 'Disques libres sans barre (par exemple pour poser sur une machine ou accrocher à une ceinture). Les disques sont utilisés un à la fois, pas en paires.',
			stack: 'Poids empilés dans un ordre strict. Généralement sur une machine. Avec des disques de micro-charge si vous en avez.',
			manual: 'Utilisez ceci pour les poids que vous arrangerez vous-même manuellement. Vous devez pouvoir arranger tous les poids possibles selon les incréments donnés.',
		},
		notes: {
			barWeight: 'Poids de la barre elle-même.',
			bothCollars: 'Les deux colliers ensemble pèsent {weight}',
			keepEmptyCollars: 'Laissez vide si vous utilisez des colliers très légers ou aucun collier (comme dans la plupart des salles).',
		},
		buttons: {
			delete: 'Supprimer',
			duplicate: 'Dupliquer',
			modify: 'Modifier',
			create: 'Créer',
			createEquipment: 'Créer un équipement',
			addStackedWeight: 'Ajouter un poids empilé',
			addDumbbells: 'Ajouter des haltères',
		},
		messages: {
			wouldYouLike: 'Souhaitez-vous',
			noEquipmentDefined: 'Vous n\'avez encore défini aucun équipement.',
			showingOnlyCustom: 'Affichage de votre équipement personnalisé uniquement. Il y a {count} éléments masqués.',
			toCreateEquipment: 'que vous pouvez utiliser pour créer votre équipement',
		},
		emptyState: {
			noResultsTitle: 'Aucun résultat trouvé',
			noResultsSubtext: 'Nous n\'avons trouvé aucune correspondance pour votre recherche. Essayez d\'ajuster vos mots-clés ou vos filtres et relancez la recherche.',
			chooseTemplate: {
				title: 'Choisissez un modèle pour commencer',
				subtext: 'Sélectionnez un modèle d\'équipement ci-dessus pour débloquer des champs supplémentaires et créer votre nouveau type d\'équipement.',
			},
		},
		links: {
			showTemplates: 'afficher les modèles',
		},
		alerts: {
			deleteEquipment: {
				title: 'Supprimer l\'équipement ?',
				subtitle: 'Voulez-vous vraiment supprimer {name} ?',
				usedBy: 'Il est utilisé dans : {exercises}',
			},
		},
		errors: {
			unknownMode: 'Mode de recherche d\'équipement inconnu {mode}',
			unknownButton: 'Bouton de recherche d\'équipement inconnu {button}',
			attemptToApplyTemplate: 'Tentative d\'appliquer le modèle {id} comme équipement',
		},
		tutorial: {
			nameEquipment: 'Voici votre nouvel équipement basé sur un modèle officiel. Donnez-lui un nom que vous reconnaîtrez.',
			adjustValues: 'Ce ne sont que des valeurs d\'exemple. Veillez à les ajuster à votre équipement spécifique !',
			saveEquipment: 'Lorsque vous êtes sûr que l\'équipement est correct, appuyez ici pour l\'enregistrer.',
		},
		validation: {
			invalidName: 'Nom invalide',
			incrementHelp: 'Réglez l\'« incrément » sur la plus petite quantité dont vous pouvez augmenter le poids. Par exemple, si le plus petit disque d\'une barre fait 0,5 kg, réglez l\'incrément sur 1 kg, car vous devrez ajouter deux disques.',
			minimumHelp: 'Réglez le minimum sur le poids le plus faible utilisable pour cet exercice. Par exemple, le poids d\'une barre vide.',
			barWeightRequired: 'Le poids de la barre est obligatoire.',
			unknownField: 'Champ inconnu',
			unknownEquipmentType: 'Type d\'équipement inconnu',
		},
	},
	subscribe: {
		title: 'S\'abonner',
		restorePurchases: 'Restaurer les achats',
		subscriptionTerms: 'Le paiement sera prélevé sur votre compte Apple ID à la fin de toute période d\'essai gratuite. L\'abonnement se renouvelle automatiquement au prix indiqué, sauf s\'il est annulé au moins 24 heures avant la fin de la période en cours. Gérez ou annulez à tout moment dans les réglages de votre Apple ID.',
		privacyPolicy: 'Politique de confidentialité',
		eula: 'CLUF',
		titles: {
			selectSubscription: 'Sélectionner un abonnement',
			tryFree: 'Essai gratuit de {period}',
			payment: 'Paiement',
			subscribe: 'S\'abonner',
			startFreeTrial: 'Commencer l\'essai gratuit',
		},
		messages: {
			paymentInitiated: 'Il semble que vous ayez initié un paiement que vous n\'avez pas encore entièrement confirmé.',
			confirmPayment: 'Veuillez confirmer le paiement auprès de votre banque, puis ',
			thisPage: ' cette page.',
			paymentIssues: 'En cas de problème avec les paiements, n\'hésitez pas à contacter ',
			subscriptionInactive: 'Votre abonnement est inactif. Si vous souhaitez le renouveler, veuillez mettre à jour vos informations de paiement.',
			coachLapsedTitle: 'Ton accès Premium est en pause',
			coachLapsed: '{coachName} vous offrait l\'accès Premium, et cet accès est en pause pour le moment.',
			coachLapsedNoName: 'Votre coach vous offrait l\'accès Premium, et cet accès est en pause pour le moment.',
			coachLapsedStillConnected: 'Tu es toujours connecté à ton coach. Rien n\'a été retiré de ton accompagnement et ton accès reviendra automatiquement dès que la couverture de ton coach sera de nouveau active.',
			coachLapsedSubscribe: 'Vous pouvez aussi démarrer votre propre abonnement ci-dessous.',
			noExpiration: 'Votre abonnement n\'a pas de date d\'expiration, vous n\'avez donc pas besoin de le prolonger.',
			ifPersists: 'Si le problème persiste, contactez ',
			alreadyHaveAccountPrefix: 'Vous avez déjà un compte ?',
			signIn: 'Se connecter',
			crossPlatform: 'Votre abonnement est actif. Pour le gérer, utilisez l\'appareil sur lequel vous vous êtes abonné.',
			membershipPaused: 'Votre adhésion est en pause, donc elle n\'est pas active pour le moment. Reprenez-la depuis votre profil au lieu d\'acheter un nouvel abonnement.',
			crossPlatformWeb: 'Votre abonnement est actif. Pour le gérer, connectez-vous sur notre site web.',
			signedInAsPrefix: 'Vous êtes connecté en tant que',
			signedInAsSuffix: '.',
			alreadyHaveSubscriptionPrefix: 'Vous avez payé avec une autre adresse e-mail ?',
			alreadyHaveSubscriptionLink: 'Recevez un lien de connexion',
			alreadyHaveSubscriptionSuffix: 'pour ce compte.',
			installAppPromptTitle: 'Votre abonnement est actif',
			installAppPromptBody: 'Vous voulez aussi utiliser MH Physique sur votre téléphone ?',
			continueAfterPurchase: 'Continuer',
			noStoreProductsTitle: 'Impossible de charger les options d\'abonnement',
			noStoreProductsBody: 'Nous n\'avons pas pu charger les options d\'abonnement sur cet appareil pour le moment. Notre équipe a été prévenue. Veuillez réessayer plus tard, ou contactez-nous pour obtenir de l\'aide pour vous abonner.',
		},
		links: {
			reload: 'recharger',
		},
		labels: {
			savePrefix: 'Économisez',
			trialDisclosure: '{period} d\'essai gratuit, puis {price}/{recurrence}',
		},
		recurrence: {
			month: 'mois',
			year: 'an',
		},
		trialPeriod: {
			days: '{count} {{jour|jours}}',
			weeks: '{count} {{semaine|semaines}}',
			months: '{count} mois',
			years: '{count} {{an|ans}}',
		},
		code: {
			hint: 'Code d\'un ami, code d\'accès ou code soldes',
			hintApp: 'Un code d\'accès',
			friendApplied: 'Code d\'ami appliqué : votre premier mois est gratuit.',
			removeCode: 'Retirer le code',
			notRecognised: 'Nous ne reconnaissons pas ce code. Vérifiez-le et réessayez.',
			newAccountsOnly: 'Cette offre est réservée aux nouveaux comptes.',
			ownCode: 'Vous ne pouvez pas utiliser votre propre code.',
			alreadyReferred: 'Vous avez déjà utilisé l\'invitation d\'un ami.',
			alreadyUsed: 'Ce code a déjà été utilisé.',
			addsNothing: 'Ce code n\'ajouterait rien à votre accès.',
			notValidYet: 'Ce code ne peut pas encore être utilisé. Réessayez dans {days} {{jour|jours}}.',
			tryAgain: 'Une erreur s\'est produite. Veuillez réessayer.',
			mistyped: 'Ce code semble incorrect. Vérifiez qu\'il n\'y a pas de faute de frappe.',
			incomplete: 'Ce code semble incomplet. Vérifiez qu\'il n\'y a pas de faute de frappe.',
			signedOutFriend: 'Cela ressemble au code d\'invitation d\'un ami. Créez un compte ou connectez-vous pour l\'utiliser.',
			signedOutAccess: 'Cela ressemble à un code d\'accès. Créez un compte ou connectez-vous pour l\'utiliser.',
			appOnly: 'Les règles de Google Play n\'autorisent pas les codes promo sur les achats intégrés.',
			confirmTitle: 'Utiliser ce code ?',
			confirmMessage: 'Ce code d\'accès sera ajouté à {email}. Il donne accès sans paiement et ne peut être utilisé qu\'une seule fois.',
		},
		promo: {
			haveCode: 'Vous avez un code ?',
			codePlaceholder: 'Code',
			applyButton: 'Appliquer',
			appliedOneNamed: 'Code {name} {code} appliqué : {percent} % de réduction sur {period} de {plan}',
			appliedOne: 'Code {code} appliqué : {percent} % de réduction sur {period} de {plan}',
			appliedSeveralNamed: 'Code {name} {code} appliqué : voyez les prix soldés ci-dessous',
			appliedSeveral: 'Code {code} appliqué : voyez les prix soldés ci-dessous',
			periodYear: 'la première année',
			periodMonth: 'le premier mois',
			planYearly: 'Annuel',
			planMonthly: 'Mensuel',
			percentOff: '-{percent} %',
			perMonth: '{price} par mois',
			thenYear: 'première année, puis le prix normal de {plan}',
			thenMonth: 'premier mois, puis le prix normal de {plan}',
			planTrial: 'Commence par {period} gratuits',
			moneyBack: 'Pas d\'essai au prix soldé : vous payez aujourd\'hui et pouvez être remboursé sous 30 jours, sans questions. Les soldes se terminent le {date}.',
			expired: 'Ce code a expiré',
			ended: 'Les soldes sont terminés',
			checkFailed: 'Le code n\'a pas pu être vérifié. Veuillez réessayer.',
		},
		notes: {
			billingInfo: 'Facturé au début de chaque cycle. Les abonnements se renouvellent automatiquement. Changez d\'abonnement ou annulez à tout moment.',
			billingInfoTrial: 'Essai gratuit de {period}, puis facturé au début de chaque cycle. Les abonnements se renouvellent automatiquement. Changez d\'abonnement ou annulez à tout moment.',
		},
		alerts: {
			emailMismatch: {
				title: 'Adresses e-mail différentes',
				message: 'Vous ne pouvez pas payer avec une adresse e-mail différente de celle de votre compte. Veuillez utiliser l\'e-mail de votre compte ou vous déconnecter d\'abord.',
			},
			accountExists: {
				title: 'Le compte existe déjà',
				message: 'Cette adresse e-mail est déjà associée à un compte. Nous devons d\'abord vous connecter...',
			},
			cantVerifyEmail: {
				title: 'Impossible de vérifier l\'e-mail',
				message: 'Impossible de contacter notre serveur d\'inscription. Veuillez réessayer plus tard ou contacter [support@mh-physique.app](mailto:support@mh-physique.app).',
			},
			checkEmail: {
				sendLinkTitle: 'Recevoir un lien de connexion',
				message: 'Saisissez l\'adresse e-mail avec laquelle vous avez payé, et nous y enverrons un lien de connexion.',
				sendLink: 'Envoyer le lien',
				resendFailedTitle: 'Impossible d\'envoyer l\'e-mail',
				resendFailedMessage: 'Nous n\'avons pas pu envoyer l\'e-mail de connexion. Veuillez vérifier votre connexion et réessayer.',
			},
			pricingFailed: {
				title: 'Échec du chargement des tarifs',
				message: 'Impossible de charger les tarifs des abonnements. Veuillez vérifier votre connexion et réessayer.',
			},
			pricingOffline: {
				title: 'Vous êtes hors ligne',
				message: 'Les abonnements ne peuvent pas se charger sans connexion Internet. Connectez-vous à Internet et réessayez.',
				tryAgain: 'Réessayer',
			},
			pricingUnavailable: {
				title: 'Impossible de charger les abonnements',
				message: 'Les abonnements n\'ont pas pu se charger. Un bloqueur de publicités ou une restriction réseau les bloque peut-être. Réessayez, ou désactivez tout bloqueur de publicités pour ce site.',
			},
			checkoutUnavailable: {
				title: 'Impossible d\'ouvrir le paiement',
				message: 'Le formulaire de paiement n\'a pas pu s\'ouvrir. Aucun montant ne vous a été facturé. Réessayez. Si le problème persiste, contactez support@mh-physique.app.',
			},
			purchaseFailed: {
				title: 'Échec de l\'achat de l\'abonnement',
				message: 'Impossible de finaliser l\'achat de l\'abonnement. Veuillez réessayer.',
			},
			purchaseNotYetConfirmed: {
				title: 'Achat effectué — activation en cours',
				message: 'Votre achat a bien été effectué. Nous n\'avons pas pu terminer de le confirmer à l\'instant, mais il devrait s\'activer tout seul d\'ici quelques minutes. Inutile d\'acheter à nouveau. S\'il ne s\'est pas activé, rouvrez l\'application ou appuyez sur Restaurer les achats.',
			},
			restoreFailed: {
				title: 'Échec de la restauration',
				message: 'Aucun achat existant trouvé. Si vous pensez qu\'il s\'agit d\'une erreur, veuillez contacter le support.',
			},
			restoreNotYetConfirmed: {
				title: 'Restauration en cours',
				message: 'La boutique a trouvé votre achat, mais nous n\'avons pas pu terminer de le confirmer à l\'instant. Il devrait s\'activer tout seul d\'ici quelques minutes. Inutile d\'acheter à nouveau.',
			},
			alreadyLinked: {
				title: 'Abonnement lié à un autre compte',
				message: 'Cet abonnement de la boutique est déjà lié à {email}. Pour l\'utiliser, déconnectez-vous et connectez-vous avec ce compte.',
				signOut: 'Se déconnecter',
				unknownAccount: 'un autre compte',
			},
			otherAccount: {
				title: 'Achat effectué sur un autre compte',
				message: 'Cet achat a été effectué avec un autre compte MH Physique. Pour l\'utiliser, connectez-vous avec ce compte. Si ce compte n\'existe plus, contactez le support et nous vous aiderons à obtenir l\'accès sur celui-ci.',
			},
			storeRefused: {
				title: 'Impossible de confirmer l\'achat',
				message: 'La boutique n\'a pas accepté notre demande de confirmation de cet achat, il n\'a donc pas été ajouté à votre compte. N\'achetez pas à nouveau. Si vous avez été facturé, contactez support@mh-physique.app et nous réglerons le problème.',
			},
			registrationSlow: {
				title: 'Enregistrement du paiement retardé',
				message: 'Votre paiement semble avoir été traité, mais l\'enregistrement prend plus de temps que prévu. Veuillez appuyer sur Réessayer pour recharger. Si le problème persiste, contactez support@mh-physique.app.',
			},
			paymentBeingConfirmed: {
				title: 'Paiement en cours de confirmation',
				message: 'Votre paiement est encore en cours de confirmation. Vous recevrez un e-mail une fois qu\'il sera traité.',
			},
		},
		temporaryInfoCard: {
			message: 'Paiement en cours de confirmation — votre paiement est dans la file d\'attente de vérification manuelle de PayPro. Vous avez un accès complet pendant l\'attente. La plupart des vérifications se terminent en quelques minutes.',
		},
		errors: {
			unexpectedCheckout: 'Événement inattendu pendant le paiement.',
			checkoutAwaitingProcessing: 'Votre paiement est toujours en attente de traitement. Avez-vous confirmé le paiement auprès de votre banque ?',
			checkoutDeclined: 'Le paiement a été refusé par votre banque ou votre prestataire de paiement.',
		},
	},
	unsubscribe: {
		title: 'Pourquoi partez-vous ?',
		reasons: {
			highPrice: 'Le prix est trop élevé.',
			noLongerNeed: 'Je n\'ai plus besoin de ce produit',
			notSatisfied: 'Je ne suis pas satisfait du produit.',
			switchedProduct: 'Je suis passé à un autre produit',
			notPriority: 'Ce n\'est pas une priorité pour le moment.',
			mistake: 'Je me suis abonné par erreur.',
			anotherPlan: 'Je passe à un autre abonnement.',
			other: 'Autres raisons.',
		},
		placeholders: {
			customReason: 'J\'aimerais que vous... (Veuillez expliquer votre raison ici.)',
		},
		buttons: {
			unsubscribe: 'Se désabonner',
		},
		alerts: {
			success: 'Vous vous êtes désabonné avec succès. Votre abonnement prendra fin le {date}.',
			alreadyCanceled: 'Votre abonnement a déjà été annulé. Aucune autre action n\'est nécessaire.',
			unsubscribeFailed: {
				title: 'Nous n\'avons pas pu annuler pour le moment',
				message: 'Votre abonnement est toujours actif. Veuillez réessayer dans un instant, ou contactez le support si cela persiste.',
				retry: 'Réessayer',
				contactSupport: 'Contacter le support',
			},
		},
	},
	redeemCode: {
		title: 'Utiliser un code',
		labels: {
			enterCode: 'Saisissez le code :',
		},
		placeholders: {
			codeFormat: 'ABCD-EFGH-1234-56789',
		},
		notes: {
			codeWillBeRedeemed: 'Le code que vous saisissez sera appliqué à votre compte : \'\'{email}\'\'.',
		},
		buttons: {
			redeem: 'Utiliser',
		},
		loading: {
			redeemingCode: 'Utilisation du code...',
		},
		alerts: {
			successfullyRedeemed: 'Code utilisé avec succès !',
		},
		errors: {
			loginFailed: 'La clé semble valide, mais la nouvelle connexion a échoué pour une raison inconnue. Veuillez redémarrer l\'application et réessayer, ou contacter le support.',
			activationFailed: 'La clé semble valide, mais l\'activation a échoué pour une raison inconnue. Veuillez redémarrer l\'application et réessayer, ou contacter le support.',
		},
	},
	referral: {
		settings: {
			inviteRow: 'Inviter un ami',
		},
		disclosure: 'L\'ami qui vous a invité verra quand vous vous inscrivez, quand vous commencez à vous entraîner et si vous vous abonnez.',
		invite: {
			headerTitle: 'Vous avez reçu une invitation',
			checking: 'Vérification de votre invitation...',
			title: '{name} vous offre un mois gratuit',
			subtitle: 'Un mois gratuit sur l\'application de Menno Henselmans. Commencez quand vous voulez.',
			startButton: 'Commencer mon mois gratuit',
			continueButton: 'Continuer',
			invalidTitle: 'Ce lien d\'invitation n\'est plus valable.',
			invalidSubtitle: 'Demandez un nouveau lien à votre ami, ou créez un compte sans invitation.',
			invalidButton: 'Créer un compte',
		},
		hub: {
			title: 'Offrez un mois gratuit à un ami',
			subtitle: 'Offrez à quelqu\'un un mois gratuit sur l\'application. S\'il continue, vous saurez que vous lui avez appris à s\'entraîner correctement.',
			messageLabel: 'Votre message',
			linkLabel: 'Votre lien d\'invitation',
			codeLabel: 'Ou donnez-lui ce code',
			defaultMessage: 'J\'utilise l\'application d\'entraînement de Menno Henselmans. Voici un mois gratuit si tu veux l\'essayer :',
			shareButton: 'Partager votre invitation',
			copiedToClipboard: 'Invitation copiée dans le presse-papiers.',
			copyFailed: 'Impossible de copier votre invitation. Vous pouvez sélectionner le lien ci-dessus et le copier manuellement.',
			loadFailed: 'Impossible de récupérer votre lien d\'invitation. Vérifiez votre connexion et réessayez.',
			retryButton: 'Réessayer',
			wereYouInvited: {
				title: 'Avez-vous reçu une invitation ?',
				subtitle: 'Saisissez le code de votre ami et nous enregistrerons qui vous a invité.',
				placeholder: 'Saisir le code',
				submitButton: 'Appliquer le code',
				accepted: 'Merci. Nous avons enregistré qui vous a invité.',
				refusals: {
					unknownInvite: 'Nous ne reconnaissons pas ce code. Vérifiez-le auprès de l\'ami qui vous l\'a envoyé.',
					selfReferral: 'C\'est votre propre code. Envoyez-le plutôt à un ami.',
					alreadyReferredByAnother: 'Quelqu\'un d\'autre est déjà enregistré comme l\'ami qui vous a invité.',
					hasSubscription: 'Cette offre est réservée aux nouveaux comptes.',
					accountTooOld: 'Cette offre est réservée aux nouveaux comptes.',
					inviterGone: 'Ce code n\'appartient plus à personne.',
					unexpectedError: 'Une erreur s\'est produite. Veuillez réessayer.',
				},
			},
			friends: {
				title: 'Les amis que tu as amenés',
				count: '{count} {{ami|amis}} jusqu\'ici',
				empty: 'Personne pour l\'instant. Partage ton invitation et ils apparaîtront ici.',
				loadFailed: 'Nous n\'avons pas pu charger tes amis. Vérifie ta connexion et réessaie.',
				noName: 'Un ami',
				statusJoined: 'Inscrit',
				statusTraining: 'À l\'entraînement',
				statusMember: 'Membre',
			},
		},
		subscribe: {
			freeMonthApplied: 'Votre mois gratuit offert par votre ami est appliqué.',
		},
	},
	bodyfatInput: {
		errors: {
			missingSkinfold: 'Veuillez saisir au moins une valeur pour le pli cutané « {skinfold} ».',
			genderRequired: 'Le sexe doit être renseigné pour calculer la masse grasse.',
			tapeAllValues: 'Veuillez saisir toutes les valeurs de la mesure au mètre ruban.',
			tapeInvalid: 'Données invalides pour la mesure au mètre ruban.',
			noMethod: 'Aucune méthode choisie pour le calcul du % de masse grasse.',
			valuesOutOfRange: 'Veuillez revérifier ces valeurs. Si elles sont correctes, consultez un professionnel de santé.',
		},
		methods: {
			visual: 'Visuel',
			caliper: 'Pince à plis',
			tape: 'Mètre ruban',
		},
		descriptions: {
			visual: 'Utilisez les images ci-dessous pour estimer votre pourcentage.',
		},
		labels: {
			bodyFatPercentage: 'Pourcentage de masse grasse',
			take5Measurements: 'Prenez 5 mesures de chaque pli cutané.',
			neckCircumference: 'Tour de cou',
			abdomenCircumference: 'Tour d\'abdomen',
			waistCircumference: 'Tour de taille',
			hipsCircumference: 'Tour de hanches',
		},
		helpText: {
			neckCircumference: 'Mesurez sous la pomme d\'Adam, au point le plus étroit.',
			abdomenCircumference: 'Mesurez autour du nombril, au point le plus large.',
			waistCircumference: 'Mesurez autour ou au-dessus du nombril, au point le plus étroit.',
			hipsCircumference: 'Mesurez autour du point le plus large des hanches/fessiers.',
		},
		links: {
			howToMeasure: 'Comment mesurer les plis cutanés ?',
		},
		warnings: {
			roughEstimate: 'Le mètre ruban est étonnamment utile pour suivre votre niveau de masse grasse, mais si vous pouvez vous procurer une pince à plis, elle est encore plus utile.',
		},
	},
	sendCoachMessage: {
		title: 'Message au coach',
		placeholder: 'Écrivez un message à votre coach...',
		addScreenshot: 'Ajouter une capture d\'écran',
		send: 'Envoyer',
		sentDescription: 'Votre coach recevra votre message par e-mail.',
	},
	sendFeedback: {
		title: 'Envoyer un commentaire',
		headers: {
			howCanWeHelp: 'Comment pouvons-nous vous aider aujourd\'hui ?',
		},
		messages: {
			thankYouForFeedback: 'Merci pour votre commentaire ! Nous vous avons envoyé une confirmation par e-mail.',
			couldNotSend: 'Nous n\'avons pas pu envoyer votre commentaire. Votre message est toujours là : vérifiez votre connexion et réessayez.',
			noTitle: 'Sans titre',
		},
		buttons: {
			submit: 'Envoyer un commentaire',
			addScreenshot: 'Ajouter une capture d\'écran',
		},
		writeFeedback: {
			title: 'Rédigez votre commentaire',
			subtitle: 'Nous vous contacterons à {email} si nécessaire.',
		},
		types: {
			question: {
				title: 'Poser une question',
				description: 'Nous sommes ravis de vous aider avec toutes vos questions.',
				placeholder: 'Posez n\'importe quelle question sur votre programme, ou sur l\'application en général, et nous vous répondrons dès que possible.',
			},
			like: {
				title: 'J\'aime quelque chose',
				description: 'Nous sommes ravis d\'apprendre que vous aimez quelque chose dans notre application.',
				placeholder: 'Dites-nous ce que vous aimez dans l\'application, ou dans votre programme.',
			},
			dislike: {
				title: 'Je n\'aime pas quelque chose',
				description: 'Si quelque chose ne vous plaît pas, dites-nous comment nous pouvons l\'améliorer.',
				placeholder: 'Dites-nous ce que vous n\'aimez pas dans l\'application, ou dans votre programme.',
			},
			issue: {
				title: 'Signaler un problème',
				description: 'Vous avez trouvé un bug ? Dites-le-nous et nous le corrigerons dès que possible.',
				placeholder: 'Veuillez décrire à quoi ressemble le problème et comment le reproduire (si possible).',
			},
			suggestion: {
				title: 'Faire une suggestion',
				description: 'Nous cherchons toujours des moyens d\'améliorer notre application. Dites-nous comment nous pouvons faire mieux.',
				placeholder: 'Dites-nous ce que vous aimeriez voir dans l\'application, ou comment nous pouvons l\'améliorer.',
			},
		},
	},
	flagContent: {
		title: 'Signaler le contenu',
		reasons: {
			offensive: 'Offensant ou inapproprié',
			offensiveDesc: 'Contient des grossièretés, des propos haineux ou du contenu explicite',
			spam: 'Spam',
			spamDesc: 'Publicité, contenu absurde ou dupliqué',
			incorrect: 'Informations incorrectes',
			incorrectDesc: 'Les données nutritionnelles sont manifestement fausses ou trompeuses',
			other: 'Autre',
			otherDesc: 'Autre chose non listée ci-dessus',
		},
		submit: 'Envoyer le signalement',
		otherTitle: 'Décrivez le problème',
		otherPlaceholder: 'Décrivez le problème...',
		success: 'Signalement envoyé. Merci !',
		error: 'Échec de l\'envoi du signalement. Veuillez réessayer.',
		menuButton: 'Signaler',
	},
	helpPage: {
		title: 'Aide',
		placeholders: {
			searchKnowledgeBase: 'Sur quoi avez-vous besoin d\'aide ?',
		},
		messages: {
			noMatchesTitle: 'Aucun résultat de recherche trouvé',
			noMatchesSubtext: 'Vous ne trouvez pas ce que vous cherchez ? Essayez d\'ajuster votre recherche, ou contactez-nous en <a href="mailto:support@mh-physique.app">écrivant au support</a> ou en <a href="https://community.mh-physique.app/" target="_blank">rejoignant la communauté</a> pour obtenir de l\'aide de notre équipe et des autres utilisateurs.',
		},
		faq: {
			title: 'Questions fréquentes',
		},
	},
	labelScanner: {
		title: 'Scanner l\'étiquette',
		noNutrientsTitle: 'Aucune information nutritionnelle trouvée',
		noNutrients: 'Aucune information nutritionnelle détectée. Vérifiez sous les rabats, au fond, ou sur la boîte extérieure — puis prenez une autre photo.',
		noNutrientsBlurry: 'La photo est trop floue ou trop sombre pour être lue. Essayez de la reprendre avec un meilleur éclairage et en tenant l\'appareil bien stable.',
		noNutrientsPartial: 'Seule une partie des informations nutritionnelles a été trouvée. L\'étiquette complète peut se trouver sous un rabat, au fond, ou sur la boîte extérieure.',
		retakeButton: 'Reprendre',
		cameraErrorTitle: 'Appareil photo indisponible',
		error: 'Échec de l\'analyse de l\'étiquette. Veuillez réessayer.',
		quotaTitle: 'Limite de scans atteinte',
		cameraPermissionDenied: 'L\'accès à l\'appareil photo est nécessaire pour scanner les étiquettes.',
		modelsAgree: '{count} modèle(s) d\'accord',
		acceptResult: 'Accepter ce résultat',
		labelType: 'Type d\'étiquette',
		confidence: 'Confiance',
		jsonRepaired: 'La réponse a été tronquée et réparée automatiquement — vérifiez les nutriments',
		doneButton: 'Terminé',
		photoHintExtract: 'Plus vous capturez, mieux c\'est — la nutrition, l\'avant de l\'emballage, les ingrédients.',
		photoHintImage: 'La meilleure photo devient l\'image de l\'aliment.',
		providerErrorTitle: 'Service temporairement indisponible',
		providerErrorMessage: 'Le service de scan est temporairement indisponible. Veuillez réessayer dans un instant, ou contactez le support si cela se répète.',
		incompleteTitle: 'Le scan ne s\'est pas terminé',
		incompleteMessage: 'Le scan ne s\'est pas terminé. Veuillez réessayer — vos photos sont toujours là.',
		quotaAccountLocked: 'Le scan d\'étiquettes est temporairement désactivé pour votre compte.',
		quotaRateLimited: 'Trop de scans en peu de temps. Veuillez patienter un instant.',
		quotaDailyCooldown: 'Trop de scans infructueux aujourd\'hui. Veuillez réessayer demain.',
		quotaQualityWarning: 'La plupart de vos scans échouent — vérifiez la qualité de l\'image et le contenu.',
		retryingDifferentServer: 'Difficultés rencontrées — essai avec un autre serveur...',
		offlineTitle: 'Vous êtes hors ligne',
		offlineMessage: 'Connectez-vous à Internet et réessayez.',
		statusReadingPackaging: 'Lecture de l\'emballage...',
		statusExtractingProductInfo: 'Extraction des informations produit...',
		statusAnalyzingNutrients: 'Analyse des nutriments...',
		statusCheckingIngredients: 'Vérification des ingrédients...',
		statusDetectingServingSizes: 'Détection des portions...',
		statusAlmostThere: 'Presque terminé...',
	},
	mealPhotoScanner: {
		title: 'Scanner le repas',
		analyzeButton: 'Analyser le repas',
		analyzing: 'Identification des aliments...',
		retryingDifferentServer: 'Nouvel essai avec un autre modèle...',
		addToMeal: 'Ajouter {count} aliment(s) au repas',
		replaceInMeal: 'Remplacer par {count} aliment(s)',
		noFoodsDetected: 'Aucun aliment détecté sur cette photo. Essayez de prendre une photo plus nette de votre repas.',
		noFoodsBlurry: 'La photo est trop floue ou trop sombre. Essayez de la reprendre avec un meilleur éclairage.',
		barcodeDetectedTitle: 'Code-barres détecté',
		barcodeDetectedMessage: 'Cela ressemble à un code-barres de produit, pas à une assiette de nourriture. Scannez plutôt le code-barres pour enregistrer ce produit emballé.',
		nutritionLabelDetectedTitle: 'Étiquette nutritionnelle détectée',
		nutritionLabelDetectedMessage: 'Cela ressemble à l\'étiquette nutritionnelle d\'un produit, pas à une assiette de nourriture. Scannez plutôt l\'étiquette pour enregistrer ce produit emballé.',
		scanBarcodeButton: 'Scanner le code-barres',
		scanLabelButton: 'Scanner l\'étiquette',
		retakeButton: 'Reprendre',
		changeButton: 'Changer',
		searchButton: 'Rechercher',
		addFoodButton: 'Ajouter un aliment',
		errorTitle: 'Échec de l\'analyse',
		error: 'Impossible d\'analyser la photo du repas. Veuillez réessayer.',
		estimatedGrams: '{grams} g estimés',
		estimatedToMeasured: '{estimated} g estimés → {measured} g mesurés',
		addedGrams: '{grams} g ajoutés par vous',
		quotaTitle: 'Limite de scans atteinte',
		quotaAccountLocked: 'Le scan des repas est temporairement désactivé pour votre compte.',
		quotaRateLimited: 'Trop de scans en peu de temps. Veuillez patienter un instant.',
		quotaDailyCooldown: 'Trop de scans infructueux aujourd\'hui. Veuillez réessayer demain.',
		cameraPermissionDenied: 'L\'accès à l\'appareil photo est requis pour scanner les repas.',
	},
	equipmentScanner: {
		title: 'Scanner l\'équipement',
		analyzeButton: 'Analyser',
		retakeButton: 'Reprendre',
		photoHintCapture: 'Prenez des photos sous plusieurs angles pour un meilleur résultat.',
		photoHintLabel: 'Assurez-vous que les poids imprimés sont lisibles.',
		analyzingReadingPlates: 'Lecture des poids...',
		analyzingMatchingType: 'Identification du type d\'équipement...',
		analyzingFinalising: 'Finalisation...',
		retryingDifferentServer: 'Nouvelle tentative avec un autre modèle...',
		cameraPermissionDenied: 'L\'accès à l\'appareil photo est requis pour scanner l\'équipement.',
		errorTitle: 'Échec du scan',
		errorCamera: 'L\'appareil photo n\'a pas pu démarrer. Veuillez réessayer.',
		errorNetwork: 'Impossible de joindre le scanner. Vérifiez votre connexion et réessayez.',
		errorGeneric: 'Impossible d\'analyser l\'équipement. Veuillez réessayer.',
		errorIncomplete: 'Le scan ne s\'est pas terminé. Veuillez réessayer — vos photos sont toujours là.',
		errorBadImage: 'L\'image a été refusée. Assurez-vous que les photos sont nettes et pas trop volumineuses.',
		errorUnsupportedType: 'Ce type d\'équipement ne peut pas être scanné.',
		noEquipmentDetected: 'Aucun équipement détecté sur les photos. Essayez des angles plus nets ou un meilleur éclairage.',
		noEquipmentBlurry: 'Les photos sont trop floues ou sombres. Reprenez-les avec un meilleur éclairage.',
		noEquipmentMixed: 'Les photos semblent montrer des équipements différents. Veuillez reprendre les photos du MÊME équipement sous différents angles.',
		lowConfidenceTooltip: 'L\'IA n\'était pas sûre de cette valeur — elle a pu être interpolée ou difficile à lire. Vérifiez avant d\'appliquer.',
		confidenceTooltip: 'Le niveau de confiance de l\'IA dans cette lecture. Les valeurs inférieures à 70 % sont signalées par un avertissement.',
		types: {
			barbell: 'Barre',
			dumbbells: 'Haltères',
			plates: 'Disques libres',
			kettlebells: 'Kettlebells',
			cableMachine: 'Machine à câble',
			unknown: 'Inconnu',
		},
		detectedHeader: 'Détectés ({count} éléments)',
		applyModeHeader: 'Comment appliquer',
		applyMode: {
			replace: 'Remplacer',
			replaceHelp: 'Écraser toutes les valeurs existantes par les valeurs détectées cochées.',
			merge: 'Fusionner',
			mergeHelp: 'Ajouter les valeurs détectées qui ne sont pas déjà présentes (à 0,05 kg près).',
			append: 'Ajouter',
			appendHelp: 'Ajouter toutes les valeurs détectées cochées à la liste existante (doublons autorisés).',
		},
		barGroup: 'Barre',
		collarGroup: 'Collier',
		platesGroup: 'Disques',
		microPlatesGroup: 'Micro-disques',
		currentValues: {
			showStack: 'Afficher la charge obtenue ({count} incréments)',
			headerStack: 'Charge obtenue ({count} incréments)',
			showPlates: 'Afficher les disques obtenus ({count} disques)',
			headerPlates: 'Disques obtenus ({count} disques)',
			showBar: 'Afficher la configuration de barre obtenue ({count} disques)',
			headerBar: 'Configuration de barre obtenue ({count} disques)',
			showFixed: 'Afficher les poids obtenus ({count})',
			headerFixed: 'Poids obtenus ({count})',
		},
		afterApply: 'Après application : {count} élément(s)',
		usingChecked: '{checked} sur {total} détectés utilisés',
		typeMismatchBanner: '{detected} détecté, mais cet équipement est un(e) {current}.',
		unknownTypeBanner: 'Nous n\'avons pas pu identifier avec certitude le type d\'équipement sur les photos.',
		quotaTitle: 'Limite de scans atteinte',
		quotaAccountLocked: 'Le scan des équipements est temporairement désactivé pour votre compte.',
		quotaRateLimited: 'Trop de scans en peu de temps. Veuillez patienter un instant.',
		quotaDailyCooldown: 'Trop de scans infructueux aujourd\'hui. Veuillez réessayer demain.',
	},
	workoutPlanScanner: {
		title: 'Scanner une séance',
		analyzeButton: 'Analyser',
		retakeButton: 'Reprendre',
		photoHintCapture: 'Photographiez ou faites une capture d\'écran de votre séance. Un jour d\'entraînement par image donne les meilleurs résultats.',
		photoHintBatch: 'Jusqu\'à 5 images par scan. Pour les programmes plus longs, scannez par lots et ajoutez-les.',
		analyzingReadingWorkout: 'Lecture de la séance...',
		analyzingMatchingExercises: 'Correspondance des exercices...',
		analyzingFinalising: 'Finalisation...',
		retryingDifferentServer: 'Nouvelle tentative avec un autre modèle...',
		cameraPermissionDenied: 'L\'accès à l\'appareil photo est requis pour scanner une séance. Vous pouvez aussi importer des captures d\'écran avec le bouton +.',
		errorTitle: 'Échec du scan',
		errorCamera: 'L\'appareil photo n\'a pas pu démarrer. Veuillez réessayer.',
		errorNetwork: 'Impossible de joindre le scanner. Vérifiez votre connexion et réessayez.',
		errorGeneric: 'Impossible d\'analyser la séance. Veuillez réessayer.',
		errorIncomplete: 'Le scan ne s\'est pas terminé. Veuillez réessayer — vos photos sont toujours là.',
		errorApply: 'Une erreur s\'est produite lors de l\'ajout de la séance scannée. Une partie a peut-être été ajoutée — vérifiez vos séances ci-dessous, ou annulez Modifier les séances pour abandonner les modifications.',
		errorBadImage: 'L\'image a été refusée. Assurez-vous que les photos sont nettes et pas trop volumineuses.',
		noWorkoutDetected: 'Aucune séance trouvée dans les images. Essayez des photos ou captures d\'écran plus nettes.',
		noWorkoutBlurry: 'Les images sont trop floues ou sombres pour être lues. Reprenez-les avec un meilleur éclairage.',
		quotaTitle: 'Limite de scans atteinte',
		quotaAccountLocked: 'Le scan des séances est temporairement désactivé pour votre compte.',
		quotaRateLimited: 'Trop de scans en peu de temps. Veuillez patienter un instant.',
		quotaDailyCooldown: 'Trop de scans infructueux aujourd\'hui. Veuillez réessayer demain.',
		detectedSummary: '{days} jour(s) détecté(s) avec {exercises} exercice(s).',
		willCreateCustomSummary: '{count} exercice(s) seront créés comme nouveaux exercices personnalisés lors de l\'application.',
		willCreateCustom: 'Cet exercice ne figure pas dans la base de données d\'exercices de l\'app. Il sera créé comme nouvel exercice personnalisé avec le nom scanné.',
		willCreateCustomSimilar: 'Cet exercice ne figure pas dans la base de données d\'exercices de l\'app. Il sera créé comme nouvel exercice personnalisé avec le nom scanné, configuré comme similaire à {name}.',
		useScannedButton: 'Garder le nom scanné',
		useSuggestionButton: 'Utiliser la suggestion',
		changeButton: 'Modifier',
		resolveButton: 'Résoudre',
		scannedAs: 'Scanné comme « {name} »',
		suggestedAs: 'Suggéré « {name} »',
		customBadge: 'Personnalisé',
		matchedBadge: 'Correspondance',
		matchedBadgeTooltip: 'C\'est le même exercice que celui scanné, peut-être simplement sous un nom différent dans la base de données d\'exercices de l\'app.',
		suggestedMatchBadge: 'Suggéré',
		suggestedMatchTooltip: 'Ce n\'est pas l\'exercice scanné, mais un exercice similaire tiré de la base de données d\'exercices de l\'app, proposé en remplacement.',
		alreadyInPlan: 'Déjà dans votre programme — l\'application mettra à jour ses séries et répétitions partout où il est utilisé.',
		setsLabel: 'Séries',
		targetRepsLabel: 'Répétitions cibles',
		applyModeHeader: 'Comment appliquer',
		applyModeMessage: 'Ajouter insère le(s) jour(s) scanné(s) dans vos séances actuelles. Remplacer supprime d\'abord vos séances actuelles. Rien n\'est enregistré tant que vous n\'enregistrez pas la page Modifier les séances.',
		applyingLoading: 'Ajout à votre programme…',
		applyMode: {
			append: 'Ajouter',
			replace: 'Remplacer',
		},
	},
	recipeScanner: {
		title: 'Scanner une recette',
		emptyRecipeHint: 'Vous avez une recette sous la main ? Scannez une photo et nous remplirons les ingrédients pour vous.',
		analyzeButton: 'Analyser',
		retakeButton: 'Reprendre',
		analyzing: 'Lecture de la recette...',
		retryingDifferentServer: 'Nouvelle tentative avec un autre modèle...',
		photoHintCapture: 'Photographiez une fiche recette, une page de livre de cuisine, un écran ou une note.',
		photoHintBatch: 'Jusqu\'à 4 photos — une par page.',
		photoHintImage: 'Une photo du plat terminé devient l\'image de la recette.',
		cameraPermissionDenied: 'L\'accès à l\'appareil photo est requis pour scanner une recette. Vous pouvez aussi importer des photos avec le bouton +.',
		nameLabel: 'Nom de la recette',
		namePlaceholder: 'Nom de la recette',
		imageLabel: 'Image de la recette',
		servingsLabel: 'Donne {count} portion(s)',
		instructionsLabel: 'Instructions',
		useRecipeButton: 'Utiliser {count} ingrédient(s)',
		changeButton: 'Modifier',
		searchButton: 'Rechercher',
		estimatedGrams: '{grams} g estimés',
		estimatedToMeasured: '{estimated} g estimés → {measured} g mesurés',
		errorTitle: 'Échec du scan',
		error: 'Impossible de lire la recette. Veuillez réessayer.',
		noRecipeDetected: 'Aucune recette trouvée sur ces photos. Essayez des photos plus nettes de la recette complète.',
		noRecipeBlurry: 'Les photos sont trop floues ou sombres pour être lues. Reprenez-les avec un meilleur éclairage.',
		quotaTitle: 'Limite de scans atteinte',
		quotaAccountLocked: 'Le scan des recettes est temporairement désactivé pour votre compte.',
		quotaRateLimited: 'Trop de scans en peu de temps. Veuillez patienter un instant.',
		quotaDailyCooldown: 'Trop de scans infructueux aujourd\'hui. Veuillez réessayer demain.',
	},
	cameraPermission: {
		title: 'Comment activer l\'appareil photo',
		nativeAndroidStep1: 'Ouvrez l\'application Paramètres de votre téléphone',
		nativeAndroidStep2: 'Appuyez sur Applications, puis sur MH Physique',
		nativeAndroidStep3: 'Appuyez sur Autorisations, puis sur Appareil photo',
		nativeAndroidStep4: 'Choisissez "Autoriser uniquement si l\'appli est en cours d\'utilisation"',
		nativeAndroidStep5: 'Revenez ici et rouvrez le scanner',
		nativeIosStep1: 'Ouvrez l\'app Réglages sur votre appareil',
		nativeIosStep2: 'Faites défiler et appuyez sur MH Physique',
		nativeIosStep3: 'Activez Appareil photo',
		nativeIosStep4: 'Revenez ici et rouvrez le scanner',
		webStep1: 'Cliquez sur l\'icône de cadenas à côté de la barre d\'adresse',
		webStep2: 'Trouvez « Appareil photo »',
		webStep3: 'Réglez l\'autorisation sur « Autoriser »',
		webStep4: 'Fermez et rouvrez cet écran',
		webIosStep1: 'Ouvrez l\'app Réglages sur votre appareil',
		webIosStep2: 'Faites défiler vers le bas et touchez Safari',
		webIosStep3: 'Touchez Appareil photo (sous « Réglages pour les sites web »)',
		webIosStep4: 'Sélectionnez l\'option Demander ou Autoriser',
		webIosStep5: 'Revenez ici et rechargez la page',
		webIosOtherBrowserStep1: 'Ouvrez l\'app Réglages sur votre appareil',
		webIosOtherBrowserStep2: 'Faites défiler vers le bas et touchez le navigateur que vous utilisez, comme Chrome ou Firefox',
		webIosOtherBrowserStep3: 'Activez Appareil photo',
		webIosOtherBrowserStep4: 'Revenez ici et rechargez la page',
		macSafariStep1: 'Dans le menu Safari, choisissez « Réglages pour ce site web »',
		macSafariStep2: 'Réglez Appareil photo sur « Autoriser »',
		macSafariStep3: 'Rechargez cette page',
		macSafariStep4: 'Toujours bloqué ? Ouvrez Réglages Système, puis Confidentialité et sécurité, puis Appareil photo, et activez Safari',
	},
	barcodeScanner: {
		title: 'Scanner un code-barres',
		tabs: {
			scan: 'Scanner',
			enterManually: 'Saisir manuellement',
		},
		manualEntry: {
			title: 'Saisir le code-barres',
			findFood: 'Trouver l\'aliment',
		},
		messages: {
			cameraPermissionDenied: 'Vous devrez autoriser l\'app à utiliser votre appareil photo pour que cette fonctionnalité fonctionne correctement.',
			initializingCamera: 'Initialisation de l\'appareil photo',
			cannotInitializeCamera: 'Impossible d\'initialiser l\'appareil photo.',
			noBarcodeFound: 'Aucun code-barres trouvé ? Essayez {remedies}.',
		},
		remedies: {
			betterLighting: 'un meilleur éclairage',
			differentDistance: 'une distance différente',
			enablingFlash: 'activer le flash',
			zoomingInOut: 'zoomer/dézoomer',
			switchingCameras: 'changer d\'appareil photo',
		},
	},
	helpCard: {
		title: 'Informations sur...',
	},
	changelog: {
		title: 'Nouveautés',
		comingSoon: 'Bientôt disponible',
	},
	sso: {
		loggingIntoCommunity: 'Connexion à la communauté...',
		communityForSubscribersOnly: 'La communauté est réservée aux abonnés. Abonnez-vous pour rejoindre la discussion.',
	},
	nutrients: {
		names: {
			energy: 'Énergie',
			protein: 'Protéines',
			fat: 'Lipides',
			carbohydrates: 'Glucides',
			fiber: 'Fibres',
			cholesterol: 'Cholestérol',
			fatSaturated: 'Lipides, saturés',
			fatMonounsaturated: 'Lipides, mono-insaturés',
			fatPolyunsaturated: 'Lipides, polyinsaturés',
			omega3: 'Oméga-3',
			omega6: 'Oméga-6',
			omega9: 'Oméga-9',
			transsaturatedFat: 'Lipides trans',
			carbohydratesTotal: 'Glucides, totaux',
			sugarsTotal: 'Sucres, totaux',
			sugarAdded: 'Sucres, ajoutés',
			starch: 'Amidon',
			saltNacl: 'Sel (NaCl)',
			alcohol: 'Alcool',
			water: 'Eau',
			caffeine: 'Caféine',
			theobromine: 'Théobromine',
			calciumCa: 'Calcium (Ca)',
			ironFe: 'Fer (Fe)',
			magnesiumMg: 'Magnésium (Mg)',
			phosphorusP: 'Phosphore (P)',
			potassiumK: 'Potassium (K)',
			sodiumNa: 'Sodium (Na)',
			zincZn: 'Zinc (Zn)',
			copperCu: 'Cuivre (Cu)',
			fluorideF: 'Fluorure (F)',
			manganeseMn: 'Manganèse (Mn)',
			seleniumSe: 'Sélénium (Se)',
			iodineI: 'Iode (I)',
			vitaminAIu: 'Vitamine A (UI)',
			retinol: 'Rétinol',
			vitaminARae: 'Vitamine A EAR',
			caroteneBeta: 'Carotène, bêta',
			caroteneAlpha: 'Carotène, alpha',
			vitaminEAlphaTocopherol: 'Vitamine E (alpha-tocophérol)',
			vitaminD: 'Vitamine D',
			vitaminD2Ergocalciferol: 'Vitamine D2 (ergocalciférol)',
			vitaminD3Cholecalciferol: 'Vitamine D3 (cholécalciférol)',
			vitaminCTotalAscorbicAcid: 'Vitamine C, acide ascorbique total',
			thiaminVitaminB1: 'Thiamine (vitamine B-1)',
			riboflavinVitaminB2: 'Riboflavine (vitamine B-2)',
			niacinVitaminB3: 'Niacine (vitamine B-3)',
			pantothenicAcid: 'Acide pantothénique',
			vitaminB6: 'Vitamine B-6',
			folateTotal: 'Folates, totaux',
			vitaminB12: 'Vitamine B-12',
			cholineTotal: 'Choline, totale',
			vitaminKPhylloquinone: 'Vitamine K (phylloquinone)',
			folicAcid: 'Acide folique',
			ash: 'Cendres',
			biotinVitaminH: 'Biotine (vitamine H)',
			chromiumCr: 'Chrome (Cr)',
			molybdenumMo: 'Molybdène (Mo)',
			fattyAcidsLinoleic: 'Acides gras, linoléique',
			fattyAcidsAlphaLinolenic: 'Acides gras, alpha-linolénique',
			epa: 'EPA',
			dha: 'DHA',
			fattyAcidsArachidonic: 'Acides gras, arachidonique',
			sorbitol: 'Sorbitol',
			maltitol: 'Maltitol',
			mannitol: 'Mannitol',
			isomalt: 'Isomalt',
			lactitol: 'Lactitol',
			xylitol: 'Xylitol',
			erythritol: 'Érythritol',
			polyolsSugarAlcoholsTotal: 'Polyols (sucres-alcools), totaux',
		},
		short: {
			energy: 'Cal',
			protein: 'Prot',
			fat: 'Lip',
			carbohydrates: 'Gluc',
			fiber: 'Fib',
			cholesterol: 'Chol',
		},
		threeLetter: {
			energy: 'Cal',
			protein: 'Pro',
			fat: 'Lip',
			carbohydrates: 'Glu',
			fiber: 'Fib',
		},
	},
	authRoles: {
		unknown: {
			name: 'Gratuit',
			userExplanation: 'Votre abonnement n\'est pas actif actuellement. Un abonnement Premium est nécessaire pour accéder à toutes les fonctionnalités d\'entraînement et de planification des repas.',
		},
		paid: {
			name: 'Premium',
			userExplanation: 'En tant qu\'utilisateur Premium, vous avez accès à toutes les fonctionnalités, y compris le programme d\'entraînement et la planification des repas automatiques.',
		},
		vip: {
			name: 'VIP',
			userExplanation: 'En tant qu\'utilisateur VIP, vous avez accès à toutes les fonctionnalités Premium, y compris le programme d\'entraînement et la planification des repas automatiques. Il s\'agit d\'un abonnement récurrent offert, géré manuellement par l\'équipe MH Physique.',
		},
		mod: {
			name: 'Modérateur',
			userExplanation: 'En tant que Modérateur, vous avez accès à toutes les fonctionnalités Premium et vous pouvez aussi modérer les contributions de la communauté. Il s\'agit d\'un abonnement récurrent offert, géré manuellement par l\'équipe MH Physique.',
		},
		dev: {
			name: 'Développeur',
			userExplanation: 'Il s\'agit d\'une licence développeur de base ; contactez votre responsable de production pour savoir ce qu\'elle comprend.',
		},
		officer: {
			name: 'Officier',
			userExplanation: 'En tant qu\'Officier, vous pouvez modifier les paramètres de fonctionnement du système (solveurs d\'entraînement et de repas, exercices officiels, etc.), modérer les contributions de la communauté, ainsi que modifier et supprimer des utilisateurs.',
		},
		serverdev: {
			name: 'Dév. serveur',
			userExplanation: 'En tant que Développeur serveur, vous n\'avez pas besoin qu\'on vous explique ce que cela signifie.',
		},
	},
	exerciseStates: {
		active: {
			title: 'Actif',
			description: 'Cet exercice fait actuellement partie de votre programme.',
		},
		plateaued: {
			title: 'En plateau',
			description: 'Vous avez atteint un plateau (un pic de performance temporaire) sur cet exercice. Il sera réutilisé plus tard, quand votre progression l\'exigera.',
		},
		unsuitable: {
			title: 'Inadapté',
			description: 'Nous avons constaté que cet exercice n\'était pas optimal pour vous. Il sera réutilisé plus tard, quand votre progression l\'exigera.',
		},
		avoided: {
			title: 'Évité',
			description: 'Vous avez demandé à remplacer cet exercice par une alternative, à cause d\'une blessure ou d\'un manque de matériel. Nous vous le proposerons à nouveau bientôt pour voir si la situation a changé.',
		},
		ready: {
			title: 'Prêt',
			description: 'Vous avez déjà utilisé ou tenté cet exercice. Il est de nouveau prêt et attend d\'être utilisé dès que nécessaire.',
		},
		unused: {
			title: 'Non utilisé',
			description: 'Nous ne vous avons pas encore proposé cet exercice. Nous le ferons quand votre progression l\'exigera.',
		},
	},
	exerciseStats: {
		setNumber: '{number}',
		importantNotice: 'Avis important',
		exerciseProgress: 'Progression de l\'exercice',
		log: 'Journal',
		exportAsCsv: 'Exporter en CSV',
		buttons: {
			allow: 'Autoriser',
			shareLink: 'Partager le lien',
			stopSharing: 'Arrêter le partage',
		},
		toasts: {
			linkCopied: 'Lien copié dans le presse-papiers',
		},
		tabs: {
			log: 'Historique',
			instructions: 'Instructions',
			settings: 'Réglages',
		},
		settings: {
			equipment: 'Équipement',
			notSelectedYet: 'Pas encore sélectionné',
			myoReps: 'Myo-reps',
			myoRepsTooltip: 'Les myo-reps utilisent une série principale suivie de mini-séries à repos court pour une croissance musculaire plus rapide et efficace.',
			myoRepsLearnMore: 'En savoir plus',
			useMyoReps: 'Utiliser',
			useMyoRepsNote: 'Utilisez les myo-reps chaque fois que possible pour rendre les séances plus rapides tout en restant efficaces. Si un exercice ne s\'y prête pas, l\'app reviendra aux séries classiques.',
			dontUseMyoReps: 'Ne pas utiliser',
			dontUseMyoRepsNote: 'Ne jamais utiliser les myo-reps pour cet exercice. L\'entraînement s\'appuiera sur des séries classiques traditionnelles.',
			autoMyoReps: 'Automatique',
			autoMyoRepsNote: 'Déterminer automatiquement s\'il faut utiliser les myo-reps pour cet exercice, selon les préférences d\'objectif global et la progression actuelle.',
			rmTesting: 'Test de rep max (RM)',
			rmTestingTooltip: 'Le test RM utilise une série lourde de 2 à 5 répétitions avec une bonne technique pour évaluer la force. L\'app estime ensuite votre 1RM et choisit votre poids de départ.',
			rmTestingLearnMore: 'En savoir plus',
			useRMTesting: 'Utiliser',
			useRMTestingNote: 'Toujours utiliser le test de RM pour cet exercice. Vous testerez votre max sur 2 à 5 répétitions afin que l\'application puisse estimer votre force et régler les bons poids.',
			dontUseRMTesting: 'Ne pas utiliser',
			dontUseRMTestingNote: 'Ne jamais utiliser le test de RM pour cet exercice. L\'application se basera plutôt sur vos performances enregistrées.',
			autoRMTesting: 'Auto',
			autoRMTestingNote: 'Déterminer automatiquement s\'il faut utiliser le test de RM à partir de votre réglage général.',
		},
		options: {
			exerciseStatus: 'État de l\'exercice',
		},
		alerts: {
			stopAvoidingTitle: 'Ne plus éviter',
			stopAvoidingMessage: 'Vous avez changé d\'avis ? Cela ne réintégrera pas immédiatement cet exercice dans votre programme, mais le rendra disponible pour la planification ou les changements ultérieurs.',
		},
		filters: {
			weight: 'Poids',
			oneRM: '1 RM',
			tonnage: 'Tonnage',
			includeRMTests: 'Inclure les tests de RM',
		},
		emptyState: {
			noProgressData: 'Aucune donnée de progression',
			noProgressDataSubtext: 'Les données de cet exercice s\'afficheront ici une fois que vous aurez effectué le mouvement.',
			noLogHistory: 'Aucun historique',
			noLogHistorySubtext: 'Vos exercices enregistrés et vos notes s\'afficheront ici une fois que vous aurez effectué le mouvement.',
			noDataInRange: 'Aucune donnée sur la période',
			noDataInRangeSubtext: 'Aucune donnée d\'exercice trouvée pour la période sélectionnée. Essayez de choisir une autre période.',
			loadFailed: 'Impossible de charger les données de l\'exercice',
			loadFailedSubtext: 'Une erreur s\'est produite lors du chargement. Veuillez réessayer.',
		},
		logTable: {
			date: 'DATE',
			loggedSets: 'SÉRIES ENREGISTRÉES',
			notes: 'NOTES',
		},
		logDetail: {
			sets: 'Séries',
			notes: 'Notes',
		},
		chart: {
			weight: 'Poids',
			oneRMEstimate: 'Estimation 1RM',
			tonnage: 'Tonnage',
			weightAxis: 'Poids ({unit})',
			oneRMAxis: '1RM ({unit})',
			tonnageAxis: 'Tonnage ({unit})',
		},
	},
	trendChart: {
		last7Days: '7 derniers jours',
		seeAll: 'Tout voir',
		noData: 'Aucune donnée',
	},
	markdownEditor: {
		buttons: {
			unlink: 'Supprimer le lien',
		},
		placeholders: {
			url: 'URL',
		},
	},
	planHandler: {
		macrosOnTarget: 'Macros dans la cible',
	},
	programSettings: {
		title: 'Réglages du programme',
		tabs: {
			training: 'Entraînement',
			nutrition: 'Nutrition',
		},
		settings: {
			title: 'Réglages',
		},
		advancedTraining: {
			title: 'Méthodes d\'entraînement avancées',
			edit: 'Modifier',
		},
		moreSettings: {
			toggle: 'Plus de réglages',
			info: 'Les changements ici peuvent suggérer des optimisations du programme. Vous pouvez toujours conserver vos séances actuelles.',
		},
		schedule: {
			title: 'Planning',
			frequency: 'Fréquence d\'entraînement',
			days: 'Jours d\'entraînement',
			daysPerWeek: 'jours par semaine',
			hoursPerNight: 'heures par nuit',
			sleep: 'Sommeil',
		},
		lifestyle: {
			title: 'Mode de vie',
			activityLevel: 'Niveau d\'activité',
			stressLevel: 'Niveau de stress',
		},
		volume: {
			title: 'Volume d\'entraînement',
			priority: 'Priorité physique',
			setsPerWeek: 'Séries par semaine par groupe musculaire',
			setsPerWeekCurrentPlanTooltip: 'Vos séances sont encore conçues pour {volume} séries par semaine. Utilisez Voir et optimiser dans Volume musculaire pour les rapprocher de votre objectif.',
		},
		nutrition: {
			goal: 'Objectif',
			primaryGoal: 'Objectif principal',
			schedule: 'Planning',
			mealFrequency: 'Fréquence des repas',
			mealsPerDay: '{count} repas par jour',
			mealTimes: 'Horaires des repas',
			energyBalance: 'Balance énergétique',
			calorieSurplus: 'Surplus calorique',
			calorieDeficit: 'Déficit calorique',
			energyBalanceCustomText: '{sign}{percent}% ({sign}{adjustment} kcal)',
		},
		buttons: {
			update: 'Mettre à jour',
			updateProgram: 'Mettre à jour le programme',
			volumeDetails: 'Voir et optimiser',
		},
	},
	system: {
		messages: {
			recompiling: 'Angular : recompilation...',
		},
	},
	workoutDetail: {
		volumeAutoregulation: {
			title: 'Autorégulation du volume',
			message: 'D\'après vos données, en particulier votre indice de fatigue{intensityInfo}, nous recommandons {direction} le volume de vos séries pour {exerciseName} d\'une série.',
			intensityHighRep: ' dans la séance à répétitions élevées',
			intensityMediumRep: ' dans la séance à répétitions moyennes',
			intensityLowRep: ' dans la séance à répétitions faibles',
			directionIncreasing: 'd\'augmenter',
			directionDecreasing: 'de réduire',
			buttons: {
				accept: 'Accepter',
				decline: 'Refuser',
				decideLater: 'Je déciderai plus tard',
			},
		},
	},
	cliAuth: {
		allowAccess: 'Autoriser l\'accès ?',
		description: 'MH Physique CLI (GitHub) demande l\'autorisation de :',
		permissions: {
			downloadData: 'Télécharger des instantanés de la base de données utilisateur',
			actOnBehalf: 'Effectuer des actions en votre nom',
		},
		confirmAccess: 'Autoriser l\'accès pour {email} ?',
		authorizing: 'Autorisation en cours...',
		approved: 'Accès accordé',
		approvedDetail: 'Vous pouvez fermer cette page et revenir au terminal.',
		denied: 'Accès refusé',
		deniedDetail: 'La demande a été refusée. Vous pouvez fermer cette page.',
		buttons: {
			deny: 'Refuser',
			allow: 'Autoriser',
		},
		errors: {
			noSession: 'Aucune session d\'autorisation trouvée. Veuillez relancer l\'outil CLI.',
			notSignedIn: 'Veuillez d\'abord vous connecter à l\'application, puis réessayer.',
		},
	},
	muscles: {
		bodyParts: {
			glutes: 'Grand fessier',
			glutemed: 'Moyen fessier',
			quads: 'Quadriceps',
			hams: 'Ischio-jambiers',
			calves: 'Mollets (gastrocnémiens et soléaire)',
			shoulders: 'Épaules (tous les faisceaux)',
			chest: 'Pectoraux',
			lats: 'Dorsaux',
			traps: 'Trapèzes',
			triceps: 'Triceps',
			biceps: 'Biceps',
			abs: 'Abdominaux',
		},
		volumeTable: {
			chest: 'Pectoraux',
			ldelt: 'Deltoïdes latéraux',
			rdelt: 'Deltoïdes postérieurs',
			utraps: 'Trapèzes supérieurs',
			lats: 'Dorsaux',
			biceps: 'Biceps',
			triceps: 'Triceps',
			erectors: 'Lombaires',
			quads: 'Quadriceps',
			hams: 'Ischio-jambiers',
			glutes: 'Fessiers',
			glutemed: 'Moyen fessier',
			gastrocnemius: 'Mollets (gastrocnémien)',
			soleus: 'Mollets (soléaire)',
			abs: 'Abdominaux',
		},
	},
	coach: {
		manageClientOffline: {
			title: 'Vous êtes hors ligne',
			message: 'La gestion d\'un client nécessite une connexion internet. Connectez-vous à internet et réessayez.',
		},
		formerCoachBadge: {
			label: 'Ancien coach',
			tooltip: 'Créé par votre ancien coach {coachName}. Vous pouvez continuer à l\'utiliser ou choisir une autre version.',
			editPageBody: 'Créé par votre ancien coach {coachName}.',
		},
		detachExerciseNotice: 'Votre programme utilise encore les exercices de votre ancien coach. Ouvrez le sélecteur pour revenir à votre propre version si vous le souhaitez.',
		title: 'Coaching',
		addClient: 'Ajouter un client',
		unnamedClient: 'Client sans nom',
		clientGoneMessage: 'Ce client ne figure plus dans votre liste.',
		slotsRemaining: '{remaining} places de client restantes',
		perSeatSlots: 'Ajoutez des clients à tout moment — facturé par place',
		checkout: {
			billingTitle: 'Comment fonctionne la facturation du coaching',
			billingInfo: 'Il s\'agit d\'un abonnement mensuel facturé par place de client. Vous commencez avec une place — la vôtre, qui inclut aussi votre adhésion Premium. Chaque client que vous coachez ajoute une place à votre facture mensuelle, et retirer un client retire sa place. Les changements de places sont calculés au prorata sur votre prochaine facture.',
		},
		emptyState: {
			title: 'Aucun client pour l\'instant',
		},
		editProgram: 'Modifier le programme',
		manageClient: 'Gérer le client',
		managingBannerLabel: 'Gestion',
		backToMyAccount: 'Retour à mon compte',
		status: {
			pending: 'En attente',
			claimed: 'Actif',
		},
		nicknamePrompt: {
			createTitle: 'Nouveau client',
			renameTitle: 'Renommer le client',
			message: 'Choisissez un surnom pour votre référence. Votre client ne verra pas ce nom.',
			placeholder: 'Surnom du client',
			create: 'Créer',
			rename: 'Renommer',
			cancel: 'Annuler',
		},
		rename: 'Renommer le client',
		removeClient: {
			button: 'Retirer le client',
			confirmTitle: 'Retirer le client',
			confirmMessage: 'Cela retirera définitivement cette place de client.',
			confirmMessageClaimed: 'Cela déconnectera le client de votre coaching. Il conservera son programme actuel.',
			confirm: 'Retirer',
			cancel: 'Annuler',
			removing: 'Retrait du client…',
		},
		intakeChoice: {
			title: 'Comment souhaitez-vous commencer ?',
			subtext: 'Vous pouvez remplir le questionnaire vous-même, ou envoyer un questionnaire vierge au client et le laisser y répondre lui-même.',
			fillMyself: 'Je remplirai le questionnaire',
			fillMyselfSubtext: 'Vous répondez à chaque étape et préparez le programme. Le client reçoit un lien pour récupérer le programme finalisé.',
			sendBlank: 'Envoyer un questionnaire vierge au client',
			sendBlankSubtext: 'Le client récupère le lien, répond lui-même au questionnaire, et vous examinez et finalisez le programme dans son compte.',
		},
		clientFills: {
			invitedTitle: 'En attente du client',
			invitedSubtext: 'L\'invitation a été envoyée. Le client remplira le questionnaire sur son propre compte. Vous recevrez une notification lorsqu\'il aura terminé.',
			fillMyself: 'Remplir le questionnaire moi-même',
			submittedTitle: 'Questionnaire prêt à être examiné',
			submittedSubtext: 'Votre client a terminé son questionnaire. Examinez ses réponses, définissez le volume d\'entraînement et la balance énergétique, puis générez le programme.',
			reviewIntake: 'Examiner le questionnaire',
		},
		awaiting: {
			headerTitle: 'Votre programme',
			title: 'Votre coach finalise votre programme',
			subtext: 'Nous vous préviendrons dès que votre programme sera prêt. Vous pouvez fermer l\'application et revenir plus tard.',
			subtextWithCoach: '{coachName} examine votre questionnaire et prépare votre plan d\'entraînement et de nutrition. Nous vous préviendrons dès qu\'il sera prêt. Vous pouvez fermer l\'application et revenir plus tard.',
		},
		invite: {
			title: 'Inviter un client',
			share: 'Partager',
			linkCopied: 'Lien copié',
			linkCopiedMessage: 'Le lien d\'invitation a été copié dans votre presse-papiers. Partagez-le avec votre client pour qu\'il puisse commencer.',
			ok: 'OK',
			description: 'Partagez ce lien avec votre client. Il pourra s\'inscrire et recevoir le programme que vous avez préparé.',
			creatingLink: 'Création du lien d\'invitation. Cela peut prendre quelques secondes.',
			linkFailed: 'Nous n\'avons pas pu créer le lien d\'invitation.',
		},
		claim: {
			title: 'Invitation du coach',
			description: '{coachName} a préparé un programme d\'entraînement et de nutrition pour vous. En acceptant, votre coach pourra consulter vos données d\'entraînement et ajuster votre programme.',
			descriptionBlankIntake: '{coachName} vous invite à vous entraîner ensemble. Répondez à quelques questions pour que votre coach puisse créer votre programme d\'entraînement et de nutrition. En acceptant, votre coach pourra consulter vos données d\'entraînement et ajuster votre programme.',
			accept: 'Accepter',
			overwriteWarning: 'Vous avez déjà un programme actif. En acceptant, votre programme actuel sera remplacé. Vos journaux, aliments, exercices et équipements seront conservés.',
			connected: 'Vous êtes maintenant connecté à {coachName}.',
			invalidToken: 'Ce lien d\'invitation est invalide ou a déjà été utilisé.',
			couldNotCheckToken: 'Nous n\'avons pas pu vérifier votre lien d\'invitation pour le moment. Votre lien est toujours valide, veuillez donc vérifier votre connexion et réessayer.',
			couldNotComplete: 'Nous n\'avons pas pu terminer la configuration de votre programme. Votre lien d\'invitation est toujours valide, veuillez donc l\'ouvrir à nouveau. Si cela ne fonctionne toujours pas, contactez votre coach.',
			connectedSetupUnfinished: 'Vous êtes maintenant connecté à votre coach, mais nous n\'avons pas pu terminer la copie de votre programme. Veuillez rouvrir l\'application et contacter votre coach si votre programme est toujours absent.',
			settingUp: 'Configuration de votre programme...',
			activationTimeout: 'L\'activation de votre accès coach prend plus de temps que prévu. Veuillez réessayer dans un instant, ou contactez le support si le problème persiste.',
		},
		settingsSection: {
			title: 'Coaching',
			coachName: 'Votre coach',
			leaveCoaching: 'Quitter le coaching',
		},
		selfDetach: {
			confirmTitle: 'Quitter le coaching',
			confirmMessage: 'Vous serez déconnecté de {coachName}. Vous conserverez vos données d\'entraînement, vos journaux alimentaires et vos exercices, mais vous perdrez l\'accès à votre abonnement. Cette action est irréversible.',
			confirmButton: 'Quitter',
			successToast: 'Vous avez été déconnecté de {coachName}.',
			deleteAccountButton: 'Quitter d\'abord le coaching',
		},
		deleteBlocked: {
			message: 'Vous êtes actuellement coaché par {coachName}. Veuillez demander à votre coach de vous retirer, ou contacter le support, avant de supprimer vos données.',
		},
		workoutViewOnly: 'Vous consultez cette séance en tant que coach. L\'exécution de la séance est gérée par le client.',
		weighInViewOnly: 'Vous consultez cette pesée en tant que coach. Les données de poids sont gérées par le client.',
		offlineOverlay: {
			title: 'Connexion perdue',
			message: 'En attente de reconnexion. Toutes les modifications seront synchronisées lorsque la connexion sera rétablie.',
		},
		presence: {
			online: 'En ligne',
			lastSeen: 'Vu il y a {time}',
			coachViewing: 'Votre coach consulte actuellement votre programme',
		},
		checkup: {
			submitToCoach: 'Envoyer au coach',
			submittedToast: 'Vous serez averti lorsque votre coach aura terminé l\'examen.',
			willBeSentForReview: 'Votre bilan sera envoyé à votre coach pour examen. Vous verrez les cibles mises à jour après que votre coach l\'aura examiné.',
			awaitingReview: 'En attente de l\'examen du coach',
			reviewTitle: 'Examiner le bilan',
			currentTarget: 'Objectif actuel',
			recommendedTarget: 'Objectif recommandé',
			accept: 'Accepter',
			modify: 'Modifier',
			decline: 'Refuser',
			customCalories: 'Objectif calorique personnalisé',
			reviewActionPrompt: 'Passez en revue le bilan hebdomadaire de votre client et décidez comment ajuster l\'objectif calorique.',
			kcalDelta: '{sign}{diff} kcal',
			tabDecision: 'Décision',
			tabBodyComposition: 'Composition corporelle',
			weightChange: 'Évolution du poids',
			kcalValue: '{value} kcal',
			bfPercent: '~{value} %',
			resolveError: 'Impossible de résoudre ce bilan. Veuillez réessayer.',
			decisionChoice: {
				accept: 'Accepter l\'objectif de l\'application',
				acceptHelp: 'Le plan de votre client passe à la recommandation de l\'application.',
				modify: 'Définir un autre objectif',
				modifyHelp: 'Choisissez vous-même le nombre, en kcal ou en variation en pourcentage.',
				decline: 'Garder l\'objectif actuel',
				declineHelp: 'Le plan de votre client reste tel quel cette semaine.',
			},
		},
		dashboard: {
			refresh: 'Actualiser',
			statusOnTrack: 'Dans les temps',
			statusOffTrack: 'Hors des temps',
			statusUndetermined: 'Indéterminé',
			statusUnknown: 'Inconnu',
			itemsNone: '—',
			pendingSectionTitle: 'Invitations en attente',
			actionItemsSectionTitle: 'Actions en attente',
			actionItemCheckupTitle: 'Bilan hebdomadaire',
			actionItemStrengthTestTitle: 'Test de force',
			actionItemSubtext: 'En attente de votre révision',
			actionItemTimeAgo: 'il y a {time}',
			handoverIncompleteBadge: 'Configuration incomplète',
			handoverIncompleteExplanation: 'Ce client a accepté votre invitation, mais son compte n\'a jamais fini de recevoir le programme que vous avez préparé. Ouvrez Gérer le client pour vérifier ce qu\'il a réellement, ou demandez-lui de rouvrir son lien d\'invitation.',
		},
		billing: {
			title: 'Facturation',
			headerAffordance: 'Ouvrir le tableau de bord de facturation',
			refresh: 'Actualiser',
			activeSlotsLine: '{count} places clients actives',
			runoutLine: 'À votre rythme actuel, vos crédits seront épuisés vers le {date}.',
			balance: {
				remaining: '{amount} mois-clients restants',
				dueWithBilling: '{amount} mois-clients dus',
				locked: 'Compte bloqué',
			},
			history: {
				sectionTitle: 'Relevés',
				consumed: '{amount} mois-clients consommés',
				settled: 'Réglé',
				unsettled: 'Non réglé — aucun moyen de paiement enregistré',
				empty: 'Aucun relevé pour l\'instant. Vous verrez une ligne ici le 3 de chaque mois.',
			},
			loadError: {
				title: 'Impossible de charger la facturation',
				subtext: 'Nous n\'avons pas pu charger votre tableau de bord de facturation. Vérifiez votre connexion et réessayez.',
				retry: 'Réessayer',
			},
			unmigrated: {
				title: 'Facturation bientôt disponible',
				subtext: 'Votre compte utilise l\'ancien système de crédit par places. Nous vous préviendrons lorsque le nouveau système de facturation sera activé pour vous.',
			},
			seat: {
				heading: 'Coaching de {count} {{client|clients}}',
				billedMonthly: 'Facturé mensuellement, au prorata à mesure que vous ajoutez ou retirez des clients.',
				nextPayment: 'Prochain paiement : {amount} le {date}',
				manageNote: 'Votre abonnement de coaching inclut votre propre plan plus une place par client. Pour arrêter le coaching, annulez votre abonnement de coaching.',
			},
			recordedHistory: {
				chartTitle: 'Clients au fil du temps',
				range6: '6 mois',
				range12: '12 mois',
				rangeAria: 'Période',
				active: 'Actifs',
				asleep: 'En pause',
				mostClientsNote: 'Le nombre maximal de clients que vous avez eus chaque mois.',
				capNote: 'Ligne pointillée : la limite de votre plan chaque mois (actuellement {cap} {{client|clients}}).',
				chartAria: 'Clients par mois, de {from} à {to} : {values}',
				chartAriaWithCap: 'Clients par mois, de {from} à {to} : {values} ; limite du plan {cap}',
				paymentsTitle: 'Paiements passés',
				invoice: 'Facture',
				testBadge: 'Test',
				paddleLine: '{amount} · {seats} {{place|places}} {{client|clients}}',
				amountOnly: '{amount}',
				storeLine: '{amount} · plan de {cap} clients · {store}',
				storeLineNoPlan: '{amount} · {store}',
				appStore: 'App Store',
				googlePlay: 'Google Play',
				receiptsApple: 'Vos reçus se trouvent dans votre historique d\'achats de l\'App Store.',
				receiptsGoogle: 'Vos reçus se trouvent dans votre historique d\'achats Google Play.',
				emptyHistory: 'Pas encore d\'historique. Les changements de vos clients sont enregistrés à partir de maintenant.',
				emptyPayments: 'Aucun paiement pour l\'instant.',
				loadError: 'Impossible de charger l\'historique de vos clients.',
				retry: 'Réessayer',
				invoiceUnavailable: 'La facture n\'est pas disponible pour le moment. Réessayez dans une minute.',
				invoiceBlocked: 'Votre navigateur a bloqué l\'onglet de la facture. Autorisez les fenêtres contextuelles pour ce site et appuyez à nouveau sur Facture.',
			},
		},
		tier: {
			becomeCoach: 'Devenir coach',
			noTiersAvailable: 'Les plans de coaching ne sont pas disponibles pour le moment. Veuillez réessayer plus tard.',
			tierOption: '{count} clients · {price}',
			purchaseFailed: 'Nous n\'avons pas pu finaliser votre achat. Veuillez réessayer.',
			purchaseNotYetConfirmed: 'Votre achat a bien été effectué, mais nous n\'avons pas pu terminer de le confirmer à l\'instant, donc votre plan de coaching n\'est peut-être pas encore actif. N\'achetez pas à nouveau. Il s\'activera peut-être tout seul à la prochaine ouverture de l\'app. S\'il n\'est toujours pas actif au bout de quelques jours, contactez le support.',
			crossProviderConflict: 'Vous avez déjà un abonnement actif sur un autre canal de paiement. Veuillez d\'abord l\'annuler, puis configurer le coaching ici.',
			purchaseSuccess: 'Tout est prêt — votre plan de coaching est maintenant actif.',
			alreadyOwned: 'Vous êtes déjà sur ce plan. Utilisez Changer de plan pour en choisir un autre.',
			tierName: '{count} clients',
			usageLine: '{used} sur {cap} places clients utilisées',
			changePlan: 'Changer de plan',
			changePlanSubtext: 'Augmentez ou réduisez le nombre de clients que vous pouvez coacher.',
			changeFailed: 'Nous n\'avons pas pu changer votre plan. Veuillez réessayer.',
			changeNotYetConfirmed: 'Votre changement de plan a bien été effectué sur la boutique, mais nous n\'avons pas pu terminer de le confirmer à l\'instant, donc votre nouveau plan n\'apparaît peut-être pas encore. Ne réessayez pas. Il s\'appliquera peut-être tout seul à la prochaine ouverture de l\'app. Si votre nouveau plan n\'apparaît toujours pas au bout de quelques jours, contactez le support.',
			changeScheduled: 'Votre changement de plan est programmé et prendra effet à la fin de votre période de facturation en cours.',
			changeSuccess: 'Votre plan a été mis à jour.',
			pauseWarning: {
				title: 'Certains clients seront mis en pause',
				message: 'Cette formule couvre {cap} {{client|clients}}, et vous en avez plus que cela actuellement. Si vous continuez, {count} {{client sera mis|clients seront mis}} en pause : {names}. Un client en pause conserve son compte, son programme et son historique, mais perd l\'accès Premium que vous lui offrez, et vous ne pourrez plus l\'ouvrir. Vous pourrez le réveiller plus tard, tant que votre formule le permet.',
				confirm: 'Continuer',
			},
			pausedNowSuffix: '{count} {{client a été mis|clients ont été mis}} en pause : {names}. Vous pourrez les réveiller depuis votre liste de clients dès que votre formule aura de la place.',
			pauseScheduledNotice: {
				title: 'Des clients seront mis en pause au renouvellement',
				body: 'Votre formule passe à {cap} {{client|clients}} le {date}. À ce moment-là, {count} {{client sera mis|clients seront mis}} en pause : {names}. Rien ne change d\'ici là.',
				bodyNoDate: 'Votre formule passera à {cap} {{client|clients}} lors de votre prochain renouvellement. À ce moment-là, {count} {{client sera mis|clients seront mis}} en pause : {names}. Rien ne change d\'ici là.',
			},
			crossChannel: {
				appBlock: 'Votre abonnement est géré sur le web. Vous pouvez devenir coach depuis notre site web.',
				webBlock: 'Votre abonnement est sur le {store}. Pour devenir coach, vous pouvez acheter un plan de coaching dans l\'application — ou, pour un prix inférieur, annuler votre abonnement du store et passer à la facturation web.',
				webBlockPayPro: 'Votre abonnement est encore facturé par notre ancien prestataire de paiement, le coaching ne peut donc pas encore y être configuré. Votre abonnement doit d\'abord être transféré vers notre prestataire actuel — contactez-nous et nous nous en occupons pour vous, sans aucune interruption de votre abonnement.',
			},
		},
		branding: {
			title: 'Image de marque',
			headerAffordance: 'Personnaliser votre image de marque',
			logoLabel: 'Logo',
			logoHelp: 'Téléversez votre logo. Il apparaît dans l\'application de vos clients.',
			brandNameLabel: 'Nom de la marque',
			brandNamePlaceholder: 'Le nom de votre entreprise',
			accentLabel: 'Couleur d\'accent',
			accentHelp: 'Choisissez un préréglage ou saisissez votre propre couleur hexadécimale. Nous en créons automatiquement une gamme de teintes lisibles.',
			contrastWarning: 'Le texte peut être difficile à lire sur cette couleur. Nous le gardons lisible automatiquement, mais une couleur plus soutenue se lit mieux.',
			previewLabel: 'Aperçu',
			previewButton: 'Exemple de bouton',
			previewLink: 'Exemple de lien',
			save: 'Enregistrer l\'image de marque',
			saveConfirmTitle: 'Appliquer l\'image de marque ?',
			saveConfirmMessage: 'Cette image de marque sera appliquée à tous vos clients la prochaine fois qu\'ils ouvriront l\'application.',
			saveSuccess: 'Image de marque enregistrée.',
			savePartial: 'Image de marque enregistrée, mais {count} client(s) n\'ont pas pu être mis à jour. Réessayez d\'enregistrer pour les relancer.',
			saveError: 'Impossible d\'enregistrer l\'image de marque. Vérifiez votre connexion et réessayez.',
			reset: 'Réinitialiser par défaut',
			resetConfirmTitle: 'Supprimer l\'image de marque ?',
			resetConfirmMessage: 'Cela supprime votre image de marque pour tous vos clients. Leur application revient à l\'apparence MH Physique par défaut la prochaine fois qu\'ils l\'ouvriront.',
			resetSuccess: 'Image de marque réinitialisée par défaut.',
			resetPartial: 'Image de marque réinitialisée, mais {count} client(s) n\'ont pas pu être mis à jour. Réessayez de réinitialiser pour les relancer.',
			resetError: 'Impossible de réinitialiser l\'image de marque. Vérifiez votre connexion et réessayez.',
			poweredByMh: 'Propulsé par MH Physique',
		},
		sleepClient: {
			button: 'Mettre le client en pause',
			confirmTitle: 'Mettre ce client en pause ?',
			confirmMessage: 'Il garde son compte, son programme et son historique, et vous pouvez le réactiver à tout moment. Pendant la pause, il revient à la version gratuite, vous ne pouvez plus ouvrir son compte, et il n\'occupe plus de place sur votre formule.',
			confirm: 'Mettre en pause',
			cancel: 'Annuler',
			working: 'Mise en pause du client…',
		},
		wakeClient: {
			button: 'Réactiver le client',
			confirmTitle: 'Réactiver ce client ?',
			confirmMessage: 'Il retrouve immédiatement l\'accès complet et vous pouvez de nouveau ouvrir son compte. Il occupera à nouveau une place sur votre formule.',
			confirm: 'Réactiver',
			cancel: 'Annuler',
			working: 'Réactivation du client…',
		},
		clientAsleep: {
			badge: 'En pause',
			badgeSince: 'En pause depuis {days} {{jour|jours}}',
			badgeSinceToday: 'En pause depuis aujourd\'hui',
			refusedTitle: 'Ce client est en pause',
			refusedMessage: 'Vous ne pouvez pas ouvrir le compte d\'un client en pause. Réactivez ce client pour continuer.',
			becausePlanFull: 'Mis en pause car votre formule est complète',
			becausePlanFullSince: 'Mis en pause depuis {days} {{jour|jours}} car votre formule est complète',
			becausePlanFullToday: 'Mis en pause aujourd\'hui car votre formule est complète',
		},
	},
	pageTitles: {
		login: 'Connexion',
		fatalError: 'Erreur fatale',
		subscribe: 'S\'abonner',
		unsubscribe: 'Se désabonner',
		changelog: 'Nouveautés',
		home: 'Accueil',
		editMeal: 'Repas',
		workoutDetail: 'Séance',
		equipmentEdit: 'Modifier l\'équipement',
		editWeighIn: 'Pesée',
		training: 'Entraînement',
		editWorkouts: 'Modifier les séances',
		nutrition: 'Nutrition',
		programSettings: 'Réglages du programme',
		advancedTrainingMethods: 'Méthodes d\'entraînement avancées',
		nutritionOptions: 'Options de nutrition',
		scheduleTips: 'Conseils de planning',
		equipmentSearch: 'Équipement',
		foods: 'Aliments',
		barcodeScanner: 'Scanner un code-barres',
		labelScanner: 'Scanner une étiquette',
		mealPhotoScanner: 'Scanner un repas',
		equipmentScanner: 'Scanner un équipement',
		workoutPlanScanner: 'Scanner une séance',
		recipeScanner: 'Scanner une recette',
		mealPlan: 'Plan de repas',
		editFood: 'Aliment',
		editNutritionPlan: 'Modifier l\'objectif nutritionnel quotidien',
		editIngredient: 'Modifier l\'ingrédient',
		exerciseSwitch: 'Changement d\'exercice',
		editExercise: 'Modifier l\'exercice',
		viewExercise: 'Exercice',
		exerciseConfiguration: 'Configuration de l\'exercice',
		exerciseDiff: 'Mise à jour disponible',
		muscleVolume: 'Volume musculaire',
		editTrainingGoal: 'Modifier l\'objectif d\'entraînement',
		updatePlanOptions: 'Mettre à jour ton programme',
		weeklyCheckup: 'Bilan hebdomadaire',
		exerciseStats: 'Stats de l\'exercice',
		progress: 'Progression',
		userProfile: 'Profil utilisateur',
		settings: 'Réglages',
		appSettings: 'Réglages de l\'application',
		notificationSettings: 'Réglages des notifications',
		customizeHomepage: 'Personnaliser l\'accueil',
		redeemCode: 'Utiliser un code',
		referralInvite: 'Invitation',
		promo: 'Soldes',
		referralHub: 'Inviter un ami',
		intakeForm: 'Questionnaire',
		introCarousel: 'Carrousel d\'introduction',
		awaitingCoach: 'En attente du coach',
		helpCard: 'Aide',
		mealSuggestions: 'Suggestions de repas',
		note: 'Note',
		purchaseSuccess: 'Abonnement actif',
		nutritionInfo: 'Infos nutritionnelles',
		taskCalendar: 'Calendrier des tâches',
		inputCalendar: 'Calendrier',
		changeWorkout: 'Changer de séance',
		trainingOverview: 'Aperçu de l\'entraînement',
		sendFeedback: 'Envoyer un commentaire',
		sendCoachMessage: 'Message au coach',
		help: 'Aide et FAQ',
		cliAuth: 'Autorisation CLI',
		coachSettings: 'Coaching',
		coachClientDetail: 'Détail du client',
		coachBilling: 'Facturation coach',
		coachCheckout: 'Devenir coach',
		coachBranding: 'Image de marque',
		coachClaim: 'Rattachement au coach',
	},
	coachingTips: {
		scheduleItems: {
			training: 'Entraînement',
			wakeUp: 'Réveil',
			goToSleep: 'Coucher',
			weeklyCheckup: 'Bilan hebdomadaire',
		},
	},
} satisfies Translation;

export default fr;
